var cov_1w0wl6gh7m = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/vars-inject.ts",
      hash = "60936d2bd037e7049d92087b411c0699ef69a70c",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/vars-inject.ts",
    statementMap: {
      "0": {
        start: {
          line: 38,
          column: 28
        },
        end: {
          line: 41,
          column: 1
        }
      },
      "1": {
        start: {
          line: 42,
          column: 34
        },
        end: {
          line: 42,
          column: 36
        }
      },
      "2": {
        start: {
          line: 43,
          column: 27
        },
        end: {
          line: 43,
          column: 29
        }
      },
      "3": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 51,
          column: 4
        }
      },
      "4": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 50,
          column: 5
        }
      },
      "5": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 26
        }
      },
      "6": {
        start: {
          line: 54,
          column: 2
        },
        end: {
          line: 54,
          column: 21
        }
      },
      "7": {
        start: {
          line: 57,
          column: 19
        },
        end: {
          line: 57,
          column: 25
        }
      },
      "8": {
        start: {
          line: 58,
          column: 2
        },
        end: {
          line: 58,
          column: 35
        }
      },
      "9": {
        start: {
          line: 58,
          column: 15
        },
        end: {
          line: 58,
          column: 35
        }
      },
      "10": {
        start: {
          line: 59,
          column: 2
        },
        end: {
          line: 63,
          column: 3
        }
      },
      "11": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 21
        }
      },
      "12": {
        start: {
          line: 61,
          column: 9
        },
        end: {
          line: 63,
          column: 3
        }
      },
      "13": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 58
        }
      },
      "14": {
        start: {
          line: 64,
          column: 2
        },
        end: {
          line: 64,
          column: 50
        }
      },
      "15": {
        start: {
          line: 64,
          column: 37
        },
        end: {
          line: 64,
          column: 50
        }
      },
      "16": {
        start: {
          line: 65,
          column: 2
        },
        end: {
          line: 65,
          column: 72
        }
      },
      "17": {
        start: {
          line: 66,
          column: 2
        },
        end: {
          line: 66,
          column: 22
        }
      },
      "18": {
        start: {
          line: 70,
          column: 2
        },
        end: {
          line: 70,
          column: 15
        }
      },
      "19": {
        start: {
          line: 74,
          column: 2
        },
        end: {
          line: 76,
          column: 3
        }
      },
      "20": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 86
        }
      },
      "21": {
        start: {
          line: 77,
          column: 19
        },
        end: {
          line: 77,
          column: 42
        }
      },
      "22": {
        start: {
          line: 78,
          column: 13
        },
        end: {
          line: 78,
          column: 63
        }
      },
      "23": {
        start: {
          line: 79,
          column: 22
        },
        end: {
          line: 79,
          column: 48
        }
      },
      "24": {
        start: {
          line: 80,
          column: 20
        },
        end: {
          line: 82,
          column: 17
        }
      },
      "25": {
        start: {
          line: 81,
          column: 16
        },
        end: {
          line: 81,
          column: 40
        }
      },
      "26": {
        start: {
          line: 83,
          column: 13
        },
        end: {
          line: 83,
          column: 40
        }
      },
      "27": {
        start: {
          line: 84,
          column: 2
        },
        end: {
          line: 92,
          column: 3
        }
      },
      "28": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 28
        }
      },
      "29": {
        start: {
          line: 87,
          column: 19
        },
        end: {
          line: 87,
          column: 50
        }
      },
      "30": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 43
        }
      },
      "31": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 33
        }
      },
      "32": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 32
        }
      },
      "33": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 37
        }
      },
      "34": {
        start: {
          line: 93,
          column: 2
        },
        end: {
          line: 93,
          column: 11
        }
      },
      "35": {
        start: {
          line: 97,
          column: 2
        },
        end: {
          line: 97,
          column: 62
        }
      },
      "36": {
        start: {
          line: 97,
          column: 36
        },
        end: {
          line: 97,
          column: 62
        }
      },
      "37": {
        start: {
          line: 98,
          column: 2
        },
        end: {
          line: 100,
          column: 11
        }
      },
      "38": {
        start: {
          line: 101,
          column: 2
        },
        end: {
          line: 101,
          column: 28
        }
      },
      "39": {
        start: {
          line: 105,
          column: 2
        },
        end: {
          line: 121,
          column: 3
        }
      },
      "40": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 113,
          column: 5
        }
      },
      "41": {
        start: {
          line: 107,
          column: 21
        },
        end: {
          line: 107,
          column: 37
        }
      },
      "42": {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 112,
          column: 7
        }
      },
      "43": {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 109,
          column: 43
        }
      },
      "44": {
        start: {
          line: 111,
          column: 8
        },
        end: {
          line: 111,
          column: 50
        }
      },
      "45": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 120,
          column: 5
        }
      },
      "46": {
        start: {
          line: 115,
          column: 6
        },
        end: {
          line: 119,
          column: 7
        }
      },
      "47": {
        start: {
          line: 116,
          column: 8
        },
        end: {
          line: 116,
          column: 31
        }
      },
      "48": {
        start: {
          line: 118,
          column: 8
        },
        end: {
          line: 118,
          column: 35
        }
      },
      "49": {
        start: {
          line: 123,
          column: 16
        },
        end: {
          line: 5161,
          column: 1
        }
      },
      "50": {
        start: {
          line: 233,
          column: 6
        },
        end: {
          line: 249,
          column: 7
        }
      },
      "51": {
        start: {
          line: 252,
          column: 6
        },
        end: {
          line: 263,
          column: 7
        }
      },
      "52": {
        start: {
          line: 266,
          column: 6
        },
        end: {
          line: 277,
          column: 7
        }
      },
      "53": {
        start: {
          line: 280,
          column: 6
        },
        end: {
          line: 292,
          column: 7
        }
      },
      "54": {
        start: {
          line: 295,
          column: 6
        },
        end: {
          line: 306,
          column: 7
        }
      },
      "55": {
        start: {
          line: 309,
          column: 6
        },
        end: {
          line: 318,
          column: 7
        }
      },
      "56": {
        start: {
          line: 321,
          column: 6
        },
        end: {
          line: 326,
          column: 7
        }
      },
      "57": {
        start: {
          line: 329,
          column: 6
        },
        end: {
          line: 335,
          column: 7
        }
      },
      "58": {
        start: {
          line: 338,
          column: 6
        },
        end: {
          line: 346,
          column: 7
        }
      },
      "59": {
        start: {
          line: 349,
          column: 6
        },
        end: {
          line: 355,
          column: 7
        }
      },
      "60": {
        start: {
          line: 358,
          column: 6
        },
        end: {
          line: 363,
          column: 7
        }
      },
      "61": {
        start: {
          line: 366,
          column: 6
        },
        end: {
          line: 372,
          column: 7
        }
      },
      "62": {
        start: {
          line: 375,
          column: 6
        },
        end: {
          line: 380,
          column: 7
        }
      },
      "63": {
        start: {
          line: 383,
          column: 6
        },
        end: {
          line: 389,
          column: 7
        }
      },
      "64": {
        start: {
          line: 392,
          column: 6
        },
        end: {
          line: 398,
          column: 7
        }
      },
      "65": {
        start: {
          line: 564,
          column: 6
        },
        end: {
          line: 569,
          column: 7
        }
      },
      "66": {
        start: {
          line: 572,
          column: 6
        },
        end: {
          line: 577,
          column: 7
        }
      },
      "67": {
        start: {
          line: 580,
          column: 6
        },
        end: {
          line: 585,
          column: 7
        }
      },
      "68": {
        start: {
          line: 588,
          column: 6
        },
        end: {
          line: 593,
          column: 7
        }
      },
      "69": {
        start: {
          line: 596,
          column: 6
        },
        end: {
          line: 601,
          column: 7
        }
      },
      "70": {
        start: {
          line: 604,
          column: 6
        },
        end: {
          line: 609,
          column: 7
        }
      },
      "71": {
        start: {
          line: 612,
          column: 6
        },
        end: {
          line: 617,
          column: 7
        }
      },
      "72": {
        start: {
          line: 620,
          column: 6
        },
        end: {
          line: 625,
          column: 7
        }
      },
      "73": {
        start: {
          line: 628,
          column: 6
        },
        end: {
          line: 634,
          column: 7
        }
      },
      "74": {
        start: {
          line: 637,
          column: 6
        },
        end: {
          line: 642,
          column: 7
        }
      },
      "75": {
        start: {
          line: 645,
          column: 6
        },
        end: {
          line: 650,
          column: 7
        }
      },
      "76": {
        start: {
          line: 653,
          column: 6
        },
        end: {
          line: 658,
          column: 7
        }
      },
      "77": {
        start: {
          line: 661,
          column: 6
        },
        end: {
          line: 666,
          column: 7
        }
      },
      "78": {
        start: {
          line: 669,
          column: 6
        },
        end: {
          line: 674,
          column: 7
        }
      },
      "79": {
        start: {
          line: 677,
          column: 6
        },
        end: {
          line: 682,
          column: 7
        }
      },
      "80": {
        start: {
          line: 685,
          column: 6
        },
        end: {
          line: 690,
          column: 7
        }
      },
      "81": {
        start: {
          line: 693,
          column: 6
        },
        end: {
          line: 698,
          column: 7
        }
      },
      "82": {
        start: {
          line: 701,
          column: 6
        },
        end: {
          line: 706,
          column: 7
        }
      },
      "83": {
        start: {
          line: 709,
          column: 6
        },
        end: {
          line: 714,
          column: 7
        }
      },
      "84": {
        start: {
          line: 717,
          column: 6
        },
        end: {
          line: 724,
          column: 7
        }
      },
      "85": {
        start: {
          line: 765,
          column: 6
        },
        end: {
          line: 770,
          column: 7
        }
      },
      "86": {
        start: {
          line: 773,
          column: 6
        },
        end: {
          line: 778,
          column: 7
        }
      },
      "87": {
        start: {
          line: 781,
          column: 6
        },
        end: {
          line: 786,
          column: 7
        }
      },
      "88": {
        start: {
          line: 789,
          column: 6
        },
        end: {
          line: 794,
          column: 7
        }
      },
      "89": {
        start: {
          line: 876,
          column: 6
        },
        end: {
          line: 881,
          column: 7
        }
      },
      "90": {
        start: {
          line: 884,
          column: 6
        },
        end: {
          line: 889,
          column: 7
        }
      },
      "91": {
        start: {
          line: 892,
          column: 6
        },
        end: {
          line: 897,
          column: 7
        }
      },
      "92": {
        start: {
          line: 900,
          column: 6
        },
        end: {
          line: 905,
          column: 7
        }
      },
      "93": {
        start: {
          line: 908,
          column: 6
        },
        end: {
          line: 913,
          column: 7
        }
      },
      "94": {
        start: {
          line: 916,
          column: 6
        },
        end: {
          line: 921,
          column: 7
        }
      },
      "95": {
        start: {
          line: 924,
          column: 6
        },
        end: {
          line: 929,
          column: 7
        }
      },
      "96": {
        start: {
          line: 932,
          column: 6
        },
        end: {
          line: 937,
          column: 7
        }
      },
      "97": {
        start: {
          line: 940,
          column: 6
        },
        end: {
          line: 945,
          column: 7
        }
      },
      "98": {
        start: {
          line: 1018,
          column: 6
        },
        end: {
          line: 1023,
          column: 7
        }
      },
      "99": {
        start: {
          line: 1026,
          column: 6
        },
        end: {
          line: 1031,
          column: 7
        }
      },
      "100": {
        start: {
          line: 1034,
          column: 6
        },
        end: {
          line: 1039,
          column: 7
        }
      },
      "101": {
        start: {
          line: 1042,
          column: 6
        },
        end: {
          line: 1047,
          column: 7
        }
      },
      "102": {
        start: {
          line: 1050,
          column: 6
        },
        end: {
          line: 1055,
          column: 7
        }
      },
      "103": {
        start: {
          line: 1058,
          column: 6
        },
        end: {
          line: 1063,
          column: 7
        }
      },
      "104": {
        start: {
          line: 1066,
          column: 6
        },
        end: {
          line: 1071,
          column: 7
        }
      },
      "105": {
        start: {
          line: 1074,
          column: 6
        },
        end: {
          line: 1079,
          column: 7
        }
      },
      "106": {
        start: {
          line: 1137,
          column: 6
        },
        end: {
          line: 1142,
          column: 7
        }
      },
      "107": {
        start: {
          line: 1145,
          column: 6
        },
        end: {
          line: 1150,
          column: 7
        }
      },
      "108": {
        start: {
          line: 1153,
          column: 6
        },
        end: {
          line: 1158,
          column: 7
        }
      },
      "109": {
        start: {
          line: 1161,
          column: 6
        },
        end: {
          line: 1166,
          column: 7
        }
      },
      "110": {
        start: {
          line: 1169,
          column: 6
        },
        end: {
          line: 1174,
          column: 7
        }
      },
      "111": {
        start: {
          line: 1221,
          column: 31
        },
        end: {
          line: 1221,
          column: 64
        }
      },
      "112": {
        start: {
          line: 1283,
          column: 6
        },
        end: {
          line: 1288,
          column: 7
        }
      },
      "113": {
        start: {
          line: 1291,
          column: 6
        },
        end: {
          line: 1296,
          column: 7
        }
      },
      "114": {
        start: {
          line: 1299,
          column: 6
        },
        end: {
          line: 1304,
          column: 7
        }
      },
      "115": {
        start: {
          line: 1307,
          column: 6
        },
        end: {
          line: 1312,
          column: 7
        }
      },
      "116": {
        start: {
          line: 1315,
          column: 6
        },
        end: {
          line: 1320,
          column: 7
        }
      },
      "117": {
        start: {
          line: 1323,
          column: 6
        },
        end: {
          line: 1328,
          column: 7
        }
      },
      "118": {
        start: {
          line: 1331,
          column: 6
        },
        end: {
          line: 1336,
          column: 7
        }
      },
      "119": {
        start: {
          line: 1339,
          column: 6
        },
        end: {
          line: 1345,
          column: 7
        }
      },
      "120": {
        start: {
          line: 1348,
          column: 6
        },
        end: {
          line: 1353,
          column: 7
        }
      },
      "121": {
        start: {
          line: 1356,
          column: 6
        },
        end: {
          line: 1361,
          column: 7
        }
      },
      "122": {
        start: {
          line: 1364,
          column: 6
        },
        end: {
          line: 1369,
          column: 7
        }
      },
      "123": {
        start: {
          line: 1372,
          column: 6
        },
        end: {
          line: 1377,
          column: 7
        }
      },
      "124": {
        start: {
          line: 1380,
          column: 6
        },
        end: {
          line: 1385,
          column: 7
        }
      },
      "125": {
        start: {
          line: 1539,
          column: 6
        },
        end: {
          line: 1544,
          column: 7
        }
      },
      "126": {
        start: {
          line: 1547,
          column: 6
        },
        end: {
          line: 1553,
          column: 7
        }
      },
      "127": {
        start: {
          line: 1556,
          column: 6
        },
        end: {
          line: 1561,
          column: 7
        }
      },
      "128": {
        start: {
          line: 1564,
          column: 6
        },
        end: {
          line: 1569,
          column: 7
        }
      },
      "129": {
        start: {
          line: 1572,
          column: 6
        },
        end: {
          line: 1577,
          column: 7
        }
      },
      "130": {
        start: {
          line: 1580,
          column: 6
        },
        end: {
          line: 1585,
          column: 7
        }
      },
      "131": {
        start: {
          line: 1588,
          column: 6
        },
        end: {
          line: 1593,
          column: 7
        }
      },
      "132": {
        start: {
          line: 1596,
          column: 6
        },
        end: {
          line: 1601,
          column: 7
        }
      },
      "133": {
        start: {
          line: 1604,
          column: 6
        },
        end: {
          line: 1609,
          column: 7
        }
      },
      "134": {
        start: {
          line: 1612,
          column: 6
        },
        end: {
          line: 1617,
          column: 7
        }
      },
      "135": {
        start: {
          line: 1620,
          column: 6
        },
        end: {
          line: 1625,
          column: 7
        }
      },
      "136": {
        start: {
          line: 1628,
          column: 6
        },
        end: {
          line: 1633,
          column: 7
        }
      },
      "137": {
        start: {
          line: 1636,
          column: 6
        },
        end: {
          line: 1641,
          column: 7
        }
      },
      "138": {
        start: {
          line: 1645,
          column: 6
        },
        end: {
          line: 1650,
          column: 7
        }
      },
      "139": {
        start: {
          line: 1654,
          column: 6
        },
        end: {
          line: 1659,
          column: 7
        }
      },
      "140": {
        start: {
          line: 1663,
          column: 6
        },
        end: {
          line: 1668,
          column: 7
        }
      },
      "141": {
        start: {
          line: 1671,
          column: 6
        },
        end: {
          line: 1676,
          column: 7
        }
      },
      "142": {
        start: {
          line: 1679,
          column: 6
        },
        end: {
          line: 1684,
          column: 7
        }
      },
      "143": {
        start: {
          line: 1687,
          column: 6
        },
        end: {
          line: 1692,
          column: 7
        }
      },
      "144": {
        start: {
          line: 1695,
          column: 6
        },
        end: {
          line: 1700,
          column: 7
        }
      },
      "145": {
        start: {
          line: 1727,
          column: 6
        },
        end: {
          line: 1732,
          column: 7
        }
      },
      "146": {
        start: {
          line: 1735,
          column: 6
        },
        end: {
          line: 1740,
          column: 7
        }
      },
      "147": {
        start: {
          line: 1828,
          column: 6
        },
        end: {
          line: 1833,
          column: 7
        }
      },
      "148": {
        start: {
          line: 1836,
          column: 6
        },
        end: {
          line: 1842,
          column: 7
        }
      },
      "149": {
        start: {
          line: 1845,
          column: 6
        },
        end: {
          line: 1850,
          column: 7
        }
      },
      "150": {
        start: {
          line: 1853,
          column: 6
        },
        end: {
          line: 1858,
          column: 7
        }
      },
      "151": {
        start: {
          line: 1861,
          column: 6
        },
        end: {
          line: 1866,
          column: 7
        }
      },
      "152": {
        start: {
          line: 1869,
          column: 6
        },
        end: {
          line: 1874,
          column: 7
        }
      },
      "153": {
        start: {
          line: 1877,
          column: 6
        },
        end: {
          line: 1882,
          column: 7
        }
      },
      "154": {
        start: {
          line: 1885,
          column: 6
        },
        end: {
          line: 1890,
          column: 7
        }
      },
      "155": {
        start: {
          line: 1893,
          column: 6
        },
        end: {
          line: 1898,
          column: 7
        }
      },
      "156": {
        start: {
          line: 1901,
          column: 6
        },
        end: {
          line: 1906,
          column: 7
        }
      },
      "157": {
        start: {
          line: 2093,
          column: 19
        },
        end: {
          line: 2093,
          column: 62
        }
      },
      "158": {
        start: {
          line: 2094,
          column: 6
        },
        end: {
          line: 2094,
          column: 36
        }
      },
      "159": {
        start: {
          line: 2095,
          column: 6
        },
        end: {
          line: 2100,
          column: 7
        }
      },
      "160": {
        start: {
          line: 2103,
          column: 6
        },
        end: {
          line: 2108,
          column: 7
        }
      },
      "161": {
        start: {
          line: 2111,
          column: 6
        },
        end: {
          line: 2116,
          column: 7
        }
      },
      "162": {
        start: {
          line: 2119,
          column: 6
        },
        end: {
          line: 2124,
          column: 7
        }
      },
      "163": {
        start: {
          line: 2127,
          column: 6
        },
        end: {
          line: 2132,
          column: 7
        }
      },
      "164": {
        start: {
          line: 2135,
          column: 6
        },
        end: {
          line: 2140,
          column: 7
        }
      },
      "165": {
        start: {
          line: 2143,
          column: 6
        },
        end: {
          line: 2148,
          column: 7
        }
      },
      "166": {
        start: {
          line: 2151,
          column: 6
        },
        end: {
          line: 2156,
          column: 7
        }
      },
      "167": {
        start: {
          line: 2159,
          column: 6
        },
        end: {
          line: 2164,
          column: 7
        }
      },
      "168": {
        start: {
          line: 2167,
          column: 6
        },
        end: {
          line: 2172,
          column: 7
        }
      },
      "169": {
        start: {
          line: 2175,
          column: 6
        },
        end: {
          line: 2180,
          column: 7
        }
      },
      "170": {
        start: {
          line: 2183,
          column: 6
        },
        end: {
          line: 2188,
          column: 7
        }
      },
      "171": {
        start: {
          line: 2191,
          column: 6
        },
        end: {
          line: 2196,
          column: 7
        }
      },
      "172": {
        start: {
          line: 2199,
          column: 6
        },
        end: {
          line: 2204,
          column: 7
        }
      },
      "173": {
        start: {
          line: 2207,
          column: 6
        },
        end: {
          line: 2212,
          column: 7
        }
      },
      "174": {
        start: {
          line: 2215,
          column: 6
        },
        end: {
          line: 2220,
          column: 7
        }
      },
      "175": {
        start: {
          line: 2223,
          column: 6
        },
        end: {
          line: 2228,
          column: 7
        }
      },
      "176": {
        start: {
          line: 2231,
          column: 6
        },
        end: {
          line: 2236,
          column: 7
        }
      },
      "177": {
        start: {
          line: 2239,
          column: 6
        },
        end: {
          line: 2244,
          column: 7
        }
      },
      "178": {
        start: {
          line: 2247,
          column: 6
        },
        end: {
          line: 2252,
          column: 7
        }
      },
      "179": {
        start: {
          line: 2255,
          column: 6
        },
        end: {
          line: 2260,
          column: 7
        }
      },
      "180": {
        start: {
          line: 2263,
          column: 6
        },
        end: {
          line: 2268,
          column: 7
        }
      },
      "181": {
        start: {
          line: 2271,
          column: 6
        },
        end: {
          line: 2276,
          column: 7
        }
      },
      "182": {
        start: {
          line: 2357,
          column: 6
        },
        end: {
          line: 2362,
          column: 7
        }
      },
      "183": {
        start: {
          line: 2365,
          column: 6
        },
        end: {
          line: 2370,
          column: 7
        }
      },
      "184": {
        start: {
          line: 2373,
          column: 6
        },
        end: {
          line: 2378,
          column: 7
        }
      },
      "185": {
        start: {
          line: 2381,
          column: 6
        },
        end: {
          line: 2386,
          column: 7
        }
      },
      "186": {
        start: {
          line: 2389,
          column: 6
        },
        end: {
          line: 2394,
          column: 7
        }
      },
      "187": {
        start: {
          line: 2397,
          column: 6
        },
        end: {
          line: 2402,
          column: 7
        }
      },
      "188": {
        start: {
          line: 2405,
          column: 6
        },
        end: {
          line: 2410,
          column: 7
        }
      },
      "189": {
        start: {
          line: 2413,
          column: 6
        },
        end: {
          line: 2418,
          column: 7
        }
      },
      "190": {
        start: {
          line: 2421,
          column: 6
        },
        end: {
          line: 2426,
          column: 7
        }
      },
      "191": {
        start: {
          line: 2563,
          column: 6
        },
        end: {
          line: 2568,
          column: 7
        }
      },
      "192": {
        start: {
          line: 2571,
          column: 6
        },
        end: {
          line: 2571,
          column: 51
        }
      },
      "193": {
        start: {
          line: 2574,
          column: 6
        },
        end: {
          line: 2574,
          column: 48
        }
      },
      "194": {
        start: {
          line: 2577,
          column: 6
        },
        end: {
          line: 2577,
          column: 51
        }
      },
      "195": {
        start: {
          line: 2580,
          column: 6
        },
        end: {
          line: 2580,
          column: 50
        }
      },
      "196": {
        start: {
          line: 2583,
          column: 6
        },
        end: {
          line: 2588,
          column: 7
        }
      },
      "197": {
        start: {
          line: 2591,
          column: 6
        },
        end: {
          line: 2591,
          column: 54
        }
      },
      "198": {
        start: {
          line: 2594,
          column: 6
        },
        end: {
          line: 2594,
          column: 51
        }
      },
      "199": {
        start: {
          line: 2597,
          column: 6
        },
        end: {
          line: 2597,
          column: 54
        }
      },
      "200": {
        start: {
          line: 2600,
          column: 6
        },
        end: {
          line: 2600,
          column: 53
        }
      },
      "201": {
        start: {
          line: 2603,
          column: 6
        },
        end: {
          line: 2608,
          column: 7
        }
      },
      "202": {
        start: {
          line: 2611,
          column: 6
        },
        end: {
          line: 2616,
          column: 7
        }
      },
      "203": {
        start: {
          line: 2619,
          column: 6
        },
        end: {
          line: 2624,
          column: 7
        }
      },
      "204": {
        start: {
          line: 2627,
          column: 6
        },
        end: {
          line: 2632,
          column: 7
        }
      },
      "205": {
        start: {
          line: 2635,
          column: 6
        },
        end: {
          line: 2640,
          column: 7
        }
      },
      "206": {
        start: {
          line: 2643,
          column: 6
        },
        end: {
          line: 2648,
          column: 7
        }
      },
      "207": {
        start: {
          line: 2651,
          column: 6
        },
        end: {
          line: 2656,
          column: 7
        }
      },
      "208": {
        start: {
          line: 2691,
          column: 6
        },
        end: {
          line: 2696,
          column: 7
        }
      },
      "209": {
        start: {
          line: 2699,
          column: 6
        },
        end: {
          line: 2704,
          column: 7
        }
      },
      "210": {
        start: {
          line: 2707,
          column: 6
        },
        end: {
          line: 2712,
          column: 7
        }
      },
      "211": {
        start: {
          line: 2899,
          column: 6
        },
        end: {
          line: 2904,
          column: 7
        }
      },
      "212": {
        start: {
          line: 2907,
          column: 6
        },
        end: {
          line: 2912,
          column: 7
        }
      },
      "213": {
        start: {
          line: 2915,
          column: 6
        },
        end: {
          line: 2920,
          column: 7
        }
      },
      "214": {
        start: {
          line: 2923,
          column: 6
        },
        end: {
          line: 2928,
          column: 7
        }
      },
      "215": {
        start: {
          line: 2931,
          column: 21
        },
        end: {
          line: 2931,
          column: 36
        }
      },
      "216": {
        start: {
          line: 2932,
          column: 6
        },
        end: {
          line: 2937,
          column: 7
        }
      },
      "217": {
        start: {
          line: 2940,
          column: 6
        },
        end: {
          line: 2945,
          column: 7
        }
      },
      "218": {
        start: {
          line: 2948,
          column: 6
        },
        end: {
          line: 2953,
          column: 7
        }
      },
      "219": {
        start: {
          line: 2956,
          column: 6
        },
        end: {
          line: 2961,
          column: 7
        }
      },
      "220": {
        start: {
          line: 2964,
          column: 6
        },
        end: {
          line: 2969,
          column: 7
        }
      },
      "221": {
        start: {
          line: 2972,
          column: 6
        },
        end: {
          line: 2977,
          column: 7
        }
      },
      "222": {
        start: {
          line: 2980,
          column: 6
        },
        end: {
          line: 2985,
          column: 7
        }
      },
      "223": {
        start: {
          line: 2988,
          column: 6
        },
        end: {
          line: 2993,
          column: 7
        }
      },
      "224": {
        start: {
          line: 2996,
          column: 6
        },
        end: {
          line: 3001,
          column: 7
        }
      },
      "225": {
        start: {
          line: 3004,
          column: 6
        },
        end: {
          line: 3009,
          column: 7
        }
      },
      "226": {
        start: {
          line: 3012,
          column: 6
        },
        end: {
          line: 3018,
          column: 7
        }
      },
      "227": {
        start: {
          line: 3021,
          column: 6
        },
        end: {
          line: 3026,
          column: 7
        }
      },
      "228": {
        start: {
          line: 3029,
          column: 6
        },
        end: {
          line: 3034,
          column: 7
        }
      },
      "229": {
        start: {
          line: 3037,
          column: 6
        },
        end: {
          line: 3042,
          column: 7
        }
      },
      "230": {
        start: {
          line: 3045,
          column: 6
        },
        end: {
          line: 3050,
          column: 7
        }
      },
      "231": {
        start: {
          line: 3053,
          column: 6
        },
        end: {
          line: 3058,
          column: 7
        }
      },
      "232": {
        start: {
          line: 3061,
          column: 6
        },
        end: {
          line: 3066,
          column: 7
        }
      },
      "233": {
        start: {
          line: 3069,
          column: 6
        },
        end: {
          line: 3074,
          column: 7
        }
      },
      "234": {
        start: {
          line: 3077,
          column: 6
        },
        end: {
          line: 3082,
          column: 7
        }
      },
      "235": {
        start: {
          line: 3085,
          column: 6
        },
        end: {
          line: 3090,
          column: 7
        }
      },
      "236": {
        start: {
          line: 3276,
          column: 6
        },
        end: {
          line: 3281,
          column: 7
        }
      },
      "237": {
        start: {
          line: 3285,
          column: 6
        },
        end: {
          line: 3290,
          column: 7
        }
      },
      "238": {
        start: {
          line: 3293,
          column: 6
        },
        end: {
          line: 3298,
          column: 7
        }
      },
      "239": {
        start: {
          line: 3301,
          column: 6
        },
        end: {
          line: 3306,
          column: 7
        }
      },
      "240": {
        start: {
          line: 3310,
          column: 6
        },
        end: {
          line: 3315,
          column: 7
        }
      },
      "241": {
        start: {
          line: 3318,
          column: 6
        },
        end: {
          line: 3323,
          column: 7
        }
      },
      "242": {
        start: {
          line: 3326,
          column: 6
        },
        end: {
          line: 3331,
          column: 7
        }
      },
      "243": {
        start: {
          line: 3334,
          column: 6
        },
        end: {
          line: 3339,
          column: 7
        }
      },
      "244": {
        start: {
          line: 3342,
          column: 6
        },
        end: {
          line: 3347,
          column: 7
        }
      },
      "245": {
        start: {
          line: 3350,
          column: 6
        },
        end: {
          line: 3355,
          column: 7
        }
      },
      "246": {
        start: {
          line: 3358,
          column: 6
        },
        end: {
          line: 3363,
          column: 7
        }
      },
      "247": {
        start: {
          line: 3366,
          column: 6
        },
        end: {
          line: 3371,
          column: 7
        }
      },
      "248": {
        start: {
          line: 3374,
          column: 6
        },
        end: {
          line: 3379,
          column: 7
        }
      },
      "249": {
        start: {
          line: 3382,
          column: 6
        },
        end: {
          line: 3388,
          column: 7
        }
      },
      "250": {
        start: {
          line: 3391,
          column: 6
        },
        end: {
          line: 3396,
          column: 7
        }
      },
      "251": {
        start: {
          line: 3399,
          column: 6
        },
        end: {
          line: 3405,
          column: 7
        }
      },
      "252": {
        start: {
          line: 3408,
          column: 6
        },
        end: {
          line: 3414,
          column: 7
        }
      },
      "253": {
        start: {
          line: 3417,
          column: 6
        },
        end: {
          line: 3422,
          column: 7
        }
      },
      "254": {
        start: {
          line: 3425,
          column: 6
        },
        end: {
          line: 3431,
          column: 7
        }
      },
      "255": {
        start: {
          line: 3434,
          column: 6
        },
        end: {
          line: 3440,
          column: 7
        }
      },
      "256": {
        start: {
          line: 3443,
          column: 6
        },
        end: {
          line: 3448,
          column: 7
        }
      },
      "257": {
        start: {
          line: 3451,
          column: 6
        },
        end: {
          line: 3457,
          column: 7
        }
      },
      "258": {
        start: {
          line: 3460,
          column: 6
        },
        end: {
          line: 3466,
          column: 7
        }
      },
      "259": {
        start: {
          line: 3469,
          column: 6
        },
        end: {
          line: 3474,
          column: 7
        }
      },
      "260": {
        start: {
          line: 3477,
          column: 6
        },
        end: {
          line: 3483,
          column: 7
        }
      },
      "261": {
        start: {
          line: 3541,
          column: 6
        },
        end: {
          line: 3546,
          column: 7
        }
      },
      "262": {
        start: {
          line: 3549,
          column: 6
        },
        end: {
          line: 3554,
          column: 7
        }
      },
      "263": {
        start: {
          line: 3557,
          column: 6
        },
        end: {
          line: 3562,
          column: 7
        }
      },
      "264": {
        start: {
          line: 3565,
          column: 6
        },
        end: {
          line: 3570,
          column: 7
        }
      },
      "265": {
        start: {
          line: 3573,
          column: 6
        },
        end: {
          line: 3573,
          column: 57
        }
      },
      "266": {
        start: {
          line: 3576,
          column: 6
        },
        end: {
          line: 3581,
          column: 7
        }
      },
      "267": {
        start: {
          line: 3736,
          column: 6
        },
        end: {
          line: 3741,
          column: 7
        }
      },
      "268": {
        start: {
          line: 3744,
          column: 6
        },
        end: {
          line: 3749,
          column: 7
        }
      },
      "269": {
        start: {
          line: 3752,
          column: 6
        },
        end: {
          line: 3757,
          column: 7
        }
      },
      "270": {
        start: {
          line: 3760,
          column: 6
        },
        end: {
          line: 3765,
          column: 7
        }
      },
      "271": {
        start: {
          line: 3768,
          column: 6
        },
        end: {
          line: 3773,
          column: 7
        }
      },
      "272": {
        start: {
          line: 3776,
          column: 6
        },
        end: {
          line: 3781,
          column: 7
        }
      },
      "273": {
        start: {
          line: 3784,
          column: 6
        },
        end: {
          line: 3789,
          column: 7
        }
      },
      "274": {
        start: {
          line: 3792,
          column: 6
        },
        end: {
          line: 3797,
          column: 7
        }
      },
      "275": {
        start: {
          line: 3800,
          column: 6
        },
        end: {
          line: 3805,
          column: 7
        }
      },
      "276": {
        start: {
          line: 3808,
          column: 6
        },
        end: {
          line: 3813,
          column: 7
        }
      },
      "277": {
        start: {
          line: 3816,
          column: 6
        },
        end: {
          line: 3821,
          column: 7
        }
      },
      "278": {
        start: {
          line: 3824,
          column: 6
        },
        end: {
          line: 3829,
          column: 7
        }
      },
      "279": {
        start: {
          line: 3832,
          column: 6
        },
        end: {
          line: 3837,
          column: 7
        }
      },
      "280": {
        start: {
          line: 3840,
          column: 6
        },
        end: {
          line: 3845,
          column: 7
        }
      },
      "281": {
        start: {
          line: 3848,
          column: 6
        },
        end: {
          line: 3853,
          column: 7
        }
      },
      "282": {
        start: {
          line: 3856,
          column: 6
        },
        end: {
          line: 3861,
          column: 7
        }
      },
      "283": {
        start: {
          line: 3864,
          column: 6
        },
        end: {
          line: 3869,
          column: 7
        }
      },
      "284": {
        start: {
          line: 3872,
          column: 6
        },
        end: {
          line: 3877,
          column: 7
        }
      },
      "285": {
        start: {
          line: 3880,
          column: 6
        },
        end: {
          line: 3885,
          column: 7
        }
      },
      "286": {
        start: {
          line: 4179,
          column: 6
        },
        end: {
          line: 4179,
          column: 53
        }
      },
      "287": {
        start: {
          line: 4182,
          column: 6
        },
        end: {
          line: 4187,
          column: 7
        }
      },
      "288": {
        start: {
          line: 4190,
          column: 6
        },
        end: {
          line: 4195,
          column: 7
        }
      },
      "289": {
        start: {
          line: 4198,
          column: 6
        },
        end: {
          line: 4203,
          column: 7
        }
      },
      "290": {
        start: {
          line: 4206,
          column: 6
        },
        end: {
          line: 4211,
          column: 7
        }
      },
      "291": {
        start: {
          line: 4214,
          column: 6
        },
        end: {
          line: 4219,
          column: 7
        }
      },
      "292": {
        start: {
          line: 4222,
          column: 6
        },
        end: {
          line: 4227,
          column: 7
        }
      },
      "293": {
        start: {
          line: 4230,
          column: 6
        },
        end: {
          line: 4235,
          column: 7
        }
      },
      "294": {
        start: {
          line: 4238,
          column: 6
        },
        end: {
          line: 4243,
          column: 7
        }
      },
      "295": {
        start: {
          line: 4246,
          column: 6
        },
        end: {
          line: 4251,
          column: 7
        }
      },
      "296": {
        start: {
          line: 4254,
          column: 6
        },
        end: {
          line: 4259,
          column: 7
        }
      },
      "297": {
        start: {
          line: 4262,
          column: 6
        },
        end: {
          line: 4267,
          column: 7
        }
      },
      "298": {
        start: {
          line: 4270,
          column: 6
        },
        end: {
          line: 4275,
          column: 7
        }
      },
      "299": {
        start: {
          line: 4278,
          column: 6
        },
        end: {
          line: 4283,
          column: 7
        }
      },
      "300": {
        start: {
          line: 4286,
          column: 6
        },
        end: {
          line: 4291,
          column: 7
        }
      },
      "301": {
        start: {
          line: 4294,
          column: 6
        },
        end: {
          line: 4299,
          column: 7
        }
      },
      "302": {
        start: {
          line: 4302,
          column: 6
        },
        end: {
          line: 4307,
          column: 7
        }
      },
      "303": {
        start: {
          line: 4310,
          column: 6
        },
        end: {
          line: 4315,
          column: 7
        }
      },
      "304": {
        start: {
          line: 4318,
          column: 6
        },
        end: {
          line: 4323,
          column: 7
        }
      },
      "305": {
        start: {
          line: 4326,
          column: 6
        },
        end: {
          line: 4331,
          column: 7
        }
      },
      "306": {
        start: {
          line: 4334,
          column: 6
        },
        end: {
          line: 4339,
          column: 7
        }
      },
      "307": {
        start: {
          line: 4342,
          column: 6
        },
        end: {
          line: 4347,
          column: 7
        }
      },
      "308": {
        start: {
          line: 4350,
          column: 6
        },
        end: {
          line: 4355,
          column: 7
        }
      },
      "309": {
        start: {
          line: 4358,
          column: 6
        },
        end: {
          line: 4363,
          column: 7
        }
      },
      "310": {
        start: {
          line: 4366,
          column: 6
        },
        end: {
          line: 4371,
          column: 7
        }
      },
      "311": {
        start: {
          line: 4374,
          column: 6
        },
        end: {
          line: 4379,
          column: 7
        }
      },
      "312": {
        start: {
          line: 4382,
          column: 6
        },
        end: {
          line: 4387,
          column: 7
        }
      },
      "313": {
        start: {
          line: 4390,
          column: 6
        },
        end: {
          line: 4395,
          column: 7
        }
      },
      "314": {
        start: {
          line: 4398,
          column: 6
        },
        end: {
          line: 4403,
          column: 7
        }
      },
      "315": {
        start: {
          line: 4406,
          column: 6
        },
        end: {
          line: 4411,
          column: 7
        }
      },
      "316": {
        start: {
          line: 4414,
          column: 6
        },
        end: {
          line: 4419,
          column: 7
        }
      },
      "317": {
        start: {
          line: 4422,
          column: 6
        },
        end: {
          line: 4427,
          column: 7
        }
      },
      "318": {
        start: {
          line: 4430,
          column: 6
        },
        end: {
          line: 4435,
          column: 7
        }
      },
      "319": {
        start: {
          line: 4438,
          column: 6
        },
        end: {
          line: 4443,
          column: 7
        }
      },
      "320": {
        start: {
          line: 4446,
          column: 6
        },
        end: {
          line: 4451,
          column: 7
        }
      },
      "321": {
        start: {
          line: 4454,
          column: 6
        },
        end: {
          line: 4459,
          column: 7
        }
      },
      "322": {
        start: {
          line: 4516,
          column: 6
        },
        end: {
          line: 4521,
          column: 7
        }
      },
      "323": {
        start: {
          line: 4524,
          column: 6
        },
        end: {
          line: 4529,
          column: 7
        }
      },
      "324": {
        start: {
          line: 4532,
          column: 6
        },
        end: {
          line: 4537,
          column: 7
        }
      },
      "325": {
        start: {
          line: 4540,
          column: 6
        },
        end: {
          line: 4545,
          column: 7
        }
      },
      "326": {
        start: {
          line: 4548,
          column: 6
        },
        end: {
          line: 4553,
          column: 7
        }
      },
      "327": {
        start: {
          line: 4556,
          column: 6
        },
        end: {
          line: 4561,
          column: 7
        }
      },
      "328": {
        start: {
          line: 4604,
          column: 6
        },
        end: {
          line: 4609,
          column: 7
        }
      },
      "329": {
        start: {
          line: 4612,
          column: 6
        },
        end: {
          line: 4617,
          column: 7
        }
      },
      "330": {
        start: {
          line: 4620,
          column: 6
        },
        end: {
          line: 4625,
          column: 7
        }
      },
      "331": {
        start: {
          line: 4628,
          column: 6
        },
        end: {
          line: 4633,
          column: 7
        }
      },
      "332": {
        start: {
          line: 4659,
          column: 41
        },
        end: {
          line: 4659,
          column: 43
        }
      },
      "333": {
        start: {
          line: 4660,
          column: 6
        },
        end: {
          line: 4685,
          column: 7
        }
      },
      "334": {
        start: {
          line: 4661,
          column: 8
        },
        end: {
          line: 4661,
          column: 58
        }
      },
      "335": {
        start: {
          line: 4662,
          column: 8
        },
        end: {
          line: 4662,
          column: 67
        }
      },
      "336": {
        start: {
          line: 4663,
          column: 8
        },
        end: {
          line: 4663,
          column: 45
        }
      },
      "337": {
        start: {
          line: 4664,
          column: 8
        },
        end: {
          line: 4664,
          column: 40
        }
      },
      "338": {
        start: {
          line: 4665,
          column: 8
        },
        end: {
          line: 4665,
          column: 44
        }
      },
      "339": {
        start: {
          line: 4666,
          column: 8
        },
        end: {
          line: 4666,
          column: 51
        }
      },
      "340": {
        start: {
          line: 4667,
          column: 8
        },
        end: {
          line: 4667,
          column: 46
        }
      },
      "341": {
        start: {
          line: 4668,
          column: 8
        },
        end: {
          line: 4668,
          column: 46
        }
      },
      "342": {
        start: {
          line: 4669,
          column: 8
        },
        end: {
          line: 4669,
          column: 50
        }
      },
      "343": {
        start: {
          line: 4670,
          column: 8
        },
        end: {
          line: 4670,
          column: 50
        }
      },
      "344": {
        start: {
          line: 4671,
          column: 8
        },
        end: {
          line: 4671,
          column: 51
        }
      },
      "345": {
        start: {
          line: 4672,
          column: 13
        },
        end: {
          line: 4685,
          column: 7
        }
      },
      "346": {
        start: {
          line: 4673,
          column: 8
        },
        end: {
          line: 4673,
          column: 51
        }
      },
      "347": {
        start: {
          line: 4674,
          column: 8
        },
        end: {
          line: 4674,
          column: 58
        }
      },
      "348": {
        start: {
          line: 4675,
          column: 8
        },
        end: {
          line: 4675,
          column: 68
        }
      },
      "349": {
        start: {
          line: 4676,
          column: 8
        },
        end: {
          line: 4676,
          column: 45
        }
      },
      "350": {
        start: {
          line: 4677,
          column: 8
        },
        end: {
          line: 4677,
          column: 40
        }
      },
      "351": {
        start: {
          line: 4678,
          column: 8
        },
        end: {
          line: 4678,
          column: 43
        }
      },
      "352": {
        start: {
          line: 4679,
          column: 8
        },
        end: {
          line: 4679,
          column: 51
        }
      },
      "353": {
        start: {
          line: 4680,
          column: 8
        },
        end: {
          line: 4680,
          column: 46
        }
      },
      "354": {
        start: {
          line: 4681,
          column: 8
        },
        end: {
          line: 4681,
          column: 46
        }
      },
      "355": {
        start: {
          line: 4682,
          column: 8
        },
        end: {
          line: 4682,
          column: 49
        }
      },
      "356": {
        start: {
          line: 4683,
          column: 8
        },
        end: {
          line: 4683,
          column: 49
        }
      },
      "357": {
        start: {
          line: 4684,
          column: 8
        },
        end: {
          line: 4684,
          column: 51
        }
      },
      "358": {
        start: {
          line: 4686,
          column: 6
        },
        end: {
          line: 4686,
          column: 27
        }
      },
      "359": {
        start: {
          line: 4689,
          column: 6
        },
        end: {
          line: 4694,
          column: 7
        }
      },
      "360": {
        start: {
          line: 4791,
          column: 6
        },
        end: {
          line: 4796,
          column: 7
        }
      },
      "361": {
        start: {
          line: 4799,
          column: 6
        },
        end: {
          line: 4804,
          column: 7
        }
      },
      "362": {
        start: {
          line: 4807,
          column: 6
        },
        end: {
          line: 4812,
          column: 7
        }
      },
      "363": {
        start: {
          line: 4815,
          column: 6
        },
        end: {
          line: 4820,
          column: 7
        }
      },
      "364": {
        start: {
          line: 4823,
          column: 6
        },
        end: {
          line: 4828,
          column: 7
        }
      },
      "365": {
        start: {
          line: 4831,
          column: 6
        },
        end: {
          line: 4836,
          column: 7
        }
      },
      "366": {
        start: {
          line: 4839,
          column: 6
        },
        end: {
          line: 4844,
          column: 7
        }
      },
      "367": {
        start: {
          line: 4847,
          column: 6
        },
        end: {
          line: 4852,
          column: 7
        }
      },
      "368": {
        start: {
          line: 4855,
          column: 6
        },
        end: {
          line: 4860,
          column: 7
        }
      },
      "369": {
        start: {
          line: 4863,
          column: 6
        },
        end: {
          line: 4868,
          column: 7
        }
      },
      "370": {
        start: {
          line: 4871,
          column: 6
        },
        end: {
          line: 4876,
          column: 7
        }
      },
      "371": {
        start: {
          line: 4902,
          column: 6
        },
        end: {
          line: 4907,
          column: 7
        }
      },
      "372": {
        start: {
          line: 4910,
          column: 6
        },
        end: {
          line: 4915,
          column: 7
        }
      },
      "373": {
        start: {
          line: 4942,
          column: 6
        },
        end: {
          line: 4947,
          column: 7
        }
      },
      "374": {
        start: {
          line: 4950,
          column: 6
        },
        end: {
          line: 4955,
          column: 7
        }
      },
      "375": {
        start: {
          line: 4974,
          column: 6
        },
        end: {
          line: 4979,
          column: 7
        }
      },
      "376": {
        start: {
          line: 5027,
          column: 32
        },
        end: {
          line: 5027,
          column: 60
        }
      },
      "377": {
        start: {
          line: 5074,
          column: 19
        },
        end: {
          line: 5074,
          column: 34
        }
      },
      "378": {
        start: {
          line: 5075,
          column: 6
        },
        end: {
          line: 5090,
          column: 7
        }
      },
      "379": {
        start: {
          line: 5093,
          column: 6
        },
        end: {
          line: 5098,
          column: 7
        }
      },
      "380": {
        start: {
          line: 5101,
          column: 6
        },
        end: {
          line: 5106,
          column: 7
        }
      },
      "381": {
        start: {
          line: 5109,
          column: 6
        },
        end: {
          line: 5114,
          column: 7
        }
      },
      "382": {
        start: {
          line: 5117,
          column: 6
        },
        end: {
          line: 5122,
          column: 7
        }
      },
      "383": {
        start: {
          line: 5125,
          column: 6
        },
        end: {
          line: 5125,
          column: 39
        }
      },
      "384": {
        start: {
          line: 5126,
          column: 6
        },
        end: {
          line: 5131,
          column: 7
        }
      },
      "385": {
        start: {
          line: 5134,
          column: 6
        },
        end: {
          line: 5134,
          column: 41
        }
      },
      "386": {
        start: {
          line: 5135,
          column: 6
        },
        end: {
          line: 5140,
          column: 7
        }
      },
      "387": {
        start: {
          line: 5143,
          column: 6
        },
        end: {
          line: 5143,
          column: 28
        }
      },
      "388": {
        start: {
          line: 5144,
          column: 6
        },
        end: {
          line: 5149,
          column: 7
        }
      },
      "389": {
        start: {
          line: 5152,
          column: 6
        },
        end: {
          line: 5152,
          column: 26
        }
      },
      "390": {
        start: {
          line: 5153,
          column: 6
        },
        end: {
          line: 5158,
          column: 7
        }
      }
    },
    fnMap: {
      "0": {
        name: "setThemeConfig",
        decl: {
          start: {
            line: 45,
            column: 16
          },
          end: {
            line: 45,
            column: 30
          }
        },
        loc: {
          start: {
            line: 45,
            column: 56
          },
          end: {
            line: 52,
            column: 1
          }
        },
        line: 45
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 46,
            column: 25
          },
          end: {
            line: 46,
            column: 26
          }
        },
        loc: {
          start: {
            line: 46,
            column: 53
          },
          end: {
            line: 51,
            column: 3
          }
        },
        line: 46
      },
      "2": {
        name: "getThemeConfig",
        decl: {
          start: {
            line: 53,
            column: 16
          },
          end: {
            line: 53,
            column: 30
          }
        },
        loc: {
          start: {
            line: 53,
            column: 56
          },
          end: {
            line: 55,
            column: 1
          }
        },
        line: 53
      },
      "3": {
        name: "getThemeTarget",
        decl: {
          start: {
            line: 56,
            column: 16
          },
          end: {
            line: 56,
            column: 30
          }
        },
        loc: {
          start: {
            line: 56,
            column: 33
          },
          end: {
            line: 67,
            column: 1
          }
        },
        line: 56
      },
      "4": {
        name: "cleanStyleObj",
        decl: {
          start: {
            line: 69,
            column: 16
          },
          end: {
            line: 69,
            column: 29
          }
        },
        loc: {
          start: {
            line: 69,
            column: 32
          },
          end: {
            line: 71,
            column: 1
          }
        },
        line: 69
      },
      "5": {
        name: "injectTag",
        decl: {
          start: {
            line: 73,
            column: 16
          },
          end: {
            line: 73,
            column: 25
          }
        },
        loc: {
          start: {
            line: 73,
            column: 39
          },
          end: {
            line: 94,
            column: 1
          }
        },
        line: 73
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 81,
            column: 9
          },
          end: {
            line: 81,
            column: 10
          }
        },
        loc: {
          start: {
            line: 81,
            column: 16
          },
          end: {
            line: 81,
            column: 40
          }
        },
        line: 81
      },
      "7": {
        name: "getProperty",
        decl: {
          start: {
            line: 96,
            column: 9
          },
          end: {
            line: 96,
            column: 20
          }
        },
        loc: {
          start: {
            line: 96,
            column: 64
          },
          end: {
            line: 102,
            column: 1
          }
        },
        line: 96
      },
      "8": {
        name: "setBodyProperty",
        decl: {
          start: {
            line: 104,
            column: 9
          },
          end: {
            line: 104,
            column: 24
          }
        },
        loc: {
          start: {
            line: 104,
            column: 80
          },
          end: {
            line: 122,
            column: 1
          }
        },
        line: 104
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 232,
            column: 4
          },
          end: {
            line: 232,
            column: 5
          }
        },
        loc: {
          start: {
            line: 232,
            column: 27
          },
          end: {
            line: 250,
            column: 5
          }
        },
        line: 232
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 251,
            column: 4
          },
          end: {
            line: 251,
            column: 5
          }
        },
        loc: {
          start: {
            line: 251,
            column: 29
          },
          end: {
            line: 264,
            column: 5
          }
        },
        line: 251
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 265,
            column: 4
          },
          end: {
            line: 265,
            column: 5
          }
        },
        loc: {
          start: {
            line: 265,
            column: 27
          },
          end: {
            line: 278,
            column: 5
          }
        },
        line: 265
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 279,
            column: 4
          },
          end: {
            line: 279,
            column: 5
          }
        },
        loc: {
          start: {
            line: 279,
            column: 26
          },
          end: {
            line: 293,
            column: 5
          }
        },
        line: 279
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 294,
            column: 4
          },
          end: {
            line: 294,
            column: 5
          }
        },
        loc: {
          start: {
            line: 294,
            column: 27
          },
          end: {
            line: 307,
            column: 5
          }
        },
        line: 294
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 308,
            column: 4
          },
          end: {
            line: 308,
            column: 5
          }
        },
        loc: {
          start: {
            line: 308,
            column: 29
          },
          end: {
            line: 319,
            column: 5
          }
        },
        line: 308
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 320,
            column: 4
          },
          end: {
            line: 320,
            column: 5
          }
        },
        loc: {
          start: {
            line: 320,
            column: 27
          },
          end: {
            line: 327,
            column: 5
          }
        },
        line: 320
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 328,
            column: 4
          },
          end: {
            line: 328,
            column: 5
          }
        },
        loc: {
          start: {
            line: 328,
            column: 27
          },
          end: {
            line: 336,
            column: 5
          }
        },
        line: 328
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 337,
            column: 4
          },
          end: {
            line: 337,
            column: 5
          }
        },
        loc: {
          start: {
            line: 337,
            column: 27
          },
          end: {
            line: 347,
            column: 5
          }
        },
        line: 337
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 348,
            column: 4
          },
          end: {
            line: 348,
            column: 5
          }
        },
        loc: {
          start: {
            line: 348,
            column: 27
          },
          end: {
            line: 356,
            column: 5
          }
        },
        line: 348
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 357,
            column: 4
          },
          end: {
            line: 357,
            column: 5
          }
        },
        loc: {
          start: {
            line: 357,
            column: 27
          },
          end: {
            line: 364,
            column: 5
          }
        },
        line: 357
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 365,
            column: 4
          },
          end: {
            line: 365,
            column: 5
          }
        },
        loc: {
          start: {
            line: 365,
            column: 27
          },
          end: {
            line: 373,
            column: 5
          }
        },
        line: 365
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 374,
            column: 4
          },
          end: {
            line: 374,
            column: 5
          }
        },
        loc: {
          start: {
            line: 374,
            column: 27
          },
          end: {
            line: 381,
            column: 5
          }
        },
        line: 374
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 382,
            column: 4
          },
          end: {
            line: 382,
            column: 5
          }
        },
        loc: {
          start: {
            line: 382,
            column: 27
          },
          end: {
            line: 390,
            column: 5
          }
        },
        line: 382
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 391,
            column: 4
          },
          end: {
            line: 391,
            column: 5
          }
        },
        loc: {
          start: {
            line: 391,
            column: 27
          },
          end: {
            line: 399,
            column: 5
          }
        },
        line: 391
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 563,
            column: 4
          },
          end: {
            line: 563,
            column: 5
          }
        },
        loc: {
          start: {
            line: 563,
            column: 32
          },
          end: {
            line: 570,
            column: 5
          }
        },
        line: 563
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 571,
            column: 4
          },
          end: {
            line: 571,
            column: 5
          }
        },
        loc: {
          start: {
            line: 571,
            column: 33
          },
          end: {
            line: 578,
            column: 5
          }
        },
        line: 571
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 579,
            column: 4
          },
          end: {
            line: 579,
            column: 5
          }
        },
        loc: {
          start: {
            line: 579,
            column: 33
          },
          end: {
            line: 586,
            column: 5
          }
        },
        line: 579
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 587,
            column: 4
          },
          end: {
            line: 587,
            column: 5
          }
        },
        loc: {
          start: {
            line: 587,
            column: 30
          },
          end: {
            line: 594,
            column: 5
          }
        },
        line: 587
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 595,
            column: 4
          },
          end: {
            line: 595,
            column: 5
          }
        },
        loc: {
          start: {
            line: 595,
            column: 30
          },
          end: {
            line: 602,
            column: 5
          }
        },
        line: 595
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 603,
            column: 4
          },
          end: {
            line: 603,
            column: 5
          }
        },
        loc: {
          start: {
            line: 603,
            column: 32
          },
          end: {
            line: 610,
            column: 5
          }
        },
        line: 603
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 611,
            column: 4
          },
          end: {
            line: 611,
            column: 5
          }
        },
        loc: {
          start: {
            line: 611,
            column: 37
          },
          end: {
            line: 618,
            column: 5
          }
        },
        line: 611
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 619,
            column: 4
          },
          end: {
            line: 619,
            column: 5
          }
        },
        loc: {
          start: {
            line: 619,
            column: 37
          },
          end: {
            line: 626,
            column: 5
          }
        },
        line: 619
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 627,
            column: 4
          },
          end: {
            line: 627,
            column: 5
          }
        },
        loc: {
          start: {
            line: 627,
            column: 41
          },
          end: {
            line: 635,
            column: 5
          }
        },
        line: 627
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 636,
            column: 4
          },
          end: {
            line: 636,
            column: 5
          }
        },
        loc: {
          start: {
            line: 636,
            column: 42
          },
          end: {
            line: 643,
            column: 5
          }
        },
        line: 636
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 644,
            column: 4
          },
          end: {
            line: 644,
            column: 5
          }
        },
        loc: {
          start: {
            line: 644,
            column: 42
          },
          end: {
            line: 651,
            column: 5
          }
        },
        line: 644
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 652,
            column: 4
          },
          end: {
            line: 652,
            column: 5
          }
        },
        loc: {
          start: {
            line: 652,
            column: 39
          },
          end: {
            line: 659,
            column: 5
          }
        },
        line: 652
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 660,
            column: 4
          },
          end: {
            line: 660,
            column: 5
          }
        },
        loc: {
          start: {
            line: 660,
            column: 40
          },
          end: {
            line: 667,
            column: 5
          }
        },
        line: 660
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 668,
            column: 4
          },
          end: {
            line: 668,
            column: 5
          }
        },
        loc: {
          start: {
            line: 668,
            column: 40
          },
          end: {
            line: 675,
            column: 5
          }
        },
        line: 668
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 676,
            column: 4
          },
          end: {
            line: 676,
            column: 5
          }
        },
        loc: {
          start: {
            line: 676,
            column: 30
          },
          end: {
            line: 683,
            column: 5
          }
        },
        line: 676
      },
      "39": {
        name: "(anonymous_39)",
        decl: {
          start: {
            line: 684,
            column: 4
          },
          end: {
            line: 684,
            column: 5
          }
        },
        loc: {
          start: {
            line: 684,
            column: 33
          },
          end: {
            line: 691,
            column: 5
          }
        },
        line: 684
      },
      "40": {
        name: "(anonymous_40)",
        decl: {
          start: {
            line: 692,
            column: 4
          },
          end: {
            line: 692,
            column: 5
          }
        },
        loc: {
          start: {
            line: 692,
            column: 39
          },
          end: {
            line: 699,
            column: 5
          }
        },
        line: 692
      },
      "41": {
        name: "(anonymous_41)",
        decl: {
          start: {
            line: 700,
            column: 4
          },
          end: {
            line: 700,
            column: 5
          }
        },
        loc: {
          start: {
            line: 700,
            column: 37
          },
          end: {
            line: 707,
            column: 5
          }
        },
        line: 700
      },
      "42": {
        name: "(anonymous_42)",
        decl: {
          start: {
            line: 708,
            column: 4
          },
          end: {
            line: 708,
            column: 5
          }
        },
        loc: {
          start: {
            line: 708,
            column: 42
          },
          end: {
            line: 715,
            column: 5
          }
        },
        line: 708
      },
      "43": {
        name: "(anonymous_43)",
        decl: {
          start: {
            line: 716,
            column: 4
          },
          end: {
            line: 716,
            column: 5
          }
        },
        loc: {
          start: {
            line: 716,
            column: 44
          },
          end: {
            line: 725,
            column: 5
          }
        },
        line: 716
      },
      "44": {
        name: "(anonymous_44)",
        decl: {
          start: {
            line: 764,
            column: 4
          },
          end: {
            line: 764,
            column: 5
          }
        },
        loc: {
          start: {
            line: 764,
            column: 31
          },
          end: {
            line: 771,
            column: 5
          }
        },
        line: 764
      },
      "45": {
        name: "(anonymous_45)",
        decl: {
          start: {
            line: 772,
            column: 4
          },
          end: {
            line: 772,
            column: 5
          }
        },
        loc: {
          start: {
            line: 772,
            column: 34
          },
          end: {
            line: 779,
            column: 5
          }
        },
        line: 772
      },
      "46": {
        name: "(anonymous_46)",
        decl: {
          start: {
            line: 780,
            column: 4
          },
          end: {
            line: 780,
            column: 5
          }
        },
        loc: {
          start: {
            line: 780,
            column: 35
          },
          end: {
            line: 787,
            column: 5
          }
        },
        line: 780
      },
      "47": {
        name: "(anonymous_47)",
        decl: {
          start: {
            line: 788,
            column: 4
          },
          end: {
            line: 788,
            column: 5
          }
        },
        loc: {
          start: {
            line: 788,
            column: 37
          },
          end: {
            line: 795,
            column: 5
          }
        },
        line: 788
      },
      "48": {
        name: "(anonymous_48)",
        decl: {
          start: {
            line: 875,
            column: 4
          },
          end: {
            line: 875,
            column: 5
          }
        },
        loc: {
          start: {
            line: 875,
            column: 36
          },
          end: {
            line: 882,
            column: 5
          }
        },
        line: 875
      },
      "49": {
        name: "(anonymous_49)",
        decl: {
          start: {
            line: 883,
            column: 4
          },
          end: {
            line: 883,
            column: 5
          }
        },
        loc: {
          start: {
            line: 883,
            column: 35
          },
          end: {
            line: 890,
            column: 5
          }
        },
        line: 883
      },
      "50": {
        name: "(anonymous_50)",
        decl: {
          start: {
            line: 891,
            column: 4
          },
          end: {
            line: 891,
            column: 5
          }
        },
        loc: {
          start: {
            line: 891,
            column: 28
          },
          end: {
            line: 898,
            column: 5
          }
        },
        line: 891
      },
      "51": {
        name: "(anonymous_51)",
        decl: {
          start: {
            line: 899,
            column: 4
          },
          end: {
            line: 899,
            column: 5
          }
        },
        loc: {
          start: {
            line: 899,
            column: 40
          },
          end: {
            line: 906,
            column: 5
          }
        },
        line: 899
      },
      "52": {
        name: "(anonymous_52)",
        decl: {
          start: {
            line: 907,
            column: 4
          },
          end: {
            line: 907,
            column: 5
          }
        },
        loc: {
          start: {
            line: 907,
            column: 35
          },
          end: {
            line: 914,
            column: 5
          }
        },
        line: 907
      },
      "53": {
        name: "(anonymous_53)",
        decl: {
          start: {
            line: 915,
            column: 4
          },
          end: {
            line: 915,
            column: 5
          }
        },
        loc: {
          start: {
            line: 915,
            column: 39
          },
          end: {
            line: 922,
            column: 5
          }
        },
        line: 915
      },
      "54": {
        name: "(anonymous_54)",
        decl: {
          start: {
            line: 923,
            column: 4
          },
          end: {
            line: 923,
            column: 5
          }
        },
        loc: {
          start: {
            line: 923,
            column: 38
          },
          end: {
            line: 930,
            column: 5
          }
        },
        line: 923
      },
      "55": {
        name: "(anonymous_55)",
        decl: {
          start: {
            line: 931,
            column: 4
          },
          end: {
            line: 931,
            column: 5
          }
        },
        loc: {
          start: {
            line: 931,
            column: 41
          },
          end: {
            line: 938,
            column: 5
          }
        },
        line: 931
      },
      "56": {
        name: "(anonymous_56)",
        decl: {
          start: {
            line: 939,
            column: 4
          },
          end: {
            line: 939,
            column: 5
          }
        },
        loc: {
          start: {
            line: 939,
            column: 39
          },
          end: {
            line: 946,
            column: 5
          }
        },
        line: 939
      },
      "57": {
        name: "(anonymous_57)",
        decl: {
          start: {
            line: 1017,
            column: 4
          },
          end: {
            line: 1017,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1017,
            column: 31
          },
          end: {
            line: 1024,
            column: 5
          }
        },
        line: 1017
      },
      "58": {
        name: "(anonymous_58)",
        decl: {
          start: {
            line: 1025,
            column: 4
          },
          end: {
            line: 1025,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1025,
            column: 25
          },
          end: {
            line: 1032,
            column: 5
          }
        },
        line: 1025
      },
      "59": {
        name: "(anonymous_59)",
        decl: {
          start: {
            line: 1033,
            column: 4
          },
          end: {
            line: 1033,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1033,
            column: 31
          },
          end: {
            line: 1040,
            column: 5
          }
        },
        line: 1033
      },
      "60": {
        name: "(anonymous_60)",
        decl: {
          start: {
            line: 1041,
            column: 4
          },
          end: {
            line: 1041,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1041,
            column: 31
          },
          end: {
            line: 1048,
            column: 5
          }
        },
        line: 1041
      },
      "61": {
        name: "(anonymous_61)",
        decl: {
          start: {
            line: 1049,
            column: 4
          },
          end: {
            line: 1049,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1049,
            column: 32
          },
          end: {
            line: 1056,
            column: 5
          }
        },
        line: 1049
      },
      "62": {
        name: "(anonymous_62)",
        decl: {
          start: {
            line: 1057,
            column: 4
          },
          end: {
            line: 1057,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1057,
            column: 41
          },
          end: {
            line: 1064,
            column: 5
          }
        },
        line: 1057
      },
      "63": {
        name: "(anonymous_63)",
        decl: {
          start: {
            line: 1065,
            column: 4
          },
          end: {
            line: 1065,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1065,
            column: 39
          },
          end: {
            line: 1072,
            column: 5
          }
        },
        line: 1065
      },
      "64": {
        name: "(anonymous_64)",
        decl: {
          start: {
            line: 1073,
            column: 4
          },
          end: {
            line: 1073,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1073,
            column: 46
          },
          end: {
            line: 1080,
            column: 5
          }
        },
        line: 1073
      },
      "65": {
        name: "(anonymous_65)",
        decl: {
          start: {
            line: 1136,
            column: 4
          },
          end: {
            line: 1136,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1136,
            column: 24
          },
          end: {
            line: 1143,
            column: 5
          }
        },
        line: 1136
      },
      "66": {
        name: "(anonymous_66)",
        decl: {
          start: {
            line: 1144,
            column: 4
          },
          end: {
            line: 1144,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1144,
            column: 31
          },
          end: {
            line: 1151,
            column: 5
          }
        },
        line: 1144
      },
      "67": {
        name: "(anonymous_67)",
        decl: {
          start: {
            line: 1152,
            column: 4
          },
          end: {
            line: 1152,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1152,
            column: 30
          },
          end: {
            line: 1159,
            column: 5
          }
        },
        line: 1152
      },
      "68": {
        name: "(anonymous_68)",
        decl: {
          start: {
            line: 1160,
            column: 4
          },
          end: {
            line: 1160,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1160,
            column: 38
          },
          end: {
            line: 1167,
            column: 5
          }
        },
        line: 1160
      },
      "69": {
        name: "(anonymous_69)",
        decl: {
          start: {
            line: 1168,
            column: 4
          },
          end: {
            line: 1168,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1168,
            column: 25
          },
          end: {
            line: 1175,
            column: 5
          }
        },
        line: 1168
      },
      "70": {
        name: "(anonymous_70)",
        decl: {
          start: {
            line: 1221,
            column: 16
          },
          end: {
            line: 1221,
            column: 17
          }
        },
        loc: {
          start: {
            line: 1221,
            column: 31
          },
          end: {
            line: 1221,
            column: 64
          }
        },
        line: 1221
      },
      "71": {
        name: "(anonymous_71)",
        decl: {
          start: {
            line: 1282,
            column: 4
          },
          end: {
            line: 1282,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1282,
            column: 25
          },
          end: {
            line: 1289,
            column: 5
          }
        },
        line: 1282
      },
      "72": {
        name: "(anonymous_72)",
        decl: {
          start: {
            line: 1290,
            column: 4
          },
          end: {
            line: 1290,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1290,
            column: 32
          },
          end: {
            line: 1297,
            column: 5
          }
        },
        line: 1290
      },
      "73": {
        name: "(anonymous_73)",
        decl: {
          start: {
            line: 1298,
            column: 4
          },
          end: {
            line: 1298,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1298,
            column: 35
          },
          end: {
            line: 1305,
            column: 5
          }
        },
        line: 1298
      },
      "74": {
        name: "(anonymous_74)",
        decl: {
          start: {
            line: 1306,
            column: 4
          },
          end: {
            line: 1306,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1306,
            column: 40
          },
          end: {
            line: 1313,
            column: 5
          }
        },
        line: 1306
      },
      "75": {
        name: "(anonymous_75)",
        decl: {
          start: {
            line: 1314,
            column: 4
          },
          end: {
            line: 1314,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1314,
            column: 30
          },
          end: {
            line: 1321,
            column: 5
          }
        },
        line: 1314
      },
      "76": {
        name: "(anonymous_76)",
        decl: {
          start: {
            line: 1322,
            column: 4
          },
          end: {
            line: 1322,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1322,
            column: 33
          },
          end: {
            line: 1329,
            column: 5
          }
        },
        line: 1322
      },
      "77": {
        name: "(anonymous_77)",
        decl: {
          start: {
            line: 1330,
            column: 4
          },
          end: {
            line: 1330,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1330,
            column: 31
          },
          end: {
            line: 1337,
            column: 5
          }
        },
        line: 1330
      },
      "78": {
        name: "(anonymous_78)",
        decl: {
          start: {
            line: 1338,
            column: 4
          },
          end: {
            line: 1338,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1338,
            column: 36
          },
          end: {
            line: 1346,
            column: 5
          }
        },
        line: 1338
      },
      "79": {
        name: "(anonymous_79)",
        decl: {
          start: {
            line: 1347,
            column: 4
          },
          end: {
            line: 1347,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1347,
            column: 30
          },
          end: {
            line: 1354,
            column: 5
          }
        },
        line: 1347
      },
      "80": {
        name: "(anonymous_80)",
        decl: {
          start: {
            line: 1355,
            column: 4
          },
          end: {
            line: 1355,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1355,
            column: 36
          },
          end: {
            line: 1362,
            column: 5
          }
        },
        line: 1355
      },
      "81": {
        name: "(anonymous_81)",
        decl: {
          start: {
            line: 1363,
            column: 4
          },
          end: {
            line: 1363,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1363,
            column: 35
          },
          end: {
            line: 1370,
            column: 5
          }
        },
        line: 1363
      },
      "82": {
        name: "(anonymous_82)",
        decl: {
          start: {
            line: 1371,
            column: 4
          },
          end: {
            line: 1371,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1371,
            column: 27
          },
          end: {
            line: 1378,
            column: 5
          }
        },
        line: 1371
      },
      "83": {
        name: "(anonymous_83)",
        decl: {
          start: {
            line: 1379,
            column: 4
          },
          end: {
            line: 1379,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1379,
            column: 32
          },
          end: {
            line: 1386,
            column: 5
          }
        },
        line: 1379
      },
      "84": {
        name: "(anonymous_84)",
        decl: {
          start: {
            line: 1538,
            column: 4
          },
          end: {
            line: 1538,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1538,
            column: 41
          },
          end: {
            line: 1545,
            column: 5
          }
        },
        line: 1538
      },
      "85": {
        name: "(anonymous_85)",
        decl: {
          start: {
            line: 1546,
            column: 4
          },
          end: {
            line: 1546,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1546,
            column: 43
          },
          end: {
            line: 1554,
            column: 5
          }
        },
        line: 1546
      },
      "86": {
        name: "(anonymous_86)",
        decl: {
          start: {
            line: 1555,
            column: 4
          },
          end: {
            line: 1555,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1555,
            column: 29
          },
          end: {
            line: 1562,
            column: 5
          }
        },
        line: 1555
      },
      "87": {
        name: "(anonymous_87)",
        decl: {
          start: {
            line: 1563,
            column: 4
          },
          end: {
            line: 1563,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1563,
            column: 31
          },
          end: {
            line: 1570,
            column: 5
          }
        },
        line: 1563
      },
      "88": {
        name: "(anonymous_88)",
        decl: {
          start: {
            line: 1571,
            column: 4
          },
          end: {
            line: 1571,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1571,
            column: 30
          },
          end: {
            line: 1578,
            column: 5
          }
        },
        line: 1571
      },
      "89": {
        name: "(anonymous_89)",
        decl: {
          start: {
            line: 1579,
            column: 4
          },
          end: {
            line: 1579,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1579,
            column: 33
          },
          end: {
            line: 1586,
            column: 5
          }
        },
        line: 1579
      },
      "90": {
        name: "(anonymous_90)",
        decl: {
          start: {
            line: 1587,
            column: 4
          },
          end: {
            line: 1587,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1587,
            column: 32
          },
          end: {
            line: 1594,
            column: 5
          }
        },
        line: 1587
      },
      "91": {
        name: "(anonymous_91)",
        decl: {
          start: {
            line: 1595,
            column: 4
          },
          end: {
            line: 1595,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1595,
            column: 35
          },
          end: {
            line: 1602,
            column: 5
          }
        },
        line: 1595
      },
      "92": {
        name: "(anonymous_92)",
        decl: {
          start: {
            line: 1603,
            column: 4
          },
          end: {
            line: 1603,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1603,
            column: 31
          },
          end: {
            line: 1610,
            column: 5
          }
        },
        line: 1603
      },
      "93": {
        name: "(anonymous_93)",
        decl: {
          start: {
            line: 1611,
            column: 4
          },
          end: {
            line: 1611,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1611,
            column: 34
          },
          end: {
            line: 1618,
            column: 5
          }
        },
        line: 1611
      },
      "94": {
        name: "(anonymous_94)",
        decl: {
          start: {
            line: 1619,
            column: 4
          },
          end: {
            line: 1619,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1619,
            column: 41
          },
          end: {
            line: 1626,
            column: 5
          }
        },
        line: 1619
      },
      "95": {
        name: "(anonymous_95)",
        decl: {
          start: {
            line: 1627,
            column: 4
          },
          end: {
            line: 1627,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1627,
            column: 31
          },
          end: {
            line: 1634,
            column: 5
          }
        },
        line: 1627
      },
      "96": {
        name: "(anonymous_96)",
        decl: {
          start: {
            line: 1635,
            column: 4
          },
          end: {
            line: 1635,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1635,
            column: 34
          },
          end: {
            line: 1642,
            column: 5
          }
        },
        line: 1635
      },
      "97": {
        name: "(anonymous_97)",
        decl: {
          start: {
            line: 1644,
            column: 4
          },
          end: {
            line: 1644,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1644,
            column: 36
          },
          end: {
            line: 1651,
            column: 5
          }
        },
        line: 1644
      },
      "98": {
        name: "(anonymous_98)",
        decl: {
          start: {
            line: 1653,
            column: 4
          },
          end: {
            line: 1653,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1653,
            column: 43
          },
          end: {
            line: 1660,
            column: 5
          }
        },
        line: 1653
      },
      "99": {
        name: "(anonymous_99)",
        decl: {
          start: {
            line: 1662,
            column: 4
          },
          end: {
            line: 1662,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1662,
            column: 35
          },
          end: {
            line: 1669,
            column: 5
          }
        },
        line: 1662
      },
      "100": {
        name: "(anonymous_100)",
        decl: {
          start: {
            line: 1670,
            column: 4
          },
          end: {
            line: 1670,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1670,
            column: 35
          },
          end: {
            line: 1677,
            column: 5
          }
        },
        line: 1670
      },
      "101": {
        name: "(anonymous_101)",
        decl: {
          start: {
            line: 1678,
            column: 4
          },
          end: {
            line: 1678,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1678,
            column: 38
          },
          end: {
            line: 1685,
            column: 5
          }
        },
        line: 1678
      },
      "102": {
        name: "(anonymous_102)",
        decl: {
          start: {
            line: 1686,
            column: 4
          },
          end: {
            line: 1686,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1686,
            column: 38
          },
          end: {
            line: 1693,
            column: 5
          }
        },
        line: 1686
      },
      "103": {
        name: "(anonymous_103)",
        decl: {
          start: {
            line: 1694,
            column: 4
          },
          end: {
            line: 1694,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1694,
            column: 41
          },
          end: {
            line: 1701,
            column: 5
          }
        },
        line: 1694
      },
      "104": {
        name: "(anonymous_104)",
        decl: {
          start: {
            line: 1726,
            column: 4
          },
          end: {
            line: 1726,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1726,
            column: 36
          },
          end: {
            line: 1733,
            column: 5
          }
        },
        line: 1726
      },
      "105": {
        name: "(anonymous_105)",
        decl: {
          start: {
            line: 1734,
            column: 4
          },
          end: {
            line: 1734,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1734,
            column: 31
          },
          end: {
            line: 1741,
            column: 5
          }
        },
        line: 1734
      },
      "106": {
        name: "(anonymous_106)",
        decl: {
          start: {
            line: 1827,
            column: 4
          },
          end: {
            line: 1827,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1827,
            column: 31
          },
          end: {
            line: 1834,
            column: 5
          }
        },
        line: 1827
      },
      "107": {
        name: "(anonymous_107)",
        decl: {
          start: {
            line: 1835,
            column: 4
          },
          end: {
            line: 1835,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1835,
            column: 33
          },
          end: {
            line: 1843,
            column: 5
          }
        },
        line: 1835
      },
      "108": {
        name: "(anonymous_108)",
        decl: {
          start: {
            line: 1844,
            column: 4
          },
          end: {
            line: 1844,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1844,
            column: 38
          },
          end: {
            line: 1851,
            column: 5
          }
        },
        line: 1844
      },
      "109": {
        name: "(anonymous_109)",
        decl: {
          start: {
            line: 1852,
            column: 4
          },
          end: {
            line: 1852,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1852,
            column: 25
          },
          end: {
            line: 1859,
            column: 5
          }
        },
        line: 1852
      },
      "110": {
        name: "(anonymous_110)",
        decl: {
          start: {
            line: 1860,
            column: 4
          },
          end: {
            line: 1860,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1860,
            column: 33
          },
          end: {
            line: 1867,
            column: 5
          }
        },
        line: 1860
      },
      "111": {
        name: "(anonymous_111)",
        decl: {
          start: {
            line: 1868,
            column: 4
          },
          end: {
            line: 1868,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1868,
            column: 43
          },
          end: {
            line: 1875,
            column: 5
          }
        },
        line: 1868
      },
      "112": {
        name: "(anonymous_112)",
        decl: {
          start: {
            line: 1876,
            column: 4
          },
          end: {
            line: 1876,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1876,
            column: 39
          },
          end: {
            line: 1883,
            column: 5
          }
        },
        line: 1876
      },
      "113": {
        name: "(anonymous_113)",
        decl: {
          start: {
            line: 1884,
            column: 4
          },
          end: {
            line: 1884,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1884,
            column: 26
          },
          end: {
            line: 1891,
            column: 5
          }
        },
        line: 1884
      },
      "114": {
        name: "(anonymous_114)",
        decl: {
          start: {
            line: 1892,
            column: 4
          },
          end: {
            line: 1892,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1892,
            column: 32
          },
          end: {
            line: 1899,
            column: 5
          }
        },
        line: 1892
      },
      "115": {
        name: "(anonymous_115)",
        decl: {
          start: {
            line: 1900,
            column: 4
          },
          end: {
            line: 1900,
            column: 5
          }
        },
        loc: {
          start: {
            line: 1900,
            column: 31
          },
          end: {
            line: 1907,
            column: 5
          }
        },
        line: 1900
      },
      "116": {
        name: "(anonymous_116)",
        decl: {
          start: {
            line: 2092,
            column: 4
          },
          end: {
            line: 2092,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2092,
            column: 40
          },
          end: {
            line: 2101,
            column: 5
          }
        },
        line: 2092
      },
      "117": {
        name: "(anonymous_117)",
        decl: {
          start: {
            line: 2102,
            column: 4
          },
          end: {
            line: 2102,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2102,
            column: 26
          },
          end: {
            line: 2109,
            column: 5
          }
        },
        line: 2102
      },
      "118": {
        name: "(anonymous_118)",
        decl: {
          start: {
            line: 2110,
            column: 4
          },
          end: {
            line: 2110,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2110,
            column: 27
          },
          end: {
            line: 2117,
            column: 5
          }
        },
        line: 2110
      },
      "119": {
        name: "(anonymous_119)",
        decl: {
          start: {
            line: 2118,
            column: 4
          },
          end: {
            line: 2118,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2118,
            column: 30
          },
          end: {
            line: 2125,
            column: 5
          }
        },
        line: 2118
      },
      "120": {
        name: "(anonymous_120)",
        decl: {
          start: {
            line: 2126,
            column: 4
          },
          end: {
            line: 2126,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2126,
            column: 29
          },
          end: {
            line: 2133,
            column: 5
          }
        },
        line: 2126
      },
      "121": {
        name: "(anonymous_121)",
        decl: {
          start: {
            line: 2134,
            column: 4
          },
          end: {
            line: 2134,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2134,
            column: 26
          },
          end: {
            line: 2141,
            column: 5
          }
        },
        line: 2134
      },
      "122": {
        name: "(anonymous_122)",
        decl: {
          start: {
            line: 2142,
            column: 4
          },
          end: {
            line: 2142,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2142,
            column: 30
          },
          end: {
            line: 2149,
            column: 5
          }
        },
        line: 2142
      },
      "123": {
        name: "(anonymous_123)",
        decl: {
          start: {
            line: 2150,
            column: 4
          },
          end: {
            line: 2150,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2150,
            column: 35
          },
          end: {
            line: 2157,
            column: 5
          }
        },
        line: 2150
      },
      "124": {
        name: "(anonymous_124)",
        decl: {
          start: {
            line: 2158,
            column: 4
          },
          end: {
            line: 2158,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2158,
            column: 34
          },
          end: {
            line: 2165,
            column: 5
          }
        },
        line: 2158
      },
      "125": {
        name: "(anonymous_125)",
        decl: {
          start: {
            line: 2166,
            column: 4
          },
          end: {
            line: 2166,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2166,
            column: 31
          },
          end: {
            line: 2173,
            column: 5
          }
        },
        line: 2166
      },
      "126": {
        name: "(anonymous_126)",
        decl: {
          start: {
            line: 2174,
            column: 4
          },
          end: {
            line: 2174,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2174,
            column: 29
          },
          end: {
            line: 2181,
            column: 5
          }
        },
        line: 2174
      },
      "127": {
        name: "(anonymous_127)",
        decl: {
          start: {
            line: 2182,
            column: 4
          },
          end: {
            line: 2182,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2182,
            column: 35
          },
          end: {
            line: 2189,
            column: 5
          }
        },
        line: 2182
      },
      "128": {
        name: "(anonymous_128)",
        decl: {
          start: {
            line: 2190,
            column: 4
          },
          end: {
            line: 2190,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2190,
            column: 37
          },
          end: {
            line: 2197,
            column: 5
          }
        },
        line: 2190
      },
      "129": {
        name: "(anonymous_129)",
        decl: {
          start: {
            line: 2198,
            column: 4
          },
          end: {
            line: 2198,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2198,
            column: 36
          },
          end: {
            line: 2205,
            column: 5
          }
        },
        line: 2198
      },
      "130": {
        name: "(anonymous_130)",
        decl: {
          start: {
            line: 2206,
            column: 4
          },
          end: {
            line: 2206,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2206,
            column: 41
          },
          end: {
            line: 2213,
            column: 5
          }
        },
        line: 2206
      },
      "131": {
        name: "(anonymous_131)",
        decl: {
          start: {
            line: 2214,
            column: 4
          },
          end: {
            line: 2214,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2214,
            column: 39
          },
          end: {
            line: 2221,
            column: 5
          }
        },
        line: 2214
      },
      "132": {
        name: "(anonymous_132)",
        decl: {
          start: {
            line: 2222,
            column: 4
          },
          end: {
            line: 2222,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2222,
            column: 45
          },
          end: {
            line: 2229,
            column: 5
          }
        },
        line: 2222
      },
      "133": {
        name: "(anonymous_133)",
        decl: {
          start: {
            line: 2230,
            column: 4
          },
          end: {
            line: 2230,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2230,
            column: 30
          },
          end: {
            line: 2237,
            column: 5
          }
        },
        line: 2230
      },
      "134": {
        name: "(anonymous_134)",
        decl: {
          start: {
            line: 2238,
            column: 4
          },
          end: {
            line: 2238,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2238,
            column: 28
          },
          end: {
            line: 2245,
            column: 5
          }
        },
        line: 2238
      },
      "135": {
        name: "(anonymous_135)",
        decl: {
          start: {
            line: 2246,
            column: 4
          },
          end: {
            line: 2246,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2246,
            column: 32
          },
          end: {
            line: 2253,
            column: 5
          }
        },
        line: 2246
      },
      "136": {
        name: "(anonymous_136)",
        decl: {
          start: {
            line: 2254,
            column: 4
          },
          end: {
            line: 2254,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2254,
            column: 31
          },
          end: {
            line: 2261,
            column: 5
          }
        },
        line: 2254
      },
      "137": {
        name: "(anonymous_137)",
        decl: {
          start: {
            line: 2262,
            column: 4
          },
          end: {
            line: 2262,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2262,
            column: 32
          },
          end: {
            line: 2269,
            column: 5
          }
        },
        line: 2262
      },
      "138": {
        name: "(anonymous_138)",
        decl: {
          start: {
            line: 2270,
            column: 4
          },
          end: {
            line: 2270,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2270,
            column: 36
          },
          end: {
            line: 2277,
            column: 5
          }
        },
        line: 2270
      },
      "139": {
        name: "(anonymous_139)",
        decl: {
          start: {
            line: 2356,
            column: 4
          },
          end: {
            line: 2356,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2356,
            column: 32
          },
          end: {
            line: 2363,
            column: 5
          }
        },
        line: 2356
      },
      "140": {
        name: "(anonymous_140)",
        decl: {
          start: {
            line: 2364,
            column: 4
          },
          end: {
            line: 2364,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2364,
            column: 31
          },
          end: {
            line: 2371,
            column: 5
          }
        },
        line: 2364
      },
      "141": {
        name: "(anonymous_141)",
        decl: {
          start: {
            line: 2372,
            column: 4
          },
          end: {
            line: 2372,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2372,
            column: 36
          },
          end: {
            line: 2379,
            column: 5
          }
        },
        line: 2372
      },
      "142": {
        name: "(anonymous_142)",
        decl: {
          start: {
            line: 2380,
            column: 4
          },
          end: {
            line: 2380,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2380,
            column: 30
          },
          end: {
            line: 2387,
            column: 5
          }
        },
        line: 2380
      },
      "143": {
        name: "(anonymous_143)",
        decl: {
          start: {
            line: 2388,
            column: 4
          },
          end: {
            line: 2388,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2388,
            column: 27
          },
          end: {
            line: 2395,
            column: 5
          }
        },
        line: 2388
      },
      "144": {
        name: "(anonymous_144)",
        decl: {
          start: {
            line: 2396,
            column: 4
          },
          end: {
            line: 2396,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2396,
            column: 28
          },
          end: {
            line: 2403,
            column: 5
          }
        },
        line: 2396
      },
      "145": {
        name: "(anonymous_145)",
        decl: {
          start: {
            line: 2404,
            column: 4
          },
          end: {
            line: 2404,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2404,
            column: 31
          },
          end: {
            line: 2411,
            column: 5
          }
        },
        line: 2404
      },
      "146": {
        name: "(anonymous_146)",
        decl: {
          start: {
            line: 2412,
            column: 4
          },
          end: {
            line: 2412,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2412,
            column: 29
          },
          end: {
            line: 2419,
            column: 5
          }
        },
        line: 2412
      },
      "147": {
        name: "(anonymous_147)",
        decl: {
          start: {
            line: 2420,
            column: 4
          },
          end: {
            line: 2420,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2420,
            column: 29
          },
          end: {
            line: 2427,
            column: 5
          }
        },
        line: 2420
      },
      "148": {
        name: "(anonymous_148)",
        decl: {
          start: {
            line: 2562,
            column: 4
          },
          end: {
            line: 2562,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2562,
            column: 22
          },
          end: {
            line: 2569,
            column: 5
          }
        },
        line: 2562
      },
      "149": {
        name: "(anonymous_149)",
        decl: {
          start: {
            line: 2570,
            column: 4
          },
          end: {
            line: 2570,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2570,
            column: 29
          },
          end: {
            line: 2572,
            column: 5
          }
        },
        line: 2570
      },
      "150": {
        name: "(anonymous_150)",
        decl: {
          start: {
            line: 2573,
            column: 4
          },
          end: {
            line: 2573,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2573,
            column: 26
          },
          end: {
            line: 2575,
            column: 5
          }
        },
        line: 2573
      },
      "151": {
        name: "(anonymous_151)",
        decl: {
          start: {
            line: 2576,
            column: 4
          },
          end: {
            line: 2576,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2576,
            column: 29
          },
          end: {
            line: 2578,
            column: 5
          }
        },
        line: 2576
      },
      "152": {
        name: "(anonymous_152)",
        decl: {
          start: {
            line: 2579,
            column: 4
          },
          end: {
            line: 2579,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2579,
            column: 28
          },
          end: {
            line: 2581,
            column: 5
          }
        },
        line: 2579
      },
      "153": {
        name: "(anonymous_153)",
        decl: {
          start: {
            line: 2582,
            column: 4
          },
          end: {
            line: 2582,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2582,
            column: 25
          },
          end: {
            line: 2589,
            column: 5
          }
        },
        line: 2582
      },
      "154": {
        name: "(anonymous_154)",
        decl: {
          start: {
            line: 2590,
            column: 4
          },
          end: {
            line: 2590,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2590,
            column: 32
          },
          end: {
            line: 2592,
            column: 5
          }
        },
        line: 2590
      },
      "155": {
        name: "(anonymous_155)",
        decl: {
          start: {
            line: 2593,
            column: 4
          },
          end: {
            line: 2593,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2593,
            column: 29
          },
          end: {
            line: 2595,
            column: 5
          }
        },
        line: 2593
      },
      "156": {
        name: "(anonymous_156)",
        decl: {
          start: {
            line: 2596,
            column: 4
          },
          end: {
            line: 2596,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2596,
            column: 32
          },
          end: {
            line: 2598,
            column: 5
          }
        },
        line: 2596
      },
      "157": {
        name: "(anonymous_157)",
        decl: {
          start: {
            line: 2599,
            column: 4
          },
          end: {
            line: 2599,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2599,
            column: 31
          },
          end: {
            line: 2601,
            column: 5
          }
        },
        line: 2599
      },
      "158": {
        name: "(anonymous_158)",
        decl: {
          start: {
            line: 2602,
            column: 4
          },
          end: {
            line: 2602,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2602,
            column: 30
          },
          end: {
            line: 2609,
            column: 5
          }
        },
        line: 2602
      },
      "159": {
        name: "(anonymous_159)",
        decl: {
          start: {
            line: 2610,
            column: 4
          },
          end: {
            line: 2610,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2610,
            column: 35
          },
          end: {
            line: 2617,
            column: 5
          }
        },
        line: 2610
      },
      "160": {
        name: "(anonymous_160)",
        decl: {
          start: {
            line: 2618,
            column: 4
          },
          end: {
            line: 2618,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2618,
            column: 31
          },
          end: {
            line: 2625,
            column: 5
          }
        },
        line: 2618
      },
      "161": {
        name: "(anonymous_161)",
        decl: {
          start: {
            line: 2626,
            column: 4
          },
          end: {
            line: 2626,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2626,
            column: 32
          },
          end: {
            line: 2633,
            column: 5
          }
        },
        line: 2626
      },
      "162": {
        name: "(anonymous_162)",
        decl: {
          start: {
            line: 2634,
            column: 4
          },
          end: {
            line: 2634,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2634,
            column: 37
          },
          end: {
            line: 2641,
            column: 5
          }
        },
        line: 2634
      },
      "163": {
        name: "(anonymous_163)",
        decl: {
          start: {
            line: 2642,
            column: 4
          },
          end: {
            line: 2642,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2642,
            column: 35
          },
          end: {
            line: 2649,
            column: 5
          }
        },
        line: 2642
      },
      "164": {
        name: "(anonymous_164)",
        decl: {
          start: {
            line: 2650,
            column: 4
          },
          end: {
            line: 2650,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2650,
            column: 30
          },
          end: {
            line: 2657,
            column: 5
          }
        },
        line: 2650
      },
      "165": {
        name: "(anonymous_165)",
        decl: {
          start: {
            line: 2690,
            column: 4
          },
          end: {
            line: 2690,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2690,
            column: 22
          },
          end: {
            line: 2697,
            column: 5
          }
        },
        line: 2690
      },
      "166": {
        name: "(anonymous_166)",
        decl: {
          start: {
            line: 2698,
            column: 4
          },
          end: {
            line: 2698,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2698,
            column: 37
          },
          end: {
            line: 2705,
            column: 5
          }
        },
        line: 2698
      },
      "167": {
        name: "(anonymous_167)",
        decl: {
          start: {
            line: 2706,
            column: 4
          },
          end: {
            line: 2706,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2706,
            column: 35
          },
          end: {
            line: 2713,
            column: 5
          }
        },
        line: 2706
      },
      "168": {
        name: "(anonymous_168)",
        decl: {
          start: {
            line: 2898,
            column: 4
          },
          end: {
            line: 2898,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2898,
            column: 45
          },
          end: {
            line: 2905,
            column: 5
          }
        },
        line: 2898
      },
      "169": {
        name: "(anonymous_169)",
        decl: {
          start: {
            line: 2906,
            column: 4
          },
          end: {
            line: 2906,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2906,
            column: 40
          },
          end: {
            line: 2913,
            column: 5
          }
        },
        line: 2906
      },
      "170": {
        name: "(anonymous_170)",
        decl: {
          start: {
            line: 2914,
            column: 4
          },
          end: {
            line: 2914,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2914,
            column: 42
          },
          end: {
            line: 2921,
            column: 5
          }
        },
        line: 2914
      },
      "171": {
        name: "(anonymous_171)",
        decl: {
          start: {
            line: 2922,
            column: 4
          },
          end: {
            line: 2922,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2922,
            column: 42
          },
          end: {
            line: 2929,
            column: 5
          }
        },
        line: 2922
      },
      "172": {
        name: "(anonymous_172)",
        decl: {
          start: {
            line: 2930,
            column: 4
          },
          end: {
            line: 2930,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2930,
            column: 26
          },
          end: {
            line: 2938,
            column: 5
          }
        },
        line: 2930
      },
      "173": {
        name: "(anonymous_173)",
        decl: {
          start: {
            line: 2939,
            column: 4
          },
          end: {
            line: 2939,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2939,
            column: 28
          },
          end: {
            line: 2946,
            column: 5
          }
        },
        line: 2939
      },
      "174": {
        name: "(anonymous_174)",
        decl: {
          start: {
            line: 2947,
            column: 4
          },
          end: {
            line: 2947,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2947,
            column: 26
          },
          end: {
            line: 2954,
            column: 5
          }
        },
        line: 2947
      },
      "175": {
        name: "(anonymous_175)",
        decl: {
          start: {
            line: 2955,
            column: 4
          },
          end: {
            line: 2955,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2955,
            column: 32
          },
          end: {
            line: 2962,
            column: 5
          }
        },
        line: 2955
      },
      "176": {
        name: "(anonymous_176)",
        decl: {
          start: {
            line: 2963,
            column: 4
          },
          end: {
            line: 2963,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2963,
            column: 28
          },
          end: {
            line: 2970,
            column: 5
          }
        },
        line: 2963
      },
      "177": {
        name: "(anonymous_177)",
        decl: {
          start: {
            line: 2971,
            column: 4
          },
          end: {
            line: 2971,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2971,
            column: 31
          },
          end: {
            line: 2978,
            column: 5
          }
        },
        line: 2971
      },
      "178": {
        name: "(anonymous_178)",
        decl: {
          start: {
            line: 2979,
            column: 4
          },
          end: {
            line: 2979,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2979,
            column: 25
          },
          end: {
            line: 2986,
            column: 5
          }
        },
        line: 2979
      },
      "179": {
        name: "(anonymous_179)",
        decl: {
          start: {
            line: 2987,
            column: 4
          },
          end: {
            line: 2987,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2987,
            column: 29
          },
          end: {
            line: 2994,
            column: 5
          }
        },
        line: 2987
      },
      "180": {
        name: "(anonymous_180)",
        decl: {
          start: {
            line: 2995,
            column: 4
          },
          end: {
            line: 2995,
            column: 5
          }
        },
        loc: {
          start: {
            line: 2995,
            column: 34
          },
          end: {
            line: 3002,
            column: 5
          }
        },
        line: 2995
      },
      "181": {
        name: "(anonymous_181)",
        decl: {
          start: {
            line: 3003,
            column: 4
          },
          end: {
            line: 3003,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3003,
            column: 44
          },
          end: {
            line: 3010,
            column: 5
          }
        },
        line: 3003
      },
      "182": {
        name: "(anonymous_182)",
        decl: {
          start: {
            line: 3011,
            column: 4
          },
          end: {
            line: 3011,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3011,
            column: 43
          },
          end: {
            line: 3019,
            column: 5
          }
        },
        line: 3011
      },
      "183": {
        name: "(anonymous_183)",
        decl: {
          start: {
            line: 3020,
            column: 4
          },
          end: {
            line: 3020,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3020,
            column: 41
          },
          end: {
            line: 3027,
            column: 5
          }
        },
        line: 3020
      },
      "184": {
        name: "(anonymous_184)",
        decl: {
          start: {
            line: 3028,
            column: 4
          },
          end: {
            line: 3028,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3028,
            column: 38
          },
          end: {
            line: 3035,
            column: 5
          }
        },
        line: 3028
      },
      "185": {
        name: "(anonymous_185)",
        decl: {
          start: {
            line: 3036,
            column: 4
          },
          end: {
            line: 3036,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3036,
            column: 34
          },
          end: {
            line: 3043,
            column: 5
          }
        },
        line: 3036
      },
      "186": {
        name: "(anonymous_186)",
        decl: {
          start: {
            line: 3044,
            column: 4
          },
          end: {
            line: 3044,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3044,
            column: 38
          },
          end: {
            line: 3051,
            column: 5
          }
        },
        line: 3044
      },
      "187": {
        name: "(anonymous_187)",
        decl: {
          start: {
            line: 3052,
            column: 4
          },
          end: {
            line: 3052,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3052,
            column: 32
          },
          end: {
            line: 3059,
            column: 5
          }
        },
        line: 3052
      },
      "188": {
        name: "(anonymous_188)",
        decl: {
          start: {
            line: 3060,
            column: 4
          },
          end: {
            line: 3060,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3060,
            column: 36
          },
          end: {
            line: 3067,
            column: 5
          }
        },
        line: 3060
      },
      "189": {
        name: "(anonymous_189)",
        decl: {
          start: {
            line: 3068,
            column: 4
          },
          end: {
            line: 3068,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3068,
            column: 29
          },
          end: {
            line: 3075,
            column: 5
          }
        },
        line: 3068
      },
      "190": {
        name: "(anonymous_190)",
        decl: {
          start: {
            line: 3076,
            column: 4
          },
          end: {
            line: 3076,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3076,
            column: 34
          },
          end: {
            line: 3083,
            column: 5
          }
        },
        line: 3076
      },
      "191": {
        name: "(anonymous_191)",
        decl: {
          start: {
            line: 3084,
            column: 4
          },
          end: {
            line: 3084,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3084,
            column: 38
          },
          end: {
            line: 3091,
            column: 5
          }
        },
        line: 3084
      },
      "192": {
        name: "(anonymous_192)",
        decl: {
          start: {
            line: 3275,
            column: 4
          },
          end: {
            line: 3275,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3275,
            column: 28
          },
          end: {
            line: 3282,
            column: 5
          }
        },
        line: 3275
      },
      "193": {
        name: "(anonymous_193)",
        decl: {
          start: {
            line: 3284,
            column: 4
          },
          end: {
            line: 3284,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3284,
            column: 28
          },
          end: {
            line: 3291,
            column: 5
          }
        },
        line: 3284
      },
      "194": {
        name: "(anonymous_194)",
        decl: {
          start: {
            line: 3292,
            column: 4
          },
          end: {
            line: 3292,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3292,
            column: 28
          },
          end: {
            line: 3299,
            column: 5
          }
        },
        line: 3292
      },
      "195": {
        name: "(anonymous_195)",
        decl: {
          start: {
            line: 3300,
            column: 4
          },
          end: {
            line: 3300,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3300,
            column: 33
          },
          end: {
            line: 3307,
            column: 5
          }
        },
        line: 3300
      },
      "196": {
        name: "(anonymous_196)",
        decl: {
          start: {
            line: 3309,
            column: 4
          },
          end: {
            line: 3309,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3309,
            column: 34
          },
          end: {
            line: 3316,
            column: 5
          }
        },
        line: 3309
      },
      "197": {
        name: "(anonymous_197)",
        decl: {
          start: {
            line: 3317,
            column: 4
          },
          end: {
            line: 3317,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3317,
            column: 39
          },
          end: {
            line: 3324,
            column: 5
          }
        },
        line: 3317
      },
      "198": {
        name: "(anonymous_198)",
        decl: {
          start: {
            line: 3325,
            column: 4
          },
          end: {
            line: 3325,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3325,
            column: 32
          },
          end: {
            line: 3332,
            column: 5
          }
        },
        line: 3325
      },
      "199": {
        name: "(anonymous_199)",
        decl: {
          start: {
            line: 3333,
            column: 4
          },
          end: {
            line: 3333,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3333,
            column: 29
          },
          end: {
            line: 3340,
            column: 5
          }
        },
        line: 3333
      },
      "200": {
        name: "(anonymous_200)",
        decl: {
          start: {
            line: 3341,
            column: 4
          },
          end: {
            line: 3341,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3341,
            column: 36
          },
          end: {
            line: 3348,
            column: 5
          }
        },
        line: 3341
      },
      "201": {
        name: "(anonymous_201)",
        decl: {
          start: {
            line: 3349,
            column: 4
          },
          end: {
            line: 3349,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3349,
            column: 33
          },
          end: {
            line: 3356,
            column: 5
          }
        },
        line: 3349
      },
      "202": {
        name: "(anonymous_202)",
        decl: {
          start: {
            line: 3357,
            column: 4
          },
          end: {
            line: 3357,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3357,
            column: 35
          },
          end: {
            line: 3364,
            column: 5
          }
        },
        line: 3357
      },
      "203": {
        name: "(anonymous_203)",
        decl: {
          start: {
            line: 3365,
            column: 4
          },
          end: {
            line: 3365,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3365,
            column: 36
          },
          end: {
            line: 3372,
            column: 5
          }
        },
        line: 3365
      },
      "204": {
        name: "(anonymous_204)",
        decl: {
          start: {
            line: 3373,
            column: 4
          },
          end: {
            line: 3373,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3373,
            column: 31
          },
          end: {
            line: 3380,
            column: 5
          }
        },
        line: 3373
      },
      "205": {
        name: "(anonymous_205)",
        decl: {
          start: {
            line: 3381,
            column: 4
          },
          end: {
            line: 3381,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3381,
            column: 36
          },
          end: {
            line: 3389,
            column: 5
          }
        },
        line: 3381
      },
      "206": {
        name: "(anonymous_206)",
        decl: {
          start: {
            line: 3390,
            column: 4
          },
          end: {
            line: 3390,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3390,
            column: 29
          },
          end: {
            line: 3397,
            column: 5
          }
        },
        line: 3390
      },
      "207": {
        name: "(anonymous_207)",
        decl: {
          start: {
            line: 3398,
            column: 4
          },
          end: {
            line: 3398,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3398,
            column: 38
          },
          end: {
            line: 3406,
            column: 5
          }
        },
        line: 3398
      },
      "208": {
        name: "(anonymous_208)",
        decl: {
          start: {
            line: 3407,
            column: 4
          },
          end: {
            line: 3407,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3407,
            column: 33
          },
          end: {
            line: 3415,
            column: 5
          }
        },
        line: 3407
      },
      "209": {
        name: "(anonymous_209)",
        decl: {
          start: {
            line: 3416,
            column: 4
          },
          end: {
            line: 3416,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3416,
            column: 26
          },
          end: {
            line: 3423,
            column: 5
          }
        },
        line: 3416
      },
      "210": {
        name: "(anonymous_210)",
        decl: {
          start: {
            line: 3424,
            column: 4
          },
          end: {
            line: 3424,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3424,
            column: 35
          },
          end: {
            line: 3432,
            column: 5
          }
        },
        line: 3424
      },
      "211": {
        name: "(anonymous_211)",
        decl: {
          start: {
            line: 3433,
            column: 4
          },
          end: {
            line: 3433,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3433,
            column: 36
          },
          end: {
            line: 3441,
            column: 5
          }
        },
        line: 3433
      },
      "212": {
        name: "(anonymous_212)",
        decl: {
          start: {
            line: 3442,
            column: 4
          },
          end: {
            line: 3442,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3442,
            column: 29
          },
          end: {
            line: 3449,
            column: 5
          }
        },
        line: 3442
      },
      "213": {
        name: "(anonymous_213)",
        decl: {
          start: {
            line: 3450,
            column: 4
          },
          end: {
            line: 3450,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3450,
            column: 38
          },
          end: {
            line: 3458,
            column: 5
          }
        },
        line: 3450
      },
      "214": {
        name: "(anonymous_214)",
        decl: {
          start: {
            line: 3459,
            column: 4
          },
          end: {
            line: 3459,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3459,
            column: 35
          },
          end: {
            line: 3467,
            column: 5
          }
        },
        line: 3459
      },
      "215": {
        name: "(anonymous_215)",
        decl: {
          start: {
            line: 3468,
            column: 4
          },
          end: {
            line: 3468,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3468,
            column: 28
          },
          end: {
            line: 3475,
            column: 5
          }
        },
        line: 3468
      },
      "216": {
        name: "(anonymous_216)",
        decl: {
          start: {
            line: 3476,
            column: 4
          },
          end: {
            line: 3476,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3476,
            column: 37
          },
          end: {
            line: 3484,
            column: 5
          }
        },
        line: 3476
      },
      "217": {
        name: "(anonymous_217)",
        decl: {
          start: {
            line: 3540,
            column: 4
          },
          end: {
            line: 3540,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3540,
            column: 29
          },
          end: {
            line: 3547,
            column: 5
          }
        },
        line: 3540
      },
      "218": {
        name: "(anonymous_218)",
        decl: {
          start: {
            line: 3548,
            column: 4
          },
          end: {
            line: 3548,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3548,
            column: 25
          },
          end: {
            line: 3555,
            column: 5
          }
        },
        line: 3548
      },
      "219": {
        name: "(anonymous_219)",
        decl: {
          start: {
            line: 3556,
            column: 4
          },
          end: {
            line: 3556,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3556,
            column: 30
          },
          end: {
            line: 3563,
            column: 5
          }
        },
        line: 3556
      },
      "220": {
        name: "(anonymous_220)",
        decl: {
          start: {
            line: 3564,
            column: 4
          },
          end: {
            line: 3564,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3564,
            column: 30
          },
          end: {
            line: 3571,
            column: 5
          }
        },
        line: 3564
      },
      "221": {
        name: "(anonymous_221)",
        decl: {
          start: {
            line: 3572,
            column: 4
          },
          end: {
            line: 3572,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3572,
            column: 31
          },
          end: {
            line: 3574,
            column: 5
          }
        },
        line: 3572
      },
      "222": {
        name: "(anonymous_222)",
        decl: {
          start: {
            line: 3575,
            column: 4
          },
          end: {
            line: 3575,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3575,
            column: 33
          },
          end: {
            line: 3582,
            column: 5
          }
        },
        line: 3575
      },
      "223": {
        name: "(anonymous_223)",
        decl: {
          start: {
            line: 3735,
            column: 4
          },
          end: {
            line: 3735,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3735,
            column: 28
          },
          end: {
            line: 3742,
            column: 5
          }
        },
        line: 3735
      },
      "224": {
        name: "(anonymous_224)",
        decl: {
          start: {
            line: 3743,
            column: 4
          },
          end: {
            line: 3743,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3743,
            column: 43
          },
          end: {
            line: 3750,
            column: 5
          }
        },
        line: 3743
      },
      "225": {
        name: "(anonymous_225)",
        decl: {
          start: {
            line: 3751,
            column: 4
          },
          end: {
            line: 3751,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3751,
            column: 41
          },
          end: {
            line: 3758,
            column: 5
          }
        },
        line: 3751
      },
      "226": {
        name: "(anonymous_226)",
        decl: {
          start: {
            line: 3759,
            column: 4
          },
          end: {
            line: 3759,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3759,
            column: 41
          },
          end: {
            line: 3766,
            column: 5
          }
        },
        line: 3759
      },
      "227": {
        name: "(anonymous_227)",
        decl: {
          start: {
            line: 3767,
            column: 4
          },
          end: {
            line: 3767,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3767,
            column: 39
          },
          end: {
            line: 3774,
            column: 5
          }
        },
        line: 3767
      },
      "228": {
        name: "(anonymous_228)",
        decl: {
          start: {
            line: 3775,
            column: 4
          },
          end: {
            line: 3775,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3775,
            column: 43
          },
          end: {
            line: 3782,
            column: 5
          }
        },
        line: 3775
      },
      "229": {
        name: "(anonymous_229)",
        decl: {
          start: {
            line: 3783,
            column: 4
          },
          end: {
            line: 3783,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3783,
            column: 41
          },
          end: {
            line: 3790,
            column: 5
          }
        },
        line: 3783
      },
      "230": {
        name: "(anonymous_230)",
        decl: {
          start: {
            line: 3791,
            column: 4
          },
          end: {
            line: 3791,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3791,
            column: 32
          },
          end: {
            line: 3798,
            column: 5
          }
        },
        line: 3791
      },
      "231": {
        name: "(anonymous_231)",
        decl: {
          start: {
            line: 3799,
            column: 4
          },
          end: {
            line: 3799,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3799,
            column: 31
          },
          end: {
            line: 3806,
            column: 5
          }
        },
        line: 3799
      },
      "232": {
        name: "(anonymous_232)",
        decl: {
          start: {
            line: 3807,
            column: 4
          },
          end: {
            line: 3807,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3807,
            column: 33
          },
          end: {
            line: 3814,
            column: 5
          }
        },
        line: 3807
      },
      "233": {
        name: "(anonymous_233)",
        decl: {
          start: {
            line: 3815,
            column: 4
          },
          end: {
            line: 3815,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3815,
            column: 32
          },
          end: {
            line: 3822,
            column: 5
          }
        },
        line: 3815
      },
      "234": {
        name: "(anonymous_234)",
        decl: {
          start: {
            line: 3823,
            column: 4
          },
          end: {
            line: 3823,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3823,
            column: 31
          },
          end: {
            line: 3830,
            column: 5
          }
        },
        line: 3823
      },
      "235": {
        name: "(anonymous_235)",
        decl: {
          start: {
            line: 3831,
            column: 4
          },
          end: {
            line: 3831,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3831,
            column: 32
          },
          end: {
            line: 3838,
            column: 5
          }
        },
        line: 3831
      },
      "236": {
        name: "(anonymous_236)",
        decl: {
          start: {
            line: 3839,
            column: 4
          },
          end: {
            line: 3839,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3839,
            column: 25
          },
          end: {
            line: 3846,
            column: 5
          }
        },
        line: 3839
      },
      "237": {
        name: "(anonymous_237)",
        decl: {
          start: {
            line: 3847,
            column: 4
          },
          end: {
            line: 3847,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3847,
            column: 29
          },
          end: {
            line: 3854,
            column: 5
          }
        },
        line: 3847
      },
      "238": {
        name: "(anonymous_238)",
        decl: {
          start: {
            line: 3855,
            column: 4
          },
          end: {
            line: 3855,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3855,
            column: 28
          },
          end: {
            line: 3862,
            column: 5
          }
        },
        line: 3855
      },
      "239": {
        name: "(anonymous_239)",
        decl: {
          start: {
            line: 3863,
            column: 4
          },
          end: {
            line: 3863,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3863,
            column: 28
          },
          end: {
            line: 3870,
            column: 5
          }
        },
        line: 3863
      },
      "240": {
        name: "(anonymous_240)",
        decl: {
          start: {
            line: 3871,
            column: 4
          },
          end: {
            line: 3871,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3871,
            column: 31
          },
          end: {
            line: 3878,
            column: 5
          }
        },
        line: 3871
      },
      "241": {
        name: "(anonymous_241)",
        decl: {
          start: {
            line: 3879,
            column: 4
          },
          end: {
            line: 3879,
            column: 5
          }
        },
        loc: {
          start: {
            line: 3879,
            column: 31
          },
          end: {
            line: 3886,
            column: 5
          }
        },
        line: 3879
      },
      "242": {
        name: "(anonymous_242)",
        decl: {
          start: {
            line: 4178,
            column: 4
          },
          end: {
            line: 4178,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4178,
            column: 35
          },
          end: {
            line: 4180,
            column: 5
          }
        },
        line: 4178
      },
      "243": {
        name: "(anonymous_243)",
        decl: {
          start: {
            line: 4181,
            column: 4
          },
          end: {
            line: 4181,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4181,
            column: 28
          },
          end: {
            line: 4188,
            column: 5
          }
        },
        line: 4181
      },
      "244": {
        name: "(anonymous_244)",
        decl: {
          start: {
            line: 4189,
            column: 4
          },
          end: {
            line: 4189,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4189,
            column: 28
          },
          end: {
            line: 4196,
            column: 5
          }
        },
        line: 4189
      },
      "245": {
        name: "(anonymous_245)",
        decl: {
          start: {
            line: 4197,
            column: 4
          },
          end: {
            line: 4197,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4197,
            column: 28
          },
          end: {
            line: 4204,
            column: 5
          }
        },
        line: 4197
      },
      "246": {
        name: "(anonymous_246)",
        decl: {
          start: {
            line: 4205,
            column: 4
          },
          end: {
            line: 4205,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4205,
            column: 27
          },
          end: {
            line: 4212,
            column: 5
          }
        },
        line: 4205
      },
      "247": {
        name: "(anonymous_247)",
        decl: {
          start: {
            line: 4213,
            column: 4
          },
          end: {
            line: 4213,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4213,
            column: 34
          },
          end: {
            line: 4220,
            column: 5
          }
        },
        line: 4213
      },
      "248": {
        name: "(anonymous_248)",
        decl: {
          start: {
            line: 4221,
            column: 4
          },
          end: {
            line: 4221,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4221,
            column: 39
          },
          end: {
            line: 4228,
            column: 5
          }
        },
        line: 4221
      },
      "249": {
        name: "(anonymous_249)",
        decl: {
          start: {
            line: 4229,
            column: 4
          },
          end: {
            line: 4229,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4229,
            column: 38
          },
          end: {
            line: 4236,
            column: 5
          }
        },
        line: 4229
      },
      "250": {
        name: "(anonymous_250)",
        decl: {
          start: {
            line: 4237,
            column: 4
          },
          end: {
            line: 4237,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4237,
            column: 40
          },
          end: {
            line: 4244,
            column: 5
          }
        },
        line: 4237
      },
      "251": {
        name: "(anonymous_251)",
        decl: {
          start: {
            line: 4245,
            column: 4
          },
          end: {
            line: 4245,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4245,
            column: 33
          },
          end: {
            line: 4252,
            column: 5
          }
        },
        line: 4245
      },
      "252": {
        name: "(anonymous_252)",
        decl: {
          start: {
            line: 4253,
            column: 4
          },
          end: {
            line: 4253,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4253,
            column: 30
          },
          end: {
            line: 4260,
            column: 5
          }
        },
        line: 4253
      },
      "253": {
        name: "(anonymous_253)",
        decl: {
          start: {
            line: 4261,
            column: 4
          },
          end: {
            line: 4261,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4261,
            column: 27
          },
          end: {
            line: 4268,
            column: 5
          }
        },
        line: 4261
      },
      "254": {
        name: "(anonymous_254)",
        decl: {
          start: {
            line: 4269,
            column: 4
          },
          end: {
            line: 4269,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4269,
            column: 36
          },
          end: {
            line: 4276,
            column: 5
          }
        },
        line: 4269
      },
      "255": {
        name: "(anonymous_255)",
        decl: {
          start: {
            line: 4277,
            column: 4
          },
          end: {
            line: 4277,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4277,
            column: 38
          },
          end: {
            line: 4284,
            column: 5
          }
        },
        line: 4277
      },
      "256": {
        name: "(anonymous_256)",
        decl: {
          start: {
            line: 4285,
            column: 4
          },
          end: {
            line: 4285,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4285,
            column: 42
          },
          end: {
            line: 4292,
            column: 5
          }
        },
        line: 4285
      },
      "257": {
        name: "(anonymous_257)",
        decl: {
          start: {
            line: 4293,
            column: 4
          },
          end: {
            line: 4293,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4293,
            column: 39
          },
          end: {
            line: 4300,
            column: 5
          }
        },
        line: 4293
      },
      "258": {
        name: "(anonymous_258)",
        decl: {
          start: {
            line: 4301,
            column: 4
          },
          end: {
            line: 4301,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4301,
            column: 37
          },
          end: {
            line: 4308,
            column: 5
          }
        },
        line: 4301
      },
      "259": {
        name: "(anonymous_259)",
        decl: {
          start: {
            line: 4309,
            column: 4
          },
          end: {
            line: 4309,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4309,
            column: 34
          },
          end: {
            line: 4316,
            column: 5
          }
        },
        line: 4309
      },
      "260": {
        name: "(anonymous_260)",
        decl: {
          start: {
            line: 4317,
            column: 4
          },
          end: {
            line: 4317,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4317,
            column: 36
          },
          end: {
            line: 4324,
            column: 5
          }
        },
        line: 4317
      },
      "261": {
        name: "(anonymous_261)",
        decl: {
          start: {
            line: 4325,
            column: 4
          },
          end: {
            line: 4325,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4325,
            column: 37
          },
          end: {
            line: 4332,
            column: 5
          }
        },
        line: 4325
      },
      "262": {
        name: "(anonymous_262)",
        decl: {
          start: {
            line: 4333,
            column: 4
          },
          end: {
            line: 4333,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4333,
            column: 35
          },
          end: {
            line: 4340,
            column: 5
          }
        },
        line: 4333
      },
      "263": {
        name: "(anonymous_263)",
        decl: {
          start: {
            line: 4341,
            column: 4
          },
          end: {
            line: 4341,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4341,
            column: 38
          },
          end: {
            line: 4348,
            column: 5
          }
        },
        line: 4341
      },
      "264": {
        name: "(anonymous_264)",
        decl: {
          start: {
            line: 4349,
            column: 4
          },
          end: {
            line: 4349,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4349,
            column: 40
          },
          end: {
            line: 4356,
            column: 5
          }
        },
        line: 4349
      },
      "265": {
        name: "(anonymous_265)",
        decl: {
          start: {
            line: 4357,
            column: 4
          },
          end: {
            line: 4357,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4357,
            column: 41
          },
          end: {
            line: 4364,
            column: 5
          }
        },
        line: 4357
      },
      "266": {
        name: "(anonymous_266)",
        decl: {
          start: {
            line: 4365,
            column: 4
          },
          end: {
            line: 4365,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4365,
            column: 39
          },
          end: {
            line: 4372,
            column: 5
          }
        },
        line: 4365
      },
      "267": {
        name: "(anonymous_267)",
        decl: {
          start: {
            line: 4373,
            column: 4
          },
          end: {
            line: 4373,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4373,
            column: 33
          },
          end: {
            line: 4380,
            column: 5
          }
        },
        line: 4373
      },
      "268": {
        name: "(anonymous_268)",
        decl: {
          start: {
            line: 4381,
            column: 4
          },
          end: {
            line: 4381,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4381,
            column: 32
          },
          end: {
            line: 4388,
            column: 5
          }
        },
        line: 4381
      },
      "269": {
        name: "(anonymous_269)",
        decl: {
          start: {
            line: 4389,
            column: 4
          },
          end: {
            line: 4389,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4389,
            column: 31
          },
          end: {
            line: 4396,
            column: 5
          }
        },
        line: 4389
      },
      "270": {
        name: "(anonymous_270)",
        decl: {
          start: {
            line: 4397,
            column: 4
          },
          end: {
            line: 4397,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4397,
            column: 33
          },
          end: {
            line: 4404,
            column: 5
          }
        },
        line: 4397
      },
      "271": {
        name: "(anonymous_271)",
        decl: {
          start: {
            line: 4405,
            column: 4
          },
          end: {
            line: 4405,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4405,
            column: 32
          },
          end: {
            line: 4412,
            column: 5
          }
        },
        line: 4405
      },
      "272": {
        name: "(anonymous_272)",
        decl: {
          start: {
            line: 4413,
            column: 4
          },
          end: {
            line: 4413,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4413,
            column: 31
          },
          end: {
            line: 4420,
            column: 5
          }
        },
        line: 4413
      },
      "273": {
        name: "(anonymous_273)",
        decl: {
          start: {
            line: 4421,
            column: 4
          },
          end: {
            line: 4421,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4421,
            column: 32
          },
          end: {
            line: 4428,
            column: 5
          }
        },
        line: 4421
      },
      "274": {
        name: "(anonymous_274)",
        decl: {
          start: {
            line: 4429,
            column: 4
          },
          end: {
            line: 4429,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4429,
            column: 25
          },
          end: {
            line: 4436,
            column: 5
          }
        },
        line: 4429
      },
      "275": {
        name: "(anonymous_275)",
        decl: {
          start: {
            line: 4437,
            column: 4
          },
          end: {
            line: 4437,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4437,
            column: 28
          },
          end: {
            line: 4444,
            column: 5
          }
        },
        line: 4437
      },
      "276": {
        name: "(anonymous_276)",
        decl: {
          start: {
            line: 4445,
            column: 4
          },
          end: {
            line: 4445,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4445,
            column: 28
          },
          end: {
            line: 4452,
            column: 5
          }
        },
        line: 4445
      },
      "277": {
        name: "(anonymous_277)",
        decl: {
          start: {
            line: 4453,
            column: 4
          },
          end: {
            line: 4453,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4453,
            column: 29
          },
          end: {
            line: 4460,
            column: 5
          }
        },
        line: 4453
      },
      "278": {
        name: "(anonymous_278)",
        decl: {
          start: {
            line: 4515,
            column: 4
          },
          end: {
            line: 4515,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4515,
            column: 31
          },
          end: {
            line: 4522,
            column: 5
          }
        },
        line: 4515
      },
      "279": {
        name: "(anonymous_279)",
        decl: {
          start: {
            line: 4523,
            column: 4
          },
          end: {
            line: 4523,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4523,
            column: 31
          },
          end: {
            line: 4530,
            column: 5
          }
        },
        line: 4523
      },
      "280": {
        name: "(anonymous_280)",
        decl: {
          start: {
            line: 4531,
            column: 4
          },
          end: {
            line: 4531,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4531,
            column: 29
          },
          end: {
            line: 4538,
            column: 5
          }
        },
        line: 4531
      },
      "281": {
        name: "(anonymous_281)",
        decl: {
          start: {
            line: 4539,
            column: 4
          },
          end: {
            line: 4539,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4539,
            column: 32
          },
          end: {
            line: 4546,
            column: 5
          }
        },
        line: 4539
      },
      "282": {
        name: "(anonymous_282)",
        decl: {
          start: {
            line: 4547,
            column: 4
          },
          end: {
            line: 4547,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4547,
            column: 32
          },
          end: {
            line: 4554,
            column: 5
          }
        },
        line: 4547
      },
      "283": {
        name: "(anonymous_283)",
        decl: {
          start: {
            line: 4555,
            column: 4
          },
          end: {
            line: 4555,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4555,
            column: 28
          },
          end: {
            line: 4562,
            column: 5
          }
        },
        line: 4555
      },
      "284": {
        name: "(anonymous_284)",
        decl: {
          start: {
            line: 4603,
            column: 4
          },
          end: {
            line: 4603,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4603,
            column: 31
          },
          end: {
            line: 4610,
            column: 5
          }
        },
        line: 4603
      },
      "285": {
        name: "(anonymous_285)",
        decl: {
          start: {
            line: 4611,
            column: 4
          },
          end: {
            line: 4611,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4611,
            column: 36
          },
          end: {
            line: 4618,
            column: 5
          }
        },
        line: 4611
      },
      "286": {
        name: "(anonymous_286)",
        decl: {
          start: {
            line: 4619,
            column: 4
          },
          end: {
            line: 4619,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4619,
            column: 38
          },
          end: {
            line: 4626,
            column: 5
          }
        },
        line: 4619
      },
      "287": {
        name: "(anonymous_287)",
        decl: {
          start: {
            line: 4627,
            column: 4
          },
          end: {
            line: 4627,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4627,
            column: 29
          },
          end: {
            line: 4634,
            column: 5
          }
        },
        line: 4627
      },
      "288": {
        name: "(anonymous_288)",
        decl: {
          start: {
            line: 4658,
            column: 4
          },
          end: {
            line: 4658,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4658,
            column: 24
          },
          end: {
            line: 4687,
            column: 5
          }
        },
        line: 4658
      },
      "289": {
        name: "(anonymous_289)",
        decl: {
          start: {
            line: 4688,
            column: 4
          },
          end: {
            line: 4688,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4688,
            column: 29
          },
          end: {
            line: 4695,
            column: 5
          }
        },
        line: 4688
      },
      "290": {
        name: "(anonymous_290)",
        decl: {
          start: {
            line: 4790,
            column: 4
          },
          end: {
            line: 4790,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4790,
            column: 30
          },
          end: {
            line: 4797,
            column: 5
          }
        },
        line: 4790
      },
      "291": {
        name: "(anonymous_291)",
        decl: {
          start: {
            line: 4798,
            column: 4
          },
          end: {
            line: 4798,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4798,
            column: 31
          },
          end: {
            line: 4805,
            column: 5
          }
        },
        line: 4798
      },
      "292": {
        name: "(anonymous_292)",
        decl: {
          start: {
            line: 4806,
            column: 4
          },
          end: {
            line: 4806,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4806,
            column: 31
          },
          end: {
            line: 4813,
            column: 5
          }
        },
        line: 4806
      },
      "293": {
        name: "(anonymous_293)",
        decl: {
          start: {
            line: 4814,
            column: 4
          },
          end: {
            line: 4814,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4814,
            column: 31
          },
          end: {
            line: 4821,
            column: 5
          }
        },
        line: 4814
      },
      "294": {
        name: "(anonymous_294)",
        decl: {
          start: {
            line: 4822,
            column: 4
          },
          end: {
            line: 4822,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4822,
            column: 33
          },
          end: {
            line: 4829,
            column: 5
          }
        },
        line: 4822
      },
      "295": {
        name: "(anonymous_295)",
        decl: {
          start: {
            line: 4830,
            column: 4
          },
          end: {
            line: 4830,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4830,
            column: 39
          },
          end: {
            line: 4837,
            column: 5
          }
        },
        line: 4830
      },
      "296": {
        name: "(anonymous_296)",
        decl: {
          start: {
            line: 4838,
            column: 4
          },
          end: {
            line: 4838,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4838,
            column: 34
          },
          end: {
            line: 4845,
            column: 5
          }
        },
        line: 4838
      },
      "297": {
        name: "(anonymous_297)",
        decl: {
          start: {
            line: 4846,
            column: 4
          },
          end: {
            line: 4846,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4846,
            column: 40
          },
          end: {
            line: 4853,
            column: 5
          }
        },
        line: 4846
      },
      "298": {
        name: "(anonymous_298)",
        decl: {
          start: {
            line: 4854,
            column: 4
          },
          end: {
            line: 4854,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4854,
            column: 28
          },
          end: {
            line: 4861,
            column: 5
          }
        },
        line: 4854
      },
      "299": {
        name: "(anonymous_299)",
        decl: {
          start: {
            line: 4862,
            column: 4
          },
          end: {
            line: 4862,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4862,
            column: 34
          },
          end: {
            line: 4869,
            column: 5
          }
        },
        line: 4862
      },
      "300": {
        name: "(anonymous_300)",
        decl: {
          start: {
            line: 4870,
            column: 4
          },
          end: {
            line: 4870,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4870,
            column: 38
          },
          end: {
            line: 4877,
            column: 5
          }
        },
        line: 4870
      },
      "301": {
        name: "(anonymous_301)",
        decl: {
          start: {
            line: 4901,
            column: 4
          },
          end: {
            line: 4901,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4901,
            column: 29
          },
          end: {
            line: 4908,
            column: 5
          }
        },
        line: 4901
      },
      "302": {
        name: "(anonymous_302)",
        decl: {
          start: {
            line: 4909,
            column: 4
          },
          end: {
            line: 4909,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4909,
            column: 31
          },
          end: {
            line: 4916,
            column: 5
          }
        },
        line: 4909
      },
      "303": {
        name: "(anonymous_303)",
        decl: {
          start: {
            line: 4941,
            column: 4
          },
          end: {
            line: 4941,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4941,
            column: 41
          },
          end: {
            line: 4948,
            column: 5
          }
        },
        line: 4941
      },
      "304": {
        name: "(anonymous_304)",
        decl: {
          start: {
            line: 4949,
            column: 4
          },
          end: {
            line: 4949,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4949,
            column: 32
          },
          end: {
            line: 4956,
            column: 5
          }
        },
        line: 4949
      },
      "305": {
        name: "(anonymous_305)",
        decl: {
          start: {
            line: 4973,
            column: 4
          },
          end: {
            line: 4973,
            column: 5
          }
        },
        loc: {
          start: {
            line: 4973,
            column: 31
          },
          end: {
            line: 4980,
            column: 5
          }
        },
        line: 4973
      },
      "306": {
        name: "(anonymous_306)",
        decl: {
          start: {
            line: 5027,
            column: 16
          },
          end: {
            line: 5027,
            column: 17
          }
        },
        loc: {
          start: {
            line: 5027,
            column: 32
          },
          end: {
            line: 5027,
            column: 60
          }
        },
        line: 5027
      },
      "307": {
        name: "(anonymous_307)",
        decl: {
          start: {
            line: 5073,
            column: 4
          },
          end: {
            line: 5073,
            column: 5
          }
        },
        loc: {
          start: {
            line: 5073,
            column: 28
          },
          end: {
            line: 5091,
            column: 5
          }
        },
        line: 5073
      },
      "308": {
        name: "(anonymous_308)",
        decl: {
          start: {
            line: 5092,
            column: 4
          },
          end: {
            line: 5092,
            column: 5
          }
        },
        loc: {
          start: {
            line: 5092,
            column: 30
          },
          end: {
            line: 5099,
            column: 5
          }
        },
        line: 5092
      },
      "309": {
        name: "(anonymous_309)",
        decl: {
          start: {
            line: 5100,
            column: 4
          },
          end: {
            line: 5100,
            column: 5
          }
        },
        loc: {
          start: {
            line: 5100,
            column: 30
          },
          end: {
            line: 5107,
            column: 5
          }
        },
        line: 5100
      },
      "310": {
        name: "(anonymous_310)",
        decl: {
          start: {
            line: 5108,
            column: 4
          },
          end: {
            line: 5108,
            column: 5
          }
        },
        loc: {
          start: {
            line: 5108,
            column: 39
          },
          end: {
            line: 5115,
            column: 5
          }
        },
        line: 5108
      },
      "311": {
        name: "(anonymous_311)",
        decl: {
          start: {
            line: 5116,
            column: 4
          },
          end: {
            line: 5116,
            column: 5
          }
        },
        loc: {
          start: {
            line: 5116,
            column: 38
          },
          end: {
            line: 5123,
            column: 5
          }
        },
        line: 5116
      },
      "312": {
        name: "(anonymous_312)",
        decl: {
          start: {
            line: 5124,
            column: 4
          },
          end: {
            line: 5124,
            column: 5
          }
        },
        loc: {
          start: {
            line: 5124,
            column: 25
          },
          end: {
            line: 5132,
            column: 5
          }
        },
        line: 5124
      },
      "313": {
        name: "(anonymous_313)",
        decl: {
          start: {
            line: 5133,
            column: 4
          },
          end: {
            line: 5133,
            column: 5
          }
        },
        loc: {
          start: {
            line: 5133,
            column: 30
          },
          end: {
            line: 5141,
            column: 5
          }
        },
        line: 5133
      },
      "314": {
        name: "(anonymous_314)",
        decl: {
          start: {
            line: 5142,
            column: 4
          },
          end: {
            line: 5142,
            column: 5
          }
        },
        loc: {
          start: {
            line: 5142,
            column: 29
          },
          end: {
            line: 5150,
            column: 5
          }
        },
        line: 5142
      },
      "315": {
        name: "(anonymous_315)",
        decl: {
          start: {
            line: 5151,
            column: 4
          },
          end: {
            line: 5151,
            column: 5
          }
        },
        loc: {
          start: {
            line: 5151,
            column: 35
          },
          end: {
            line: 5159,
            column: 5
          }
        },
        line: 5151
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 50,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 50,
            column: 5
          }
        }, {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 50,
            column: 5
          }
        }],
        line: 47
      },
      "1": {
        loc: {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 58,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 58,
            column: 35
          }
        }, {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 58,
            column: 35
          }
        }],
        line: 58
      },
      "2": {
        loc: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 63,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 63,
            column: 3
          }
        }, {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 63,
            column: 3
          }
        }],
        line: 59
      },
      "3": {
        loc: {
          start: {
            line: 61,
            column: 9
          },
          end: {
            line: 63,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 61,
            column: 9
          },
          end: {
            line: 63,
            column: 3
          }
        }, {
          start: {
            line: 61,
            column: 9
          },
          end: {
            line: 63,
            column: 3
          }
        }],
        line: 61
      },
      "4": {
        loc: {
          start: {
            line: 64,
            column: 2
          },
          end: {
            line: 64,
            column: 50
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 2
          },
          end: {
            line: 64,
            column: 50
          }
        }, {
          start: {
            line: 64,
            column: 2
          },
          end: {
            line: 64,
            column: 50
          }
        }],
        line: 64
      },
      "5": {
        loc: {
          start: {
            line: 73,
            column: 26
          },
          end: {
            line: 73,
            column: 37
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 73,
            column: 35
          },
          end: {
            line: 73,
            column: 37
          }
        }],
        line: 73
      },
      "6": {
        loc: {
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 76,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 76,
            column: 3
          }
        }, {
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 76,
            column: 3
          }
        }],
        line: 74
      },
      "7": {
        loc: {
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 19
          }
        }, {
          start: {
            line: 74,
            column: 23
          },
          end: {
            line: 74,
            column: 56
          }
        }],
        line: 74
      },
      "8": {
        loc: {
          start: {
            line: 77,
            column: 19
          },
          end: {
            line: 77,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 77,
            column: 19
          },
          end: {
            line: 77,
            column: 32
          }
        }, {
          start: {
            line: 77,
            column: 36
          },
          end: {
            line: 77,
            column: 42
          }
        }],
        line: 77
      },
      "9": {
        loc: {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 92,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 92,
            column: 3
          }
        }, {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 92,
            column: 3
          }
        }],
        line: 84
      },
      "10": {
        loc: {
          start: {
            line: 96,
            column: 21
          },
          end: {
            line: 96,
            column: 48
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 96,
            column: 28
          },
          end: {
            line: 96,
            column: 48
          }
        }],
        line: 96
      },
      "11": {
        loc: {
          start: {
            line: 96,
            column: 50
          },
          end: {
            line: 96,
            column: 62
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 96,
            column: 58
          },
          end: {
            line: 96,
            column: 62
          }
        }],
        line: 96
      },
      "12": {
        loc: {
          start: {
            line: 97,
            column: 2
          },
          end: {
            line: 97,
            column: 62
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 97,
            column: 2
          },
          end: {
            line: 97,
            column: 62
          }
        }, {
          start: {
            line: 97,
            column: 2
          },
          end: {
            line: 97,
            column: 62
          }
        }],
        line: 97
      },
      "13": {
        loc: {
          start: {
            line: 97,
            column: 6
          },
          end: {
            line: 97,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 97,
            column: 6
          },
          end: {
            line: 97,
            column: 11
          }
        }, {
          start: {
            line: 97,
            column: 15
          },
          end: {
            line: 97,
            column: 34
          }
        }],
        line: 97
      },
      "14": {
        loc: {
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        }, {
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        }],
        line: 106
      },
      "15": {
        loc: {
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        }, {
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        }],
        line: 108
      },
      "16": {
        loc: {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 120,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 120,
            column: 5
          }
        }, {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 120,
            column: 5
          }
        }],
        line: 114
      },
      "17": {
        loc: {
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 119,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 119,
            column: 7
          }
        }, {
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 119,
            column: 7
          }
        }],
        line: 115
      },
      "18": {
        loc: {
          start: {
            line: 2093,
            column: 19
          },
          end: {
            line: 2093,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 2093,
            column: 43
          },
          end: {
            line: 2093,
            column: 44
          }
        }, {
          start: {
            line: 2093,
            column: 47
          },
          end: {
            line: 2093,
            column: 62
          }
        }],
        line: 2093
      },
      "19": {
        loc: {
          start: {
            line: 4660,
            column: 6
          },
          end: {
            line: 4685,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 4660,
            column: 6
          },
          end: {
            line: 4685,
            column: 7
          }
        }, {
          start: {
            line: 4660,
            column: 6
          },
          end: {
            line: 4685,
            column: 7
          }
        }],
        line: 4660
      },
      "20": {
        loc: {
          start: {
            line: 4672,
            column: 13
          },
          end: {
            line: 4685,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 4672,
            column: 13
          },
          end: {
            line: 4685,
            column: 7
          }
        }, {
          start: {
            line: 4672,
            column: 13
          },
          end: {
            line: 4685,
            column: 7
          }
        }],
        line: 4672
      },
      "21": {
        loc: {
          start: {
            line: 5027,
            column: 32
          },
          end: {
            line: 5027,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 5027,
            column: 47
          },
          end: {
            line: 5027,
            column: 56
          }
        }, {
          start: {
            line: 5027,
            column: 59
          },
          end: {
            line: 5027,
            column: 60
          }
        }],
        line: 5027
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0,
      "184": 0,
      "185": 0,
      "186": 0,
      "187": 0,
      "188": 0,
      "189": 0,
      "190": 0,
      "191": 0,
      "192": 0,
      "193": 0,
      "194": 0,
      "195": 0,
      "196": 0,
      "197": 0,
      "198": 0,
      "199": 0,
      "200": 0,
      "201": 0,
      "202": 0,
      "203": 0,
      "204": 0,
      "205": 0,
      "206": 0,
      "207": 0,
      "208": 0,
      "209": 0,
      "210": 0,
      "211": 0,
      "212": 0,
      "213": 0,
      "214": 0,
      "215": 0,
      "216": 0,
      "217": 0,
      "218": 0,
      "219": 0,
      "220": 0,
      "221": 0,
      "222": 0,
      "223": 0,
      "224": 0,
      "225": 0,
      "226": 0,
      "227": 0,
      "228": 0,
      "229": 0,
      "230": 0,
      "231": 0,
      "232": 0,
      "233": 0,
      "234": 0,
      "235": 0,
      "236": 0,
      "237": 0,
      "238": 0,
      "239": 0,
      "240": 0,
      "241": 0,
      "242": 0,
      "243": 0,
      "244": 0,
      "245": 0,
      "246": 0,
      "247": 0,
      "248": 0,
      "249": 0,
      "250": 0,
      "251": 0,
      "252": 0,
      "253": 0,
      "254": 0,
      "255": 0,
      "256": 0,
      "257": 0,
      "258": 0,
      "259": 0,
      "260": 0,
      "261": 0,
      "262": 0,
      "263": 0,
      "264": 0,
      "265": 0,
      "266": 0,
      "267": 0,
      "268": 0,
      "269": 0,
      "270": 0,
      "271": 0,
      "272": 0,
      "273": 0,
      "274": 0,
      "275": 0,
      "276": 0,
      "277": 0,
      "278": 0,
      "279": 0,
      "280": 0,
      "281": 0,
      "282": 0,
      "283": 0,
      "284": 0,
      "285": 0,
      "286": 0,
      "287": 0,
      "288": 0,
      "289": 0,
      "290": 0,
      "291": 0,
      "292": 0,
      "293": 0,
      "294": 0,
      "295": 0,
      "296": 0,
      "297": 0,
      "298": 0,
      "299": 0,
      "300": 0,
      "301": 0,
      "302": 0,
      "303": 0,
      "304": 0,
      "305": 0,
      "306": 0,
      "307": 0,
      "308": 0,
      "309": 0,
      "310": 0,
      "311": 0,
      "312": 0,
      "313": 0,
      "314": 0,
      "315": 0,
      "316": 0,
      "317": 0,
      "318": 0,
      "319": 0,
      "320": 0,
      "321": 0,
      "322": 0,
      "323": 0,
      "324": 0,
      "325": 0,
      "326": 0,
      "327": 0,
      "328": 0,
      "329": 0,
      "330": 0,
      "331": 0,
      "332": 0,
      "333": 0,
      "334": 0,
      "335": 0,
      "336": 0,
      "337": 0,
      "338": 0,
      "339": 0,
      "340": 0,
      "341": 0,
      "342": 0,
      "343": 0,
      "344": 0,
      "345": 0,
      "346": 0,
      "347": 0,
      "348": 0,
      "349": 0,
      "350": 0,
      "351": 0,
      "352": 0,
      "353": 0,
      "354": 0,
      "355": 0,
      "356": 0,
      "357": 0,
      "358": 0,
      "359": 0,
      "360": 0,
      "361": 0,
      "362": 0,
      "363": 0,
      "364": 0,
      "365": 0,
      "366": 0,
      "367": 0,
      "368": 0,
      "369": 0,
      "370": 0,
      "371": 0,
      "372": 0,
      "373": 0,
      "374": 0,
      "375": 0,
      "376": 0,
      "377": 0,
      "378": 0,
      "379": 0,
      "380": 0,
      "381": 0,
      "382": 0,
      "383": 0,
      "384": 0,
      "385": 0,
      "386": 0,
      "387": 0,
      "388": 0,
      "389": 0,
      "390": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0,
      "184": 0,
      "185": 0,
      "186": 0,
      "187": 0,
      "188": 0,
      "189": 0,
      "190": 0,
      "191": 0,
      "192": 0,
      "193": 0,
      "194": 0,
      "195": 0,
      "196": 0,
      "197": 0,
      "198": 0,
      "199": 0,
      "200": 0,
      "201": 0,
      "202": 0,
      "203": 0,
      "204": 0,
      "205": 0,
      "206": 0,
      "207": 0,
      "208": 0,
      "209": 0,
      "210": 0,
      "211": 0,
      "212": 0,
      "213": 0,
      "214": 0,
      "215": 0,
      "216": 0,
      "217": 0,
      "218": 0,
      "219": 0,
      "220": 0,
      "221": 0,
      "222": 0,
      "223": 0,
      "224": 0,
      "225": 0,
      "226": 0,
      "227": 0,
      "228": 0,
      "229": 0,
      "230": 0,
      "231": 0,
      "232": 0,
      "233": 0,
      "234": 0,
      "235": 0,
      "236": 0,
      "237": 0,
      "238": 0,
      "239": 0,
      "240": 0,
      "241": 0,
      "242": 0,
      "243": 0,
      "244": 0,
      "245": 0,
      "246": 0,
      "247": 0,
      "248": 0,
      "249": 0,
      "250": 0,
      "251": 0,
      "252": 0,
      "253": 0,
      "254": 0,
      "255": 0,
      "256": 0,
      "257": 0,
      "258": 0,
      "259": 0,
      "260": 0,
      "261": 0,
      "262": 0,
      "263": 0,
      "264": 0,
      "265": 0,
      "266": 0,
      "267": 0,
      "268": 0,
      "269": 0,
      "270": 0,
      "271": 0,
      "272": 0,
      "273": 0,
      "274": 0,
      "275": 0,
      "276": 0,
      "277": 0,
      "278": 0,
      "279": 0,
      "280": 0,
      "281": 0,
      "282": 0,
      "283": 0,
      "284": 0,
      "285": 0,
      "286": 0,
      "287": 0,
      "288": 0,
      "289": 0,
      "290": 0,
      "291": 0,
      "292": 0,
      "293": 0,
      "294": 0,
      "295": 0,
      "296": 0,
      "297": 0,
      "298": 0,
      "299": 0,
      "300": 0,
      "301": 0,
      "302": 0,
      "303": 0,
      "304": 0,
      "305": 0,
      "306": 0,
      "307": 0,
      "308": 0,
      "309": 0,
      "310": 0,
      "311": 0,
      "312": 0,
      "313": 0,
      "314": 0,
      "315": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0],
      "11": [0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { darken, fade } from './color';
import { set as configSet } from '../config';
import { entries } from './objects';
import { isFunc } from './is';
import hash from './hash';
import { paginationClass } from '../Pagination/styles';
import { checkinputClass } from '../Checkbox/styles';
import { buttonClass } from '../Button/styles';
import { selectClass } from '../Select/styles';
import { formClass } from '../Form/styles';
import { menuClass } from '../Menu/styles';
import { alertClass } from '../Alert/styles';
import { messageClass } from '../Message/styles';
import { modalClass } from '../Modal/styles';
import { popoverClass } from '../Popover/styles';
import { datepickerClass } from '../DatePicker/styles';
import { dropdownClass } from '../Dropdown/styles';
import { inputClass } from '../Input/styles';
import { cardClass } from '../Card/styles';
import { tooltipClass } from '../Tooltip/styles';
import { sliderClass } from '../Slider/styles';
import { tagClass } from '../Tag/styles';
import { exposeClass } from '../styles/expose';
var config = (cov_1w0wl6gh7m.s[0]++, {
  injectType: 'body',
  target: undefined
});
var computedCache = (cov_1w0wl6gh7m.s[1]++, {});
var styleObj = (cov_1w0wl6gh7m.s[2]++, {});
export function setThemeConfig(c) {
  cov_1w0wl6gh7m.f[0]++;
  cov_1w0wl6gh7m.s[3]++;
  Object.keys(c).forEach(function (key) {
    cov_1w0wl6gh7m.f[1]++;
    cov_1w0wl6gh7m.s[4]++;

    if (key in config) {
      cov_1w0wl6gh7m.b[0][0]++;
      cov_1w0wl6gh7m.s[5]++;
      // @ts-ignore
      config[key] = c[key];
    } else {
      cov_1w0wl6gh7m.b[0][1]++;
    }
  });
}
export function getThemeConfig(name) {
  cov_1w0wl6gh7m.f[2]++;
  cov_1w0wl6gh7m.s[6]++;
  return config[name];
}
export function getThemeTarget() {
  cov_1w0wl6gh7m.f[3]++;

  var _ref = (cov_1w0wl6gh7m.s[7]++, config),
      target = _ref.target;

  cov_1w0wl6gh7m.s[8]++;

  if (!target) {
    cov_1w0wl6gh7m.b[1][0]++;
    cov_1w0wl6gh7m.s[9]++;
    return document.body;
  } else {
    cov_1w0wl6gh7m.b[1][1]++;
  }

  cov_1w0wl6gh7m.s[10]++;

  if (isFunc(target)) {
    cov_1w0wl6gh7m.b[2][0]++;
    cov_1w0wl6gh7m.s[11]++;
    target = target();
  } else {
    cov_1w0wl6gh7m.b[2][1]++;
    cov_1w0wl6gh7m.s[12]++;

    if (typeof target === 'string') {
      cov_1w0wl6gh7m.b[3][0]++;
      cov_1w0wl6gh7m.s[13]++;
      target = document.querySelector(target);
    } else {
      cov_1w0wl6gh7m.b[3][1]++;
    }
  }

  cov_1w0wl6gh7m.s[14]++;

  if (target instanceof HTMLElement) {
    cov_1w0wl6gh7m.b[4][0]++;
    cov_1w0wl6gh7m.s[15]++;
    return target;
  } else {
    cov_1w0wl6gh7m.b[4][1]++;
  }

  cov_1w0wl6gh7m.s[16]++;
  console.error("can not find theme target dom from \"".concat(config.target, "\""));
  cov_1w0wl6gh7m.s[17]++;
  return document.body;
}
export function cleanStyleObj() {
  cov_1w0wl6gh7m.f[4]++;
  cov_1w0wl6gh7m.s[18]++;
  styleObj = {};
}
export function injectTag() {
  var custom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1w0wl6gh7m.b[5][0]++, {});
  cov_1w0wl6gh7m.f[5]++;
  cov_1w0wl6gh7m.s[19]++;

  if ((cov_1w0wl6gh7m.b[7][0]++, config.target) && (cov_1w0wl6gh7m.b[7][1]++, typeof config.target !== 'string')) {
    cov_1w0wl6gh7m.b[6][0]++;
    cov_1w0wl6gh7m.s[20]++;
    console.error('The target of themeConfig must use string when injectType = "tag"');
  } else {
    cov_1w0wl6gh7m.b[6][1]++;
  }

  var selector = (cov_1w0wl6gh7m.s[21]++, (cov_1w0wl6gh7m.b[8][0]++, config.target) || (cov_1w0wl6gh7m.b[8][1]++, 'body'));
  var id = (cov_1w0wl6gh7m.s[22]++, "__shineoutThemeStyleContainer__".concat(hash(selector)));
  var varObj = (cov_1w0wl6gh7m.s[23]++, _objectSpread2(_objectSpread2({}, styleObj), custom));
  var styleText = (cov_1w0wl6gh7m.s[24]++, "".concat(selector, "{").concat(Object.keys(varObj).map(function (key) {
    cov_1w0wl6gh7m.f[6]++;
    cov_1w0wl6gh7m.s[25]++;
    return "".concat(key, ": ").concat(varObj[key]);
  }).join(';'), "}"));
  var el = (cov_1w0wl6gh7m.s[26]++, document.getElementById(id));
  cov_1w0wl6gh7m.s[27]++;

  if (el) {
    cov_1w0wl6gh7m.b[9][0]++;
    cov_1w0wl6gh7m.s[28]++;
    el.innerText = styleText;
  } else {
    cov_1w0wl6gh7m.b[9][1]++;
    var stylee = (cov_1w0wl6gh7m.s[29]++, document.createElement('style'));
    cov_1w0wl6gh7m.s[30]++;
    stylee.setAttribute('type', 'text/css');
    cov_1w0wl6gh7m.s[31]++;
    stylee.setAttribute('id', id);
    cov_1w0wl6gh7m.s[32]++;
    stylee.innerText = styleText;
    cov_1w0wl6gh7m.s[33]++;
    document.head.appendChild(stylee);
  }

  cov_1w0wl6gh7m.s[34]++;
  return id;
}

function getProperty() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1w0wl6gh7m.b[10][0]++, '--btn-hover-darken');
  var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1w0wl6gh7m.b[11][0]++, true);
  cov_1w0wl6gh7m.f[7]++;
  cov_1w0wl6gh7m.s[35]++;

  if ((cov_1w0wl6gh7m.b[13][0]++, cache) && (cov_1w0wl6gh7m.b[13][1]++, computedCache[name])) {
    cov_1w0wl6gh7m.b[12][0]++;
    cov_1w0wl6gh7m.s[36]++;
    return computedCache[name];
  } else {
    cov_1w0wl6gh7m.b[12][1]++;
  }

  cov_1w0wl6gh7m.s[37]++;
  computedCache[name] = getComputedStyle(document.body).getPropertyValue(name).trim();
  cov_1w0wl6gh7m.s[38]++;
  return computedCache[name];
}

function setBodyProperty(colors, value) {
  cov_1w0wl6gh7m.f[8]++;
  cov_1w0wl6gh7m.s[39]++;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = entries(colors)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = _slicedToArray(_step.value, 2),
          cssVar = _step$value[0],
          cssValue = _step$value[1];

      cov_1w0wl6gh7m.s[40]++;

      if (config.injectType === 'body') {
        cov_1w0wl6gh7m.b[14][0]++;

        var _target = (cov_1w0wl6gh7m.s[41]++, getThemeTarget());

        cov_1w0wl6gh7m.s[42]++;

        if (value === undefined) {
          cov_1w0wl6gh7m.b[15][0]++;
          cov_1w0wl6gh7m.s[43]++;

          _target.style.removeProperty(cssVar);
        } else {
          cov_1w0wl6gh7m.b[15][1]++;
          cov_1w0wl6gh7m.s[44]++;

          _target.style.setProperty(cssVar, cssValue);
        }
      } else {
        cov_1w0wl6gh7m.b[14][1]++;
      }

      cov_1w0wl6gh7m.s[45]++;

      if (config.injectType === 'tag') {
        cov_1w0wl6gh7m.b[16][0]++;
        cov_1w0wl6gh7m.s[46]++;

        if (value === undefined) {
          cov_1w0wl6gh7m.b[17][0]++;
          cov_1w0wl6gh7m.s[47]++;
          delete styleObj[cssVar];
        } else {
          cov_1w0wl6gh7m.b[17][1]++;
          cov_1w0wl6gh7m.s[48]++;
          styleObj[cssVar] = cssValue;
        }
      } else {
        cov_1w0wl6gh7m.b[16][1]++;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

var injects = (cov_1w0wl6gh7m.s[49]++, {
  color: {
    info: {
      title: 'Color 颜色',
      name: 'color',
      path: 'Button'
    },
    conf: [{
      name: 'primary',
      type: 'color',
      attr: 'backgroundColor',
      className: buttonClass('primary'),
      desc: '主色'
    }, {
      name: 'infoColor',
      type: 'color',
      attr: 'backgroundColor',
      className: buttonClass('info')
    }, {
      name: 'warning',
      type: 'color',
      attr: 'backgroundColor',
      className: buttonClass('warning')
    }, {
      name: 'danger',
      type: 'color',
      attr: 'backgroundColor',
      className: buttonClass('danger')
    }, {
      name: 'secondary',
      type: 'color',
      attr: 'backgroundColor',
      className: buttonClass('secondary')
    }, {
      name: 'success',
      type: 'color',
      attr: 'backgroundColor',
      className: buttonClass('success')
    }, {
      name: 'gray100',
      type: 'color',
      attr: 'color',
      desc: 'Form, Datepicker, Cascader, Tree, Card, Upload, Pagination, Select',
      className: exposeClass('gray-100')
    }, {
      name: 'gray200',
      type: 'color',
      attr: 'color',
      desc: 'Form, Datepicker, Cascader, Alert, Tabs, Progress',
      className: exposeClass('gray-200')
    }, {
      name: 'gray300',
      type: 'color',
      attr: 'color',
      desc: 'Button, Card, Cascader, Upload, Image, Tooltip',
      className: exposeClass('gray-300')
    }, {
      name: 'gray400',
      type: 'color',
      attr: 'color',
      desc: 'Cascader, Select, TreeSelect, Slider, Upload, Input, Rate',
      className: exposeClass('gray-400')
    }, {
      name: 'gray500',
      type: 'color',
      attr: 'color',
      desc: 'Cascader, Select, Table, TreeSelect, Checkbox, Slider, Tree',
      className: exposeClass('gray-500')
    }, {
      name: 'gray600',
      type: 'color',
      attr: 'color',
      desc: 'Select, Datepicker, TreeSelect, Link-disabled, Table, Pagination, Tree',
      className: exposeClass('gray-600')
    }, {
      name: 'gray700',
      type: 'color',
      attr: 'color',
      desc: 'Table sort icon hover color',
      className: exposeClass('gray-700')
    }, {
      name: 'gray800',
      type: 'color',
      attr: 'color',
      desc: 'Dropdown, Card, Dropdown',
      className: exposeClass('gray-800')
    }, {
      name: 'gray900',
      type: 'color',
      attr: 'color',
      desc: 'text color, Menu',
      className: exposeClass('gray-900')
    }],

    set primary(v) {
      cov_1w0wl6gh7m.f[9]++;
      cov_1w0wl6gh7m.s[50]++;
      setBodyProperty({
        '--primary-color': v,
        '--primary-color-dark-5': darken(v, 5),
        '--primary-color-dark-15': darken(v, 15),
        '--primary-color-dark-btn-hover': darken(v, getProperty()),
        '--primary-color-lighten-40': darken(v, -40),
        '--primary-color-fade-60': fade(v, 0.6),
        '--primary-color-fade-50': fade(v, 0.5),
        '--primary-color-fade-10': fade(v, 0.1),
        '--primary-color-fade-5': fade(v, 0.05),
        '--primary-color-fade-0': fade(v, 0),
        '--primary-color-dark-5_fade-60': fade(darken(v, 5), 0.6),
        '--primary-color-dark-5_fade-0': fade(darken(v, 5), 0)
      }, v);
    },

    set infoColor(v) {
      cov_1w0wl6gh7m.f[10]++;
      cov_1w0wl6gh7m.s[51]++;
      setBodyProperty({
        '--info-color': v,
        '--info-color-dark-5': darken(v, 5),
        '--info-color-fade-60': fade(v, 0.6),
        '--info-color-dark-5_fade-60': fade(darken(v, 5), 0.6),
        '--info-color-fade-0': fade(v, 0),
        '--info-color-dark-5_fade-0': fade(darken(v, 5), 0),
        '--info-color-dark-btn-hover': darken(v, getProperty())
      }, v);
    },

    set warning(v) {
      cov_1w0wl6gh7m.f[11]++;
      cov_1w0wl6gh7m.s[52]++;
      setBodyProperty({
        '--warning-color': v,
        '--warning-color-dark-5': darken(v, 5),
        '--warning-color-fade-60': fade(v, 0.6),
        '--warning-color-dark-5_fade-60': fade(darken(v, 5), 0.6),
        '--warning-color-fade-0': fade(v, 0),
        '--warning-color-dark-5_fade-0': fade(darken(v, 5), 0),
        '--warning-color-dark-btn-hover': darken(v, getProperty())
      }, v);
    },

    set danger(v) {
      cov_1w0wl6gh7m.f[12]++;
      cov_1w0wl6gh7m.s[53]++;
      setBodyProperty({
        '--danger-color': v,
        '--danger-color-fade-25': fade(v, 0.25),
        '--danger-color-dark-5': darken(v, 5),
        '--danger-color-fade-60': fade(v, 0.6),
        '--danger-color-dark-5_fade-60': fade(darken(v, 5), 0.6),
        '--danger-color-fade-0': fade(v, 0),
        '--danger-color-dark-5_fade-0': fade(darken(v, 5), 0),
        '--danger-color-dark-btn-hover': darken(v, getProperty())
      }, v);
    },

    set success(v) {
      cov_1w0wl6gh7m.f[13]++;
      cov_1w0wl6gh7m.s[54]++;
      setBodyProperty({
        '--success-color': v,
        '--success-color-dark-5': darken(v, 5),
        '--success-color-fade-60': fade(v, 0.6),
        '--success-color-dark-5_fade-60': fade(darken(v, 5), 0.6),
        '--success-color-fade-0': fade(v, 0),
        '--success-color-dark-5_fade-0': fade(darken(v, 5), 0),
        '--success-color-dark-btn-hover': darken(v, getProperty())
      }, v);
    },

    set secondary(v) {
      cov_1w0wl6gh7m.f[14]++;
      cov_1w0wl6gh7m.s[55]++;
      setBodyProperty({
        '--secondary-color': v,
        '--secondary-color-dark-5': darken(v, 5),
        '--secondary-color-dark-btn-hover': darken(v, getProperty()),
        '--secondary-color-dark-5_fade-60': fade(darken(v, 5), 0.6),
        '--secondary-color-dark-5_fade-0': fade(darken(v, 5), 0)
      }, v);
    },

    set gray100(v) {
      cov_1w0wl6gh7m.f[15]++;
      cov_1w0wl6gh7m.s[56]++;
      setBodyProperty({
        '--gray-100': v
      }, v);
    },

    set gray200(v) {
      cov_1w0wl6gh7m.f[16]++;
      cov_1w0wl6gh7m.s[57]++;
      setBodyProperty({
        '--gray-200': v,
        '--gray-200-darken-5': darken(v, 5)
      }, v);
    },

    set gray300(v) {
      cov_1w0wl6gh7m.f[17]++;
      cov_1w0wl6gh7m.s[58]++;
      setBodyProperty({
        '--gray-300': v,
        '--gray-300-darken-hover': darken(v, getProperty()),
        '--gray-300-fade-60': fade(v, 0.6),
        '--gray-300-fade-0': fade(v, 0)
      }, v);
    },

    set gray400(v) {
      cov_1w0wl6gh7m.f[18]++;
      cov_1w0wl6gh7m.s[59]++;
      setBodyProperty({
        '--gray-400': v,
        '--gray-400-darken-20': darken(v, 20)
      }, v);
    },

    set gray500(v) {
      cov_1w0wl6gh7m.f[19]++;
      cov_1w0wl6gh7m.s[60]++;
      setBodyProperty({
        '--gray-500': v
      }, v);
    },

    set gray600(v) {
      cov_1w0wl6gh7m.f[20]++;
      cov_1w0wl6gh7m.s[61]++;
      setBodyProperty({
        '--gray-600': v,
        '--gray-600-lighten-15': darken(v, -15)
      }, v);
    },

    set gray700(v) {
      cov_1w0wl6gh7m.f[21]++;
      cov_1w0wl6gh7m.s[62]++;
      setBodyProperty({
        '--gray-700': v
      }, v);
    },

    set gray800(v) {
      cov_1w0wl6gh7m.f[22]++;
      cov_1w0wl6gh7m.s[63]++;
      setBodyProperty({
        '--gray-800': v,
        '--gray-800-darken-5': darken(v, 5)
      }, v);
    },

    set gray900(v) {
      cov_1w0wl6gh7m.f[23]++;
      cov_1w0wl6gh7m.s[64]++;
      setBodyProperty({
        '--gray-900': v,
        '--gray-900-lighten-40': darken(v, -40)
      }, v);
    }

  },
  button: {
    info: {
      title: 'Button 按钮',
      name: 'button',
      path: 'Button'
    },
    conf: [{
      name: 'fontSizeBase',
      attr: 'fontSize',
      type: 'number',
      parser: parseInt,
      className: buttonClass('_'),
      desc: '常规按钮字体大小'
    }, {
      name: 'fontSizeLarge',
      attr: 'fontSize',
      type: 'number',
      parser: parseInt,
      className: buttonClass('large'),
      desc: '大按钮字体大小'
    }, {
      name: 'fontSizeSmall',
      attr: 'fontSize',
      type: 'number',
      parser: parseInt,
      className: buttonClass('small'),
      desc: '小按钮字体大小'
    }, {
      name: 'marginLeft',
      attr: 'marginLeft',
      type: 'number',
      parser: parseInt,
      className: exposeClass('button'),
      desc: '连续按钮间距'
    }, {
      name: 'spinMargin',
      attr: 'marginRight',
      type: 'number',
      parser: parseInt,
      className: buttonClass('spin-ltr'),
      desc: '加载图标与文字间距'
    }, {
      name: 'paddingBaseHorizontal',
      attr: 'paddingLeft',
      type: 'number',
      parser: parseInt,
      className: buttonClass('_'),
      desc: '常规按钮水平内边距'
    }, {
      name: 'paddingBaseVertical',
      attr: 'paddingTop',
      type: 'number',
      parser: parseInt,
      className: buttonClass('_'),
      desc: '常规按钮垂直内边距'
    }, {
      name: 'paddingLargeHorizontal',
      attr: 'paddingLeft',
      type: 'number',
      parser: parseInt,
      className: buttonClass('large'),
      desc: '大按钮水平内边距'
    }, {
      name: 'paddingLargeVertical',
      attr: 'paddingTop',
      type: 'number',
      parser: parseInt,
      className: buttonClass('large'),
      desc: '大按钮垂直内边距'
    }, {
      name: 'paddingSmallHorizontal',
      attr: 'paddingLeft',
      type: 'number',
      parser: parseInt,
      className: buttonClass('small'),
      desc: '小按钮水平内边距'
    }, {
      name: 'paddingSmallVertical',
      attr: 'paddingTop',
      type: 'number',
      parser: parseInt,
      className: buttonClass('small'),
      desc: '小按钮垂直内边距'
    }, {
      name: 'borderRadius',
      attr: 'borderRadius',
      type: 'number',
      parser: parseInt,
      className: buttonClass('_'),
      desc: '常规按钮圆角'
    }, {
      name: 'smallBorderRadius',
      attr: 'borderRadius',
      type: 'number',
      parser: parseInt,
      className: buttonClass('small'),
      desc: '小按钮圆角'
    }, {
      name: 'largeBorderRadius',
      attr: 'borderRadius',
      type: 'number',
      parser: parseInt,
      className: buttonClass('large'),
      desc: '大按钮圆角'
    }, {
      name: 'disabledBg',
      attr: 'backgroundColor',
      type: 'color',
      className: buttonClass('disabled'),
      desc: '禁用按钮背景色'
    }, {
      name: 'disabledDelimiter',
      attr: 'borderColor',
      type: 'color',
      className: exposeClass('button-disabled-delimiter'),
      desc: '按钮组禁用状态下分隔符颜色'
    }, {
      name: 'disabledColor',
      attr: 'color',
      type: 'color',
      className: buttonClass('disabled'),
      desc: '禁用按钮文字颜色'
    }, {
      name: 'disabledBorderColor',
      attr: 'borderColor',
      type: 'color',
      className: buttonClass('disabled'),
      desc: '禁用按钮边框颜色'
    }, {
      name: 'buttonDefaultTextColor',
      attr: 'color',
      type: 'color',
      className: buttonClass('default'),
      desc: '默认样式下文字颜色'
    }, {
      name: 'buttonDefaultBorderColor',
      attr: 'borderColor',
      type: 'color',
      className: buttonClass('default'),
      desc: '默认样式下边框颜色'
    }],

    set fontSizeBase(v) {
      cov_1w0wl6gh7m.f[24]++;
      cov_1w0wl6gh7m.s[65]++;
      setBodyProperty({
        '--button-font-size-base': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set fontSizeLarge(v) {
      cov_1w0wl6gh7m.f[25]++;
      cov_1w0wl6gh7m.s[66]++;
      setBodyProperty({
        '--button-font-size-large': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set fontSizeSmall(v) {
      cov_1w0wl6gh7m.f[26]++;
      cov_1w0wl6gh7m.s[67]++;
      setBodyProperty({
        '--button-font-size-small': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set spinMargin(v) {
      cov_1w0wl6gh7m.f[27]++;
      cov_1w0wl6gh7m.s[68]++;
      setBodyProperty({
        '--button-spin-margin': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set marginLeft(v) {
      cov_1w0wl6gh7m.f[28]++;
      cov_1w0wl6gh7m.s[69]++;
      setBodyProperty({
        '--button-margin-left': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set borderRadius(v) {
      cov_1w0wl6gh7m.f[29]++;
      cov_1w0wl6gh7m.s[70]++;
      setBodyProperty({
        '--button-border-radius': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set smallBorderRadius(v) {
      cov_1w0wl6gh7m.f[30]++;
      cov_1w0wl6gh7m.s[71]++;
      setBodyProperty({
        '--button-small-border-radius': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set largeBorderRadius(v) {
      cov_1w0wl6gh7m.f[31]++;
      cov_1w0wl6gh7m.s[72]++;
      setBodyProperty({
        '--button-large-border-radius': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set paddingBaseHorizontal(v) {
      cov_1w0wl6gh7m.f[32]++;
      cov_1w0wl6gh7m.s[73]++;
      setBodyProperty({
        '--button-padding-base-horizontal': "".concat(parseInt(v, 10), "px"),
        '--button-padding-base-horizontal-7': "".concat(parseInt(v, 10) * 0.7, "px")
      }, v);
    },

    set paddingLargeHorizontal(v) {
      cov_1w0wl6gh7m.f[33]++;
      cov_1w0wl6gh7m.s[74]++;
      setBodyProperty({
        '--button-padding-large-horizontal': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set paddingSmallHorizontal(v) {
      cov_1w0wl6gh7m.f[34]++;
      cov_1w0wl6gh7m.s[75]++;
      setBodyProperty({
        '--button-padding-small-horizontal': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set paddingBaseVertical(v) {
      cov_1w0wl6gh7m.f[35]++;
      cov_1w0wl6gh7m.s[76]++;
      setBodyProperty({
        '--button-padding-base-vertical': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set paddingLargeVertical(v) {
      cov_1w0wl6gh7m.f[36]++;
      cov_1w0wl6gh7m.s[77]++;
      setBodyProperty({
        '--button-padding-large-vertical': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set paddingSmallVertical(v) {
      cov_1w0wl6gh7m.f[37]++;
      cov_1w0wl6gh7m.s[78]++;
      setBodyProperty({
        '--button-padding-small-vertical': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set disabledBg(v) {
      cov_1w0wl6gh7m.f[38]++;
      cov_1w0wl6gh7m.s[79]++;
      setBodyProperty({
        '--button-disabled-bg': v
      }, v);
    },

    set disabledColor(v) {
      cov_1w0wl6gh7m.f[39]++;
      cov_1w0wl6gh7m.s[80]++;
      setBodyProperty({
        '--button-disabled-color': v
      }, v);
    },

    set disabledBorderColor(v) {
      cov_1w0wl6gh7m.f[40]++;
      cov_1w0wl6gh7m.s[81]++;
      setBodyProperty({
        '--button-disabled-border-color': v
      }, v);
    },

    set disabledDelimiter(v) {
      cov_1w0wl6gh7m.f[41]++;
      cov_1w0wl6gh7m.s[82]++;
      setBodyProperty({
        '--button-disabled-delimiter': v
      }, v);
    },

    set buttonDefaultTextColor(v) {
      cov_1w0wl6gh7m.f[42]++;
      cov_1w0wl6gh7m.s[83]++;
      setBodyProperty({
        '--button-default-text-color': v
      }, v);
    },

    set buttonDefaultBorderColor(v) {
      cov_1w0wl6gh7m.f[43]++;
      cov_1w0wl6gh7m.s[84]++;
      setBodyProperty({
        '--button-default-border': v,
        '--button-default-border-fade-0': fade(v, 0),
        '--button-default-border-fade-60': fade(v, 0.6)
      }, v);
    }

  },
  dropdown: {
    info: {
      title: 'Dropdown 下拉菜单',
      name: 'dropdown',
      path: 'Dropdown'
    },
    conf: [{
      name: 'borderWidth',
      attr: 'borderWidth',
      type: 'number',
      parser: parseInt,
      className: exposeClass('dropdown-button'),
      desc: '按钮边框宽度'
    }, {
      name: 'columnsPadding',
      attr: 'padding',
      type: 'string',
      className: dropdownClass('box-list'),
      desc: '多列平铺的内边距'
    }, {
      name: 'optionsHoverBgc',
      attr: 'backgroundColor',
      type: 'color',
      className: exposeClass('dropdown-options-hover'),
      desc: 'options hover时背景颜色'
    }, {
      name: 'optionsHoverColor',
      attr: 'color',
      type: 'color',
      className: exposeClass('dropdown-options-hover'),
      desc: 'options hover时字体颜色'
    }],

    set borderWidth(v) {
      cov_1w0wl6gh7m.f[44]++;
      cov_1w0wl6gh7m.s[85]++;
      setBodyProperty({
        '--dropdown-border-width': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set columnsPadding(v) {
      cov_1w0wl6gh7m.f[45]++;
      cov_1w0wl6gh7m.s[86]++;
      setBodyProperty({
        '--dropdown-columns-padding': v
      }, v);
    },

    set optionsHoverBgc(v) {
      cov_1w0wl6gh7m.f[46]++;
      cov_1w0wl6gh7m.s[87]++;
      setBodyProperty({
        '--dropdown-options-hover-bgc': v
      }, v);
    },

    set optionsHoverColor(v) {
      cov_1w0wl6gh7m.f[47]++;
      cov_1w0wl6gh7m.s[88]++;
      setBodyProperty({
        '--dropdown-options-hover-color': v
      }, v);
    }

  },
  form: {
    info: {
      title: 'Form 表单',
      name: 'form',
      path: 'Form'
    },
    conf: [{
      name: 'itemMarginBottom',
      className: formClass('item'),
      attr: 'marginBottom',
      type: 'number',
      parser: parseInt,
      desc: '条目垂直间隔'
    }, {
      name: 'itemMarginRight',
      className: exposeClass('form-inline'),
      attr: 'marginRight',
      type: 'number',
      parser: parseInt,
      desc: '条目水平间隔'
    }, {
      name: 'tipColor',
      className: exposeClass('form-tip'),
      attr: 'color',
      type: 'color',
      desc: '提示文字颜色'
    }, {
      name: 'labelHorizontalAlign',
      className: exposeClass('form-label'),
      attr: 'textAlign',
      type: ['start', 'center', 'end'],
      desc: '标签对齐方式'
    }, {
      name: 'formTipFontSize',
      className: exposeClass('form-tip'),
      attr: 'fontSize',
      type: 'number',
      parser: parseInt,
      desc: '提示信息字体大小'
    }, {
      name: 'formErrorLineHeight',
      className: exposeClass('form-error'),
      attr: 'lineHeight',
      type: 'number',
      parser: parseFloat,
      desc: '校验错误文字行高'
    }, {
      name: 'formErrorMarginTop',
      className: exposeClass('form-error'),
      attr: 'marginTop',
      type: 'number',
      parser: parseInt,
      desc: '校验错误文字顶部间距'
    }, {
      name: 'formErrorMarginBottom',
      className: exposeClass('form-error'),
      attr: 'marginBottom',
      type: 'number',
      parser: parseInt,
      desc: '校验错误文字底部间距'
    }, {
      name: 'formKeepErrorHeight',
      className: exposeClass('form-keep-error'),
      attr: 'min-height',
      type: 'number',
      parser: parseInt,
      desc: '错误提示不撑开表单高度时的最小间距'
    }],

    set itemMarginBottom(v) {
      cov_1w0wl6gh7m.f[48]++;
      cov_1w0wl6gh7m.s[89]++;
      setBodyProperty({
        '--form-item-margin-bottom': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set itemMarginRight(v) {
      cov_1w0wl6gh7m.f[49]++;
      cov_1w0wl6gh7m.s[90]++;
      setBodyProperty({
        '--form-item-margin-right': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set tipColor(v) {
      cov_1w0wl6gh7m.f[50]++;
      cov_1w0wl6gh7m.s[91]++;
      setBodyProperty({
        '--form-tip-color': v
      }, v);
    },

    set labelHorizontalAlign(v) {
      cov_1w0wl6gh7m.f[51]++;
      cov_1w0wl6gh7m.s[92]++;
      setBodyProperty({
        '--form-item-label-align': v
      }, v);
    },

    set formTipFontSize(v) {
      cov_1w0wl6gh7m.f[52]++;
      cov_1w0wl6gh7m.s[93]++;
      setBodyProperty({
        '--form-tip-font-size': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set formErrorLineHeight(v) {
      cov_1w0wl6gh7m.f[53]++;
      cov_1w0wl6gh7m.s[94]++;
      setBodyProperty({
        '--form-item-error-line-height': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set formErrorMarginTop(v) {
      cov_1w0wl6gh7m.f[54]++;
      cov_1w0wl6gh7m.s[95]++;
      setBodyProperty({
        '--form-item-error-margin-top': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set formErrorMarginBottom(v) {
      cov_1w0wl6gh7m.f[55]++;
      cov_1w0wl6gh7m.s[96]++;
      setBodyProperty({
        '--form-item-error-margin-bottom': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set formKeepErrorHeight(v) {
      cov_1w0wl6gh7m.f[56]++;
      cov_1w0wl6gh7m.s[97]++;
      setBodyProperty({
        '--form-Item-min-keep-height': "".concat(parseInt(v, 10), "px")
      }, v);
    }

  },
  checkbox: {
    info: {
      title: 'Checkbox 复选框',
      name: 'checkbox',
      path: 'Checkbox'
    },
    conf: [{
      name: 'marginRight',
      className: checkinputClass('_'),
      attr: 'marginRight',
      type: 'number',
      parser: parseInt,
      desc: '水平间隔'
    }, {
      name: 'borderWidth',
      className: exposeClass('checkbox-indicator'),
      attr: 'width',
      type: 'number',
      parser: parseInt,
      desc: '边框宽度'
    }, {
      name: 'color',
      className: checkinputClass('_'),
      attr: 'color',
      type: 'color',
      desc: '文字颜色'
    }, {
      name: 'borderColor',
      className: exposeClass('checkbox-indicator'),
      attr: 'borderColor',
      type: 'color',
      desc: '边框颜色'
    }, {
      name: 'textPaddingX',
      className: exposeClass('checkbox-text'),
      attr: 'paddingRight',
      type: 'number',
      parser: parseInt,
      desc: '文字水平内间距'
    }, {
      name: 'indicatorBorderRadius',
      className: exposeClass('checkbox-indicator'),
      attr: 'borderRadius',
      type: 'number',
      parser: parseInt,
      min: 3,
      desc: '圆角'
    }, {
      name: 'checkboxDisabledBgc',
      className: exposeClass('checkbox-disabled'),
      attr: 'backgroundColor',
      type: 'color',
      desc: 'Checkbox 和 Radio 未选中状态禁用后的背景色'
    }, {
      name: 'checkboxCheckedDisabledBgc',
      className: exposeClass('checkbox-checked-disabled'),
      attr: 'backgroundColor',
      type: 'color',
      desc: 'Checkbox 和 Radio 选中状态下禁用后的背景色'
    }],

    set marginRight(v) {
      cov_1w0wl6gh7m.f[57]++;
      cov_1w0wl6gh7m.s[98]++;
      setBodyProperty({
        '--checkbox-margin-right': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set color(v) {
      cov_1w0wl6gh7m.f[58]++;
      cov_1w0wl6gh7m.s[99]++;
      setBodyProperty({
        '--checkinput-color': v
      }, v);
    },

    set borderColor(v) {
      cov_1w0wl6gh7m.f[59]++;
      cov_1w0wl6gh7m.s[100]++;
      setBodyProperty({
        '--checkbox-border-color': v
      }, v);
    },

    set borderWidth(v) {
      cov_1w0wl6gh7m.f[60]++;
      cov_1w0wl6gh7m.s[101]++;
      setBodyProperty({
        '--checkbox-border-width': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set textPaddingX(v) {
      cov_1w0wl6gh7m.f[61]++;
      cov_1w0wl6gh7m.s[102]++;
      setBodyProperty({
        '--checkbox-text-padding-x': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set indicatorBorderRadius(v) {
      cov_1w0wl6gh7m.f[62]++;
      cov_1w0wl6gh7m.s[103]++;
      setBodyProperty({
        '--checkbox-indicator-border-radius': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set checkboxDisabledBgc(v) {
      cov_1w0wl6gh7m.f[63]++;
      cov_1w0wl6gh7m.s[104]++;
      setBodyProperty({
        '--checkbox-disabled-bgc': v
      }, v);
    },

    set checkboxCheckedDisabledBgc(v) {
      cov_1w0wl6gh7m.f[64]++;
      cov_1w0wl6gh7m.s[105]++;
      setBodyProperty({
        '--checkbox-checked-disabled-bgc': v
      }, v);
    }

  },
  radio: {
    info: {
      title: 'Radio 单选框',
      name: 'radio',
      path: 'Radio'
    },
    conf: [{
      name: 'size',
      className: exposeClass('radio'),
      attr: 'width',
      type: 'number',
      parser: parseInt,
      min: 0,
      max: 40,
      desc: '尺寸'
    }, {
      name: 'borderWidth',
      className: exposeClass('radio'),
      attr: 'borderWidth',
      type: 'number',
      parser: parseInt,
      min: 0,
      max: 10,
      desc: '选中的边框宽度'
    }, {
      name: 'innerWidth',
      className: exposeClass('radio-inner'),
      attr: 'width',
      type: 'number',
      parser: parseInt,
      min: 0,
      max: 10,
      desc: '选中点尺寸'
    }, {
      name: 'uncheckBorderWidth',
      className: exposeClass('radio-uncheck'),
      attr: 'width',
      type: 'number',
      parser: parseInt,
      min: 0,
      desc: '未选中边框宽度'
    }, {
      name: 'color',
      className: exposeClass('radio'),
      attr: 'color',
      type: 'color',
      desc: '文字颜色'
    }],

    set size(v) {
      cov_1w0wl6gh7m.f[65]++;
      cov_1w0wl6gh7m.s[106]++;
      setBodyProperty({
        '--radio-width': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set borderWidth(v) {
      cov_1w0wl6gh7m.f[66]++;
      cov_1w0wl6gh7m.s[107]++;
      setBodyProperty({
        '--radio-border-width': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set innerWidth(v) {
      cov_1w0wl6gh7m.f[67]++;
      cov_1w0wl6gh7m.s[108]++;
      setBodyProperty({
        '--radio-inner-width': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set uncheckBorderWidth(v) {
      cov_1w0wl6gh7m.f[68]++;
      cov_1w0wl6gh7m.s[109]++;
      setBodyProperty({
        '--radio-border-uncheck-width': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set color(v) {
      cov_1w0wl6gh7m.f[69]++;
      cov_1w0wl6gh7m.s[110]++;
      setBodyProperty({
        '--radio-text-color': v
      }, v);
    }

  },
  input: {
    info: {
      title: 'Input 输入框',
      name: 'input',
      path: 'Input'
    },
    conf: [{
      name: 'color',
      className: inputClass('_'),
      attr: 'color',
      type: 'color',
      desc: '文字颜色'
    }, {
      name: 'borderRadius',
      className: inputClass('_'),
      attr: 'borderRadius',
      type: 'number',
      parser: parseInt,
      desc: '圆角'
    }, {
      name: 'underlineHeight',
      className: inputClass('_', 'underline'),
      attr: 'borderBottomWidth',
      type: 'number',
      parser: parseInt,
      desc: '下边框宽度(仅在下边框模式生效)'
    }, {
      name: 'dropdownBorderRadius',
      className: datepickerClass('picker'),
      attr: 'borderRadius',
      type: 'number',
      parser: parseInt,
      desc: '下拉框圆角，例如Select Options'
    }, {
      name: 'focusWidth',
      className: inputClass('focus'),
      attr: 'boxShadow',
      type: 'number',
      max: 20,
      parser: function parser(v) {
        cov_1w0wl6gh7m.f[70]++;
        cov_1w0wl6gh7m.s[111]++;
        return parseInt(v.split(' ').pop(), 10);
      },
      desc: '聚焦发散光宽度'
    }, {
      name: 'disabledBg',
      className: inputClass('disabled'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '禁用背景色'
    }, {
      name: 'disabledColor',
      className: inputClass('disabled'),
      attr: 'color',
      type: 'color',
      desc: '禁用字体色'
    }, {
      name: 'borderColor',
      className: inputClass('_'),
      attr: 'borderColor',
      type: 'color',
      desc: '边框颜色'
    }, {
      name: 'borderHoverColor',
      className: exposeClass('input-focus'),
      attr: 'borderColor',
      type: 'color',
      desc: '鼠标悬浮、聚焦时的边框色'
    }, {
      name: 'placeholderColor',
      className: exposeClass('input-placeholder'),
      attr: 'color',
      type: 'color',
      desc: '占位文字颜色'
    }, {
      name: 'placeholderSize',
      className: exposeClass('input-placeholder'),
      attr: 'fontSize',
      type: 'number',
      parser: parseInt,
      desc: '占位文字大小'
    }, {
      name: 'clearBg',
      className: exposeClass('input-clear'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '清空图标背景色'
    }, {
      name: 'clearHoverBg',
      className: exposeClass('input-clear-hover'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '清空图标鼠标悬浮背景色'
    }],

    set color(v) {
      cov_1w0wl6gh7m.f[71]++;
      cov_1w0wl6gh7m.s[112]++;
      setBodyProperty({
        '--input-text-color': v
      }, v);
    },

    set borderRadius(v) {
      cov_1w0wl6gh7m.f[72]++;
      cov_1w0wl6gh7m.s[113]++;
      setBodyProperty({
        '--input-border-radius': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set underlineHeight(v) {
      cov_1w0wl6gh7m.f[73]++;
      cov_1w0wl6gh7m.s[114]++;
      setBodyProperty({
        '--input-underline-height': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set dropdownBorderRadius(v) {
      cov_1w0wl6gh7m.f[74]++;
      cov_1w0wl6gh7m.s[115]++;
      setBodyProperty({
        '--input-dropdown-border-radius': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set disabledBg(v) {
      cov_1w0wl6gh7m.f[75]++;
      cov_1w0wl6gh7m.s[116]++;
      setBodyProperty({
        '--input-bg-disabled': v
      }, v);
    },

    set disabledColor(v) {
      cov_1w0wl6gh7m.f[76]++;
      cov_1w0wl6gh7m.s[117]++;
      setBodyProperty({
        '--input-disabled-color': v
      }, v);
    },

    set borderColor(v) {
      cov_1w0wl6gh7m.f[77]++;
      cov_1w0wl6gh7m.s[118]++;
      setBodyProperty({
        '--input-border-color': v
      }, v);
    },

    set borderHoverColor(v) {
      cov_1w0wl6gh7m.f[78]++;
      cov_1w0wl6gh7m.s[119]++;
      setBodyProperty({
        '--input-border-focus-color': v,
        '--input-border-focus-color-fade-25': fade(v, 0.25)
      }, v);
    },

    set focusWidth(v) {
      cov_1w0wl6gh7m.f[79]++;
      cov_1w0wl6gh7m.s[120]++;
      setBodyProperty({
        '--input-focus-width': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set placeholderColor(v) {
      cov_1w0wl6gh7m.f[80]++;
      cov_1w0wl6gh7m.s[121]++;
      setBodyProperty({
        '--input-placeholder-color': v
      }, v);
    },

    set placeholderSize(v) {
      cov_1w0wl6gh7m.f[81]++;
      cov_1w0wl6gh7m.s[122]++;
      setBodyProperty({
        '--input-placeholder-size': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set clearBg(v) {
      cov_1w0wl6gh7m.f[82]++;
      cov_1w0wl6gh7m.s[123]++;
      setBodyProperty({
        '--input-clear-bg-color': v
      }, v);
    },

    set clearHoverBg(v) {
      cov_1w0wl6gh7m.f[83]++;
      cov_1w0wl6gh7m.s[124]++;
      setBodyProperty({
        '--input-clear-bg-hover-color': v
      }, v);
    }

  },
  select: {
    info: {
      title: 'Select 选择框',
      name: 'select',
      path: 'Select'
    },
    conf: [{
      name: 'resultPaddingHorizontal',
      className: exposeClass('select-result-item'),
      attr: 'paddingLeft',
      type: 'number',
      parser: parseInt,
      desc: '选中值水平内边距'
    }, {
      name: 'resultPaddingVertical',
      className: exposeClass('select-result-item'),
      attr: 'paddingTop',
      type: 'number',
      parser: parseInt,
      desc: '选中值垂直内边距'
    }, {
      name: 'itemColor',
      className: selectClass('option'),
      attr: 'color',
      type: 'color',
      desc: '选项文字颜色'
    }, {
      name: 'itemBgColor',
      className: selectClass('option'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '选项背景颜色'
    }, {
      name: 'disabledBg',
      className: selectClass('option', 'disabled'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '禁用选项背景色'
    }, {
      name: 'disabledColor',
      className: selectClass('option', 'disabled'),
      attr: 'color',
      type: 'color',
      desc: '禁用选项文字颜色'
    }, {
      name: 'itemActiveBg',
      className: selectClass('active', 'option'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '选中项背景色'
    }, {
      name: 'itemActiveColor',
      className: selectClass('active', 'option'),
      attr: 'color',
      type: 'color',
      desc: '选中项文字颜色'
    }, {
      name: 'itemHoverBg',
      className: exposeClass('select-option-hover'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '选项鼠标悬浮背景色'
    }, {
      name: 'itemHoverColor',
      className: exposeClass('select-option-hover'),
      attr: 'color',
      type: 'color',
      desc: '选项鼠标悬浮文字颜色'
    }, {
      name: 'compressedMoreHoverBg',
      className: exposeClass('select-compressed'),
      attr: 'backgroundColor',
      type: 'color',
      desc: 'compressed模式按钮鼠标悬浮背景色'
    }, {
      name: 'clearIconBg',
      className: exposeClass('select-close'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '清空按钮背景色'
    }, {
      name: 'treeDisabledBg',
      className: exposeClass('select-tree-disabled'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '树形选择禁用选项背景色'
    }, {
      name: 'treeContentColor',
      className: exposeClass('select-tree'),
      attr: 'color',
      type: 'color',
      desc: '树形选择可点击选项文字颜色'
    }, {
      name: 'treeDisableContentColor',
      className: exposeClass('select-tree-disabled'),
      attr: 'color',
      type: 'color',
      desc: '树形选择禁用选项文字颜色'
    }, {
      name: 'treeIconHoverBg',
      className: exposeClass('select-tree-icon-hover'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '树形选择展开箭头背景色'
    }, {
      name: 'treeNodeHoverBg',
      className: exposeClass('select-tree-node-hover'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '树形选择节点hover状态背景色'
    }, {
      name: 'treeNodeHoverColor',
      className: exposeClass('select-tree-node-hover'),
      attr: 'color',
      type: 'color',
      desc: '树形选择节点hover状态文字颜色'
    }, {
      name: 'treeNodeSelectedBg',
      className: exposeClass('select-tree-node-selected'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '树形选择节点选中状态背景色'
    }, {
      name: 'treeNodeSelectedColor',
      className: exposeClass('select-tree-node-selected'),
      attr: 'color',
      type: 'color',
      desc: '树形选择节点选中状态文字颜色'
    }],

    set resultPaddingVertical(v) {
      cov_1w0wl6gh7m.f[84]++;
      cov_1w0wl6gh7m.s[125]++;
      setBodyProperty({
        '--select-result-padding-vertical': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set resultPaddingHorizontal(v) {
      cov_1w0wl6gh7m.f[85]++;
      cov_1w0wl6gh7m.s[126]++;
      setBodyProperty({
        '--select-result-padding-horizontal': "".concat(parseInt(v, 10), "px"),
        '--select-result-padding-horizontal-16': "".concat(parseInt(v, 10) + 16, "px")
      }, v);
    },

    set itemColor(v) {
      cov_1w0wl6gh7m.f[86]++;
      cov_1w0wl6gh7m.s[127]++;
      setBodyProperty({
        '--select-option-color': v
      }, v);
    },

    set itemBgColor(v) {
      cov_1w0wl6gh7m.f[87]++;
      cov_1w0wl6gh7m.s[128]++;
      setBodyProperty({
        '--select-option-bg-color': v
      }, v);
    },

    set disabledBg(v) {
      cov_1w0wl6gh7m.f[88]++;
      cov_1w0wl6gh7m.s[129]++;
      setBodyProperty({
        '--select-disabled-bg-color': v
      }, v);
    },

    set disabledColor(v) {
      cov_1w0wl6gh7m.f[89]++;
      cov_1w0wl6gh7m.s[130]++;
      setBodyProperty({
        '--select-disabled-color': v
      }, v);
    },

    set itemActiveBg(v) {
      cov_1w0wl6gh7m.f[90]++;
      cov_1w0wl6gh7m.s[131]++;
      setBodyProperty({
        '--select-item-active-bg': v
      }, v);
    },

    set itemActiveColor(v) {
      cov_1w0wl6gh7m.f[91]++;
      cov_1w0wl6gh7m.s[132]++;
      setBodyProperty({
        '--select-item-active-color': v
      }, v);
    },

    set itemHoverBg(v) {
      cov_1w0wl6gh7m.f[92]++;
      cov_1w0wl6gh7m.s[133]++;
      setBodyProperty({
        '--select-option-hover-bg': v
      }, v);
    },

    set itemHoverColor(v) {
      cov_1w0wl6gh7m.f[93]++;
      cov_1w0wl6gh7m.s[134]++;
      setBodyProperty({
        '--select-option-hover-color': v
      }, v);
    },

    set compressedMoreHoverBg(v) {
      cov_1w0wl6gh7m.f[94]++;
      cov_1w0wl6gh7m.s[135]++;
      setBodyProperty({
        '--select-compressed-hover-bg': v
      }, v);
    },

    set clearIconBg(v) {
      cov_1w0wl6gh7m.f[95]++;
      cov_1w0wl6gh7m.s[136]++;
      setBodyProperty({
        '--select-clear-bg-color': v
      }, v);
    },

    set treeDisabledBg(v) {
      cov_1w0wl6gh7m.f[96]++;
      cov_1w0wl6gh7m.s[137]++;
      setBodyProperty({
        '--select-tree-disabled-bg-color': v
      }, v);
    },

    set treeContentColor(v) {
      cov_1w0wl6gh7m.f[97]++;
      cov_1w0wl6gh7m.s[138]++;
      setBodyProperty({
        '--select-tree-content-color': v
      }, v);
    },

    set treeDisableContentColor(v) {
      cov_1w0wl6gh7m.f[98]++;
      cov_1w0wl6gh7m.s[139]++;
      setBodyProperty({
        '--select-tree-disabled-content-color': v
      }, v);
    },

    set treeIconHoverBg(v) {
      cov_1w0wl6gh7m.f[99]++;
      cov_1w0wl6gh7m.s[140]++;
      setBodyProperty({
        '--select-tree-icon-hover-bg-color': v
      }, v);
    },

    set treeNodeHoverBg(v) {
      cov_1w0wl6gh7m.f[100]++;
      cov_1w0wl6gh7m.s[141]++;
      setBodyProperty({
        '--select-tree-node-hover-bg': v
      }, v);
    },

    set treeNodeHoverColor(v) {
      cov_1w0wl6gh7m.f[101]++;
      cov_1w0wl6gh7m.s[142]++;
      setBodyProperty({
        '--select-tree-node-hover-color': v
      }, v);
    },

    set treeNodeSelectedBg(v) {
      cov_1w0wl6gh7m.f[102]++;
      cov_1w0wl6gh7m.s[143]++;
      setBodyProperty({
        '--select-tree-node-selected-bg': v
      }, v);
    },

    set treeNodeSelectedColor(v) {
      cov_1w0wl6gh7m.f[103]++;
      cov_1w0wl6gh7m.s[144]++;
      setBodyProperty({
        '--select-tree-node-selected-color': v
      }, v);
    }

  },
  datepicker: {
    info: {
      title: 'Datepicker 日期选择',
      name: 'datepicker',
      path: 'Datepicker'
    },
    conf: [{
      name: 'rectBorderRadius',
      className: exposeClass('datepicker-month-item'),
      attr: 'borderRadius',
      type: 'number',
      parser: parseInt,
      desc: '年份、月份选中项圆角'
    }, {
      name: 'dayHoverBgc',
      className: exposeClass('datepicker-day-hover-bgc'),
      attr: 'backgroundColor',
      type: 'color',
      desc: 'day hover时背景颜色'
    }],

    set rectBorderRadius(v) {
      cov_1w0wl6gh7m.f[104]++;
      cov_1w0wl6gh7m.s[145]++;
      setBodyProperty({
        '--datepicker-rect-active-border-radius': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set dayHoverBgc(v) {
      cov_1w0wl6gh7m.f[105]++;
      cov_1w0wl6gh7m.s[146]++;
      setBodyProperty({
        '--datepicker-day-hover-bgc': v
      }, v);
    }

  },
  slider: {
    info: {
      title: 'Slider 滑块',
      name: 'slider',
      path: 'Slider'
    },
    conf: [{
      name: 'indicatorBg',
      className: exposeClass('slider-indicator'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '滑块背景色'
    }, {
      name: 'indicatorSize',
      className: exposeClass('slider-indicator'),
      attr: 'width',
      type: 'number',
      min: 8,
      max: 40,
      parser: parseInt,
      desc: '滑块尺寸'
    }, {
      name: 'indicatorBoxShadow',
      className: exposeClass('slider-indicator'),
      attr: 'boxShadow',
      type: 'string',
      desc: '滑块阴影'
    }, {
      name: 'barBg',
      className: exposeClass('slider-bar'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '滑动条背景色'
    }, {
      name: 'disabledBarBg',
      className: exposeClass('slider-bar-disabled'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '滑动条禁用背景色'
    }, {
      name: 'disabledIndicatorBorder',
      className: exposeClass('slider-indicator-disabled'),
      attr: 'borderColor',
      type: 'color',
      desc: '禁用状态下滑块边框色'
    }, {
      name: 'disabledIndicatorBg',
      className: exposeClass('slider-indicator-disabled'),
      attr: 'background',
      type: 'color',
      desc: '禁用状态下滑块边背景色'
    }, {
      name: 'height',
      className: sliderClass('background'),
      attr: 'height',
      type: 'number',
      parser: parseInt,
      desc: '滑动条高度'
    }, {
      name: 'borderRadius',
      className: sliderClass('background'),
      attr: 'borderRadius',
      type: 'number',
      parser: parseInt,
      desc: '滑动条圆角'
    }, {
      name: 'valueBottom',
      className: exposeClass('slider-value'),
      attr: 'height',
      type: 'number',
      parser: parseInt,
      desc: '当前值距离滑块距离'
    }],

    set indicatorBg(v) {
      cov_1w0wl6gh7m.f[106]++;
      cov_1w0wl6gh7m.s[147]++;
      setBodyProperty({
        '--slider-indicator-bg': v
      }, v);
    },

    set indicatorSize(v) {
      cov_1w0wl6gh7m.f[107]++;
      cov_1w0wl6gh7m.s[148]++;
      setBodyProperty({
        '--slider-indicator-size': "".concat(parseInt(v, 10), "px"),
        '--slider-indicator-size-half': "".concat(parseInt(v, 10) / 2, "px")
      }, v);
    },

    set indicatorBoxShadow(v) {
      cov_1w0wl6gh7m.f[108]++;
      cov_1w0wl6gh7m.s[149]++;
      setBodyProperty({
        '--slider-indicator-box-shadow': v
      }, v);
    },

    set barBg(v) {
      cov_1w0wl6gh7m.f[109]++;
      cov_1w0wl6gh7m.s[150]++;
      setBodyProperty({
        '--slider-bar-color': v
      }, v);
    },

    set disabledBarBg(v) {
      cov_1w0wl6gh7m.f[110]++;
      cov_1w0wl6gh7m.s[151]++;
      setBodyProperty({
        '--slider-disabled-bar-bg': v
      }, v);
    },

    set disabledIndicatorBorder(v) {
      cov_1w0wl6gh7m.f[111]++;
      cov_1w0wl6gh7m.s[152]++;
      setBodyProperty({
        '--slider-disbaled-indicator-border-color': v
      }, v);
    },

    set disabledIndicatorBg(v) {
      cov_1w0wl6gh7m.f[112]++;
      cov_1w0wl6gh7m.s[153]++;
      setBodyProperty({
        '--slider-disbaled-indicator-bg': v
      }, v);
    },

    set height(v) {
      cov_1w0wl6gh7m.f[113]++;
      cov_1w0wl6gh7m.s[154]++;
      setBodyProperty({
        '--slider-bar-height': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set borderRadius(v) {
      cov_1w0wl6gh7m.f[114]++;
      cov_1w0wl6gh7m.s[155]++;
      setBodyProperty({
        '--slider-border-radius': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set valueBottom(v) {
      cov_1w0wl6gh7m.f[115]++;
      cov_1w0wl6gh7m.s[156]++;
      setBodyProperty({
        '--slider-value-bottom': "".concat(parseInt(v, 10), "px")
      }, v);
    }

  },
  table: {
    info: {
      title: 'Table 表格',
      name: 'table',
      path: 'Table'
    },
    conf: [{
      name: 'scrollRatio',
      className: exposeClass('table-scroll-ratio'),
      attr: 'width',
      parser: parseInt,
      type: 'number',
      desc: '滚动速率，仅在 Windows 下有效',
      logic: true,
      max: 500
    }, {
      name: 'headBg',
      className: exposeClass('table-head'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '表头背景色'
    }, {
      name: 'headColor',
      className: exposeClass('table-head'),
      attr: 'color',
      type: 'color',
      desc: '表头文字颜色'
    }, {
      name: 'bodyBg',
      className: exposeClass('table-body'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '表格内容背景色'
    }, {
      name: 'rowSpacing',
      className: exposeClass('table-spacing'),
      attr: 'height',
      type: 'number',
      parser: parseInt,
      desc: '行间距'
    }, {
      name: 'rowBorderRadius',
      className: exposeClass('table-spacing'),
      attr: 'borderRadius',
      type: 'number',
      parser: parseInt,
      desc: '行圆角'
    }, {
      name: 'headFontWeight',
      className: exposeClass('table-head'),
      attr: 'fontWeight',
      type: 'number',
      max: 900,
      min: 100,
      parser: parseInt,
      desc: '表头字重'
    }, {
      name: 'borderColor',
      className: exposeClass('table-head'),
      attr: 'borderColor',
      type: 'color',
      desc: '边框颜色'
    }, {
      name: 'hoverBg',
      className: exposeClass('table-head-hover'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '鼠标悬浮行背景色'
    }, {
      name: 'selectedBg',
      className: exposeClass('table-selected'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '选中行背景色'
    }, {
      name: 'textColor',
      className: exposeClass('table'),
      attr: 'color',
      type: 'color',
      desc: '文字颜色'
    }, {
      name: 'borderRadiusTop',
      className: exposeClass('table-head'),
      attr: 'borderTopLeftRadius',
      type: 'number',
      parser: parseInt,
      desc: '表格头部圆角'
    }, {
      name: 'headerCellPadding',
      className: exposeClass('table-head'),
      attr: 'padding',
      type: 'string',
      desc: '表头分组内边距'
    }, {
      name: 'smallCellPadding',
      className: exposeClass('table-small'),
      attr: 'padding',
      type: 'string',
      desc: '紧凑表格单元格内边距'
    }, {
      name: 'cellPaddingHorizontal',
      className: exposeClass('table-cell'),
      attr: 'paddingLeft',
      type: 'number',
      parser: parseInt,
      desc: '单元格水平内边距'
    }, {
      name: 'cellPaddingVertical',
      className: exposeClass('table-cell'),
      attr: 'paddingTop',
      type: 'number',
      parser: parseInt,
      desc: '单元格垂直内边距'
    }, {
      name: 'treeExpandIconMarginRight',
      className: exposeClass('table-tree-expand'),
      attr: 'marginRight',
      type: 'number',
      parser: parseInt,
      desc: '子表格展开/收起按钮距离文字距离'
    }, {
      name: 'fixedStart',
      className: exposeClass('table-fixed-start'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '固定列渐变色开始颜色'
    }, {
      name: 'fixedEnd',
      className: exposeClass('table-fixed-end'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '固定列渐变色结束颜色'
    }, {
      name: 'tableEvenBgc',
      className: exposeClass('table-even'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '偶数行背景颜色'
    }, {
      name: 'tableOddBgc',
      className: exposeClass('table-odd'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '奇数行背景颜色'
    }, {
      name: 'marginBottom',
      className: exposeClass('table'),
      attr: 'marginBottom',
      type: 'number',
      parser: parseInt,
      desc: '表格底部外边距'
    }, {
      name: 'headerTopDivider',
      className: exposeClass('table-head-top'),
      attr: 'borderWidth',
      type: 'number',
      parser: parseInt,
      desc: '无边框表格头部边框线'
    }],

    set scrollRatio(v) {
      cov_1w0wl6gh7m.f[116]++;
      var rate = (cov_1w0wl6gh7m.s[157]++, typeof v === 'number' ? (cov_1w0wl6gh7m.b[18][0]++, v) : (cov_1w0wl6gh7m.b[18][1]++, parseInt(v, 10)));
      cov_1w0wl6gh7m.s[158]++;
      configSet('scrollRatio', rate);
      cov_1w0wl6gh7m.s[159]++;
      setBodyProperty({
        '--table-scroll-ratio': "".concat(rate, "px")
      }, v);
    },

    set headBg(v) {
      cov_1w0wl6gh7m.f[117]++;
      cov_1w0wl6gh7m.s[160]++;
      setBodyProperty({
        '--table-head-bg': v
      }, v);
    },

    set hoverBg(v) {
      cov_1w0wl6gh7m.f[118]++;
      cov_1w0wl6gh7m.s[161]++;
      setBodyProperty({
        '--table-hover-bg': v
      }, v);
    },

    set selectedBg(v) {
      cov_1w0wl6gh7m.f[119]++;
      cov_1w0wl6gh7m.s[162]++;
      setBodyProperty({
        '--table-selected-row-bg': v
      }, v);
    },

    set headColor(v) {
      cov_1w0wl6gh7m.f[120]++;
      cov_1w0wl6gh7m.s[163]++;
      setBodyProperty({
        '--table-head-color': v
      }, v);
    },

    set bodyBg(v) {
      cov_1w0wl6gh7m.f[121]++;
      cov_1w0wl6gh7m.s[164]++;
      setBodyProperty({
        '--table-body-bg': v
      }, v);
    },

    set rowSpacing(v) {
      cov_1w0wl6gh7m.f[122]++;
      cov_1w0wl6gh7m.s[165]++;
      setBodyProperty({
        '--table-row-spacing': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set rowBorderRadius(v) {
      cov_1w0wl6gh7m.f[123]++;
      cov_1w0wl6gh7m.s[166]++;
      setBodyProperty({
        '--table-row-border-radius': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set headFontWeight(v) {
      cov_1w0wl6gh7m.f[124]++;
      cov_1w0wl6gh7m.s[167]++;
      setBodyProperty({
        '--table-head-font-weight': "".concat(parseInt(v, 10))
      }, v);
    },

    set borderColor(v) {
      cov_1w0wl6gh7m.f[125]++;
      cov_1w0wl6gh7m.s[168]++;
      setBodyProperty({
        '--table-border-color': v
      }, v);
    },

    set textColor(v) {
      cov_1w0wl6gh7m.f[126]++;
      cov_1w0wl6gh7m.s[169]++;
      setBodyProperty({
        '--table-color': v
      }, v);
    },

    set borderRadiusTop(v) {
      cov_1w0wl6gh7m.f[127]++;
      cov_1w0wl6gh7m.s[170]++;
      setBodyProperty({
        '--table-border-radius-top': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set headerCellPadding(v) {
      cov_1w0wl6gh7m.f[128]++;
      cov_1w0wl6gh7m.s[171]++;
      setBodyProperty({
        '--table-header-cell-padding': v
      }, v);
    },

    set smallCellPadding(v) {
      cov_1w0wl6gh7m.f[129]++;
      cov_1w0wl6gh7m.s[172]++;
      setBodyProperty({
        '--table-small-cell-padding': v
      }, v);
    },

    set cellPaddingHorizontal(v) {
      cov_1w0wl6gh7m.f[130]++;
      cov_1w0wl6gh7m.s[173]++;
      setBodyProperty({
        '--table-cell-padding-horizontal': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set cellPaddingVertical(v) {
      cov_1w0wl6gh7m.f[131]++;
      cov_1w0wl6gh7m.s[174]++;
      setBodyProperty({
        '--table-cell-padding-vertical': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set treeExpandIconMarginRight(v) {
      cov_1w0wl6gh7m.f[132]++;
      cov_1w0wl6gh7m.s[175]++;
      setBodyProperty({
        '--table-tree-expand-icon-margin-right': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set fixedStart(v) {
      cov_1w0wl6gh7m.f[133]++;
      cov_1w0wl6gh7m.s[176]++;
      setBodyProperty({
        '--table-fixed-start-color': v
      }, v);
    },

    set fixedEnd(v) {
      cov_1w0wl6gh7m.f[134]++;
      cov_1w0wl6gh7m.s[177]++;
      setBodyProperty({
        '--table-fixed-end-color': v
      }, v);
    },

    set tableEvenBgc(v) {
      cov_1w0wl6gh7m.f[135]++;
      cov_1w0wl6gh7m.s[178]++;
      setBodyProperty({
        '--table-even-td-bgc': v
      }, v);
    },

    set tableOddBgc(v) {
      cov_1w0wl6gh7m.f[136]++;
      cov_1w0wl6gh7m.s[179]++;
      setBodyProperty({
        '--table-odd-td-bgc': v
      }, v);
    },

    set marginBottom(v) {
      cov_1w0wl6gh7m.f[137]++;
      cov_1w0wl6gh7m.s[180]++;
      setBodyProperty({
        '--table-margin-bottom': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set headerTopDivider(v) {
      cov_1w0wl6gh7m.f[138]++;
      cov_1w0wl6gh7m.s[181]++;
      setBodyProperty({
        '--table-header-top-divider-width': "".concat(parseInt(v, 10), "px")
      }, v);
    }

  },
  pagination: {
    info: {
      title: 'Pagination 分页',
      name: 'pagination',
      path: 'Pagination'
    },
    conf: [{
      name: 'borderRadius',
      className: paginationClass('item'),
      attr: 'borderRadius',
      type: 'number',
      parser: parseInt,
      desc: '项目圆角'
    }, {
      name: 'borderWidth',
      className: paginationClass('item'),
      attr: 'borderWidth',
      type: 'number',
      parser: parseInt,
      desc: '项目边框宽度'
    }, {
      name: 'hoverBorderColor',
      className: exposeClass('pagination-hover'),
      attr: 'borderColor',
      type: 'color',
      desc: '项目鼠标悬浮边框颜色'
    }, {
      name: 'hoverColor',
      className: exposeClass('pagination-hover'),
      attr: 'color',
      type: 'color',
      desc: '项目鼠标悬浮文字颜色'
    }, {
      name: 'hoverBg',
      className: exposeClass('pagination-hover'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '项目鼠标悬浮背景色'
    }, {
      name: 'fontSize',
      className: exposeClass('pagination'),
      attr: 'fontSize',
      type: 'number',
      parser: parseInt,
      desc: '字体大小'
    }, {
      name: 'defaultSize',
      className: exposeClass('pagination-default'),
      attr: 'width',
      type: 'number',
      parser: parseInt,
      desc: '默认尺寸宽高'
    }, {
      name: 'smallSize',
      className: exposeClass('pagination-small'),
      attr: 'width',
      type: 'number',
      parser: parseInt,
      desc: '小号尺寸宽高'
    }, {
      name: 'largeSize',
      className: exposeClass('pagination-large'),
      attr: 'width',
      type: 'number',
      parser: parseInt,
      desc: '大号尺寸宽高'
    }],

    set borderRadius(v) {
      cov_1w0wl6gh7m.f[139]++;
      cov_1w0wl6gh7m.s[182]++;
      setBodyProperty({
        '--pagination-border-radius': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set borderWidth(v) {
      cov_1w0wl6gh7m.f[140]++;
      cov_1w0wl6gh7m.s[183]++;
      setBodyProperty({
        '--pagination-border-width': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set hoverBorderColor(v) {
      cov_1w0wl6gh7m.f[141]++;
      cov_1w0wl6gh7m.s[184]++;
      setBodyProperty({
        '--pagination-hover-border': v
      }, v);
    },

    set hoverColor(v) {
      cov_1w0wl6gh7m.f[142]++;
      cov_1w0wl6gh7m.s[185]++;
      setBodyProperty({
        '--pagination-hover-color': v
      }, v);
    },

    set hoverBg(v) {
      cov_1w0wl6gh7m.f[143]++;
      cov_1w0wl6gh7m.s[186]++;
      setBodyProperty({
        '--pagination-hover-bg': v
      }, v);
    },

    set fontSize(v) {
      cov_1w0wl6gh7m.f[144]++;
      cov_1w0wl6gh7m.s[187]++;
      setBodyProperty({
        '--pagination-font-size': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set defaultSize(v) {
      cov_1w0wl6gh7m.f[145]++;
      cov_1w0wl6gh7m.s[188]++;
      setBodyProperty({
        '--pagination-size': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set smallSize(v) {
      cov_1w0wl6gh7m.f[146]++;
      cov_1w0wl6gh7m.s[189]++;
      setBodyProperty({
        '--pagination-size-small': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set largeSize(v) {
      cov_1w0wl6gh7m.f[147]++;
      cov_1w0wl6gh7m.s[190]++;
      setBodyProperty({
        '--pagination-size-large': "".concat(parseInt(v, 10), "px")
      }, v);
    }

  },
  tag: {
    info: {
      title: 'Tag 标签',
      name: 'tag',
      path: 'Tag'
    },
    conf: [{
      name: 'bg',
      className: tagClass('_'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '默认背景色'
    }, {
      name: 'successBg',
      className: tagClass('success'),
      attr: 'backgroundColor',
      type: 'color',
      desc: 'success类型背景色'
    }, {
      name: 'infoBg',
      className: tagClass('info'),
      attr: 'backgroundColor',
      type: 'color',
      desc: 'info类型背景色'
    }, {
      name: 'warningBg',
      className: tagClass('warning'),
      attr: 'backgroundColor',
      type: 'color',
      desc: 'warning类型背景色'
    }, {
      name: 'dangerBg',
      className: tagClass('danger'),
      attr: 'backgroundColor',
      type: 'color',
      desc: 'danger类型背景色'
    }, {
      name: 'color',
      className: tagClass('_'),
      attr: 'color',
      type: 'color',
      desc: '默认文字颜色'
    }, {
      name: 'successColor',
      className: tagClass('success'),
      attr: 'color',
      type: 'color',
      desc: 'success类型文字颜色'
    }, {
      name: 'infoColor',
      className: tagClass('info'),
      attr: 'color',
      type: 'color',
      desc: 'info类型文字颜色'
    }, {
      name: 'warningColor',
      className: tagClass('warning'),
      attr: 'color',
      type: 'color',
      desc: 'warning类型文字颜色'
    }, {
      name: 'dangerColor',
      className: tagClass('danger'),
      attr: 'color',
      type: 'color',
      desc: 'danger类型文字颜色'
    }, {
      name: 'borderColor',
      className: tagClass('default'),
      attr: 'borderColor',
      type: 'color',
      desc: '边框颜色'
    }, {
      name: 'closeColor',
      className: exposeClass('tag-close'),
      attr: 'color',
      type: 'color',
      desc: '关闭按钮颜色'
    }, {
      name: 'closeHoverColor',
      className: exposeClass('tag-close-hover'),
      attr: 'color',
      type: 'color',
      desc: '关闭按钮鼠标悬浮时颜色'
    }, {
      name: 'borderRadius',
      className: tagClass('_'),
      attr: 'borderRadius',
      type: 'number',
      parser: parseInt,
      desc: '圆角'
    }, {
      name: 'paddingHorizontal',
      className: tagClass('_'),
      attr: 'paddingLeft',
      type: 'number',
      parser: parseInt,
      desc: '水平内边距'
    }, {
      name: 'paddingVertical',
      className: tagClass('_'),
      attr: 'paddingTop',
      type: 'number',
      parser: parseInt,
      desc: '垂直内边距'
    }, {
      name: 'fontWeight',
      className: tagClass('_'),
      attr: 'fontWeight',
      type: 'number',
      parser: parseInt,
      min: 100,
      max: 900,
      desc: '字重'
    }],

    set bg(v) {
      cov_1w0wl6gh7m.f[148]++;
      cov_1w0wl6gh7m.s[191]++;
      setBodyProperty({
        '--tag-bg': v
      }, v);
    },

    set successBg(v) {
      cov_1w0wl6gh7m.f[149]++;
      cov_1w0wl6gh7m.s[192]++;
      setBodyProperty({
        '--tag-success-bg': v
      }, v);
    },

    set infoBg(v) {
      cov_1w0wl6gh7m.f[150]++;
      cov_1w0wl6gh7m.s[193]++;
      setBodyProperty({
        '--tag-info-bg': v
      }, v);
    },

    set warningBg(v) {
      cov_1w0wl6gh7m.f[151]++;
      cov_1w0wl6gh7m.s[194]++;
      setBodyProperty({
        '--tag-warning-bg': v
      }, v);
    },

    set dangerBg(v) {
      cov_1w0wl6gh7m.f[152]++;
      cov_1w0wl6gh7m.s[195]++;
      setBodyProperty({
        '--tag-danger-bg': v
      }, v);
    },

    set color(v) {
      cov_1w0wl6gh7m.f[153]++;
      cov_1w0wl6gh7m.s[196]++;
      setBodyProperty({
        '--tag-color': v
      }, v);
    },

    set successColor(v) {
      cov_1w0wl6gh7m.f[154]++;
      cov_1w0wl6gh7m.s[197]++;
      setBodyProperty({
        '--tag-success-color': v
      }, v);
    },

    set infoColor(v) {
      cov_1w0wl6gh7m.f[155]++;
      cov_1w0wl6gh7m.s[198]++;
      setBodyProperty({
        '--tag-info-color': v
      }, v);
    },

    set warningColor(v) {
      cov_1w0wl6gh7m.f[156]++;
      cov_1w0wl6gh7m.s[199]++;
      setBodyProperty({
        '--tag-warning-color': v
      }, v);
    },

    set dangerColor(v) {
      cov_1w0wl6gh7m.f[157]++;
      cov_1w0wl6gh7m.s[200]++;
      setBodyProperty({
        '--tag-danger-color': v
      }, v);
    },

    set closeColor(v) {
      cov_1w0wl6gh7m.f[158]++;
      cov_1w0wl6gh7m.s[201]++;
      setBodyProperty({
        '--tag-close-color': v
      }, v);
    },

    set closeHoverColor(v) {
      cov_1w0wl6gh7m.f[159]++;
      cov_1w0wl6gh7m.s[202]++;
      setBodyProperty({
        '--tag-close-hover-color': v
      }, v);
    },

    set borderColor(v) {
      cov_1w0wl6gh7m.f[160]++;
      cov_1w0wl6gh7m.s[203]++;
      setBodyProperty({
        '--tag-border-color': v
      }, v);
    },

    set borderRadius(v) {
      cov_1w0wl6gh7m.f[161]++;
      cov_1w0wl6gh7m.s[204]++;
      setBodyProperty({
        '--tag-border-radius': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set paddingHorizontal(v) {
      cov_1w0wl6gh7m.f[162]++;
      cov_1w0wl6gh7m.s[205]++;
      setBodyProperty({
        '--tag-padding-horizontal': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set paddingVertical(v) {
      cov_1w0wl6gh7m.f[163]++;
      cov_1w0wl6gh7m.s[206]++;
      setBodyProperty({
        '--tag-padding-vertical': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set fontWeight(v) {
      cov_1w0wl6gh7m.f[164]++;
      cov_1w0wl6gh7m.s[207]++;
      setBodyProperty({
        '--tag-font-weight': v
      }, v);
    }

  },
  tooltip: {
    info: {
      title: 'Tooltip 提示',
      name: 'tooltip',
      path: 'Tooltip'
    },
    conf: [{
      name: 'bg',
      className: tooltipClass('inner'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '背景色'
    }, {
      name: 'paddingHorizontal',
      className: tooltipClass('inner'),
      attr: 'paddingLeft',
      type: 'number',
      parser: parseInt,
      desc: '水平内边距'
    }, {
      name: 'paddingVertical',
      className: tooltipClass('inner'),
      attr: 'paddingTop',
      type: 'number',
      parser: parseInt,
      desc: '垂直内边距'
    }],

    set bg(v) {
      cov_1w0wl6gh7m.f[165]++;
      cov_1w0wl6gh7m.s[208]++;
      setBodyProperty({
        '--tooltip-bg': v
      }, v);
    },

    set paddingHorizontal(v) {
      cov_1w0wl6gh7m.f[166]++;
      cov_1w0wl6gh7m.s[209]++;
      setBodyProperty({
        '--tooltip-padding-horizontal': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set paddingVertical(v) {
      cov_1w0wl6gh7m.f[167]++;
      cov_1w0wl6gh7m.s[210]++;
      setBodyProperty({
        '--tooltip-padding-vertical': "".concat(parseInt(v, 10), "px")
      }, v);
    }

  },
  menu: {
    info: {
      title: 'Menu 菜单',
      name: 'menu',
      path: 'Menu'
    },
    conf: [{
      name: 'height',
      className: menuClass('title'),
      attr: 'height',
      type: 'number',
      parser: parseInt,
      desc: '条目高度'
    }, {
      name: 'fontSize',
      className: menuClass('title'),
      attr: 'fontSize',
      type: 'number',
      parser: parseInt,
      desc: '字体大小'
    }, {
      name: 'darkColor',
      className: exposeClass('menu-dark'),
      attr: 'color',
      type: 'color',
      desc: '黑色主题文字颜色'
    }, {
      name: 'darkBg',
      className: exposeClass('menu-dark'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '黑色主题背景色'
    }, {
      name: 'darkRootNodeBg',
      className: exposeClass('menu-dark-root'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '黑色主题 Root Node 背景色'
    }, {
      name: 'darkChildrenSegmentation',
      className: exposeClass('menu-dark-seg'),
      attr: 'borderTopColor',
      type: 'color',
      desc: '黑色主题子菜单与Root Menu 分割线背景色'
    }, {
      name: 'darkActiveBg',
      className: exposeClass('menu-dark-active'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '黑色主题选中项背景色'
    }, {
      name: 'activeBg',
      className: exposeClass('menu-active'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '选中项背景色'
    }, {
      name: 'activeColor',
      className: exposeClass('menu-active'),
      attr: 'color',
      type: 'color',
      desc: '选中项文字颜色'
    }, {
      name: 'color',
      className: exposeClass('menu-text'),
      attr: 'color',
      type: 'color',
      desc: '文字颜色'
    }, {
      name: 'activePaddingHorizontal',
      className: exposeClass('menu-active'),
      attr: 'paddingLeft',
      type: 'number',
      parser: parseInt,
      desc: '选中项水平内边距'
    }, {
      name: 'activePaddingVertical',
      className: exposeClass('menu-active'),
      attr: 'paddingTop',
      type: 'number',
      parser: parseInt,
      desc: '选中项垂直内边距'
    }, {
      name: 'activeBorderRadius',
      className: exposeClass('menu-active'),
      attr: 'borderRadius',
      type: 'number',
      parser: parseInt,
      desc: '选中项圆角'
    }, {
      name: 'itemHoverColor',
      className: exposeClass('menu-light-hover'),
      attr: 'color',
      type: 'color',
      desc: 'hover状态下文字颜色'
    }, {
      name: 'itemHoverDarkColor',
      className: exposeClass('menu-dark-hover'),
      attr: 'color',
      type: 'color',
      desc: '暗黑主题 hover状态下文字颜色'
    }, {
      name: 'itemHoverBgc',
      className: exposeClass('menu-light-hover'),
      attr: 'backgroundColor',
      type: 'color',
      desc: 'hover状态下背景颜色'
    }, {
      name: 'itemHoverDarkBgc',
      className: exposeClass('menu-dark-hover'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '暗黑主题 hover状态下背景颜色'
    }, {
      name: 'activeBar',
      className: exposeClass('menu-bar'),
      attr: 'width',
      type: 'number',
      parser: parseInt,
      desc: 'active 状态下 bar 宽度'
    }, {
      name: 'activeBarColor',
      className: exposeClass('menu-bar'),
      attr: 'backgroundColor',
      type: 'color',
      desc: 'active bar 颜色'
    }, {
      name: 'darkActiveBarColor',
      className: exposeClass('menu-dark-bar'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '暗黑模式下 active bar 颜色'
    }, {
      name: 'verticalDarkRootActiveBgc',
      className: exposeClass('menu-dark-vertical'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '垂直样式 dark 主题：子节点选中下，parent 节点背景颜色'
    }, {
      name: 'hasChildrenActiveBgc',
      className: exposeClass('menu-dark-vertical-children'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '垂直样式：选中状态，背景颜色'
    }, {
      name: 'hasChildrenActiveColor',
      className: exposeClass('menu-dark-vertical-children'),
      attr: 'color',
      type: 'color',
      desc: '垂直样式：选中状态，背景颜色'
    }, {
      name: 'verticalInpathBarWidth',
      className: exposeClass('menu-dark-vertical-bar'),
      attr: 'width',
      type: 'number',
      parser: parseInt,
      desc: '垂直样式：子节点选中下，parent 节点 bar 的宽度'
    }],

    set verticalDarkRootActiveBgc(v) {
      cov_1w0wl6gh7m.f[168]++;
      cov_1w0wl6gh7m.s[211]++;
      setBodyProperty({
        '--menu-vertical-dark-parent-active-bgc': v
      }, v);
    },

    set hasChildrenActiveBgc(v) {
      cov_1w0wl6gh7m.f[169]++;
      cov_1w0wl6gh7m.s[212]++;
      setBodyProperty({
        '--menu-item-has-children-active-bgc': v
      }, v);
    },

    set hasChildrenActiveColor(v) {
      cov_1w0wl6gh7m.f[170]++;
      cov_1w0wl6gh7m.s[213]++;
      setBodyProperty({
        '--menu-item-has-children-active-color': v
      }, v);
    },

    set verticalInpathBarWidth(v) {
      cov_1w0wl6gh7m.f[171]++;
      cov_1w0wl6gh7m.s[214]++;
      setBodyProperty({
        '--menu-vertical-in-path-bar-width': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set height(v) {
      cov_1w0wl6gh7m.f[172]++;
      var height = (cov_1w0wl6gh7m.s[215]++, parseInt(v, 10));
      cov_1w0wl6gh7m.s[216]++;
      setBodyProperty({
        '--menu-item-height': "".concat(height, "px")
      }, v);
    },

    set fontSize(v) {
      cov_1w0wl6gh7m.f[173]++;
      cov_1w0wl6gh7m.s[217]++;
      setBodyProperty({
        '--menu-item-font-size': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set darkBg(v) {
      cov_1w0wl6gh7m.f[174]++;
      cov_1w0wl6gh7m.s[218]++;
      setBodyProperty({
        '--menu-dark-bg': v
      }, v);
    },

    set darkActiveBg(v) {
      cov_1w0wl6gh7m.f[175]++;
      cov_1w0wl6gh7m.s[219]++;
      setBodyProperty({
        '--menu-dark-acitve-bg': v
      }, v);
    },

    set activeBg(v) {
      cov_1w0wl6gh7m.f[176]++;
      cov_1w0wl6gh7m.s[220]++;
      setBodyProperty({
        '--menu-item-active-bg': v
      }, v);
    },

    set activeColor(v) {
      cov_1w0wl6gh7m.f[177]++;
      cov_1w0wl6gh7m.s[221]++;
      setBodyProperty({
        '--menu-item-active-color': v
      }, v);
    },

    set color(v) {
      cov_1w0wl6gh7m.f[178]++;
      cov_1w0wl6gh7m.s[222]++;
      setBodyProperty({
        '--menu-item-color': v
      }, v);
    },

    set darkColor(v) {
      cov_1w0wl6gh7m.f[179]++;
      cov_1w0wl6gh7m.s[223]++;
      setBodyProperty({
        '--menu-dark-color': v
      }, v);
    },

    set darkRootNodeBg(v) {
      cov_1w0wl6gh7m.f[180]++;
      cov_1w0wl6gh7m.s[224]++;
      setBodyProperty({
        '--menu-root-node-bgc': v
      }, v);
    },

    set darkChildrenSegmentation(v) {
      cov_1w0wl6gh7m.f[181]++;
      cov_1w0wl6gh7m.s[225]++;
      setBodyProperty({
        '--menu-children-segmentation': v
      }, v);
    },

    set activePaddingHorizontal(v) {
      cov_1w0wl6gh7m.f[182]++;
      cov_1w0wl6gh7m.s[226]++;
      setBodyProperty({
        '--menu-active-padding-horizontal': "".concat(parseInt(v, 10), "px"),
        '--menu-active-padding-horizontal-negative': "-".concat(parseInt(v, 10), "px")
      }, v);
    },

    set activePaddingVertical(v) {
      cov_1w0wl6gh7m.f[183]++;
      cov_1w0wl6gh7m.s[227]++;
      setBodyProperty({
        '--menu-active-padding-vertical': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set activeBorderRadius(v) {
      cov_1w0wl6gh7m.f[184]++;
      cov_1w0wl6gh7m.s[228]++;
      setBodyProperty({
        '--menu-active-border-radius': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set itemHoverColor(v) {
      cov_1w0wl6gh7m.f[185]++;
      cov_1w0wl6gh7m.s[229]++;
      setBodyProperty({
        '--menu-item-light-hover-color': v
      }, v);
    },

    set itemHoverDarkColor(v) {
      cov_1w0wl6gh7m.f[186]++;
      cov_1w0wl6gh7m.s[230]++;
      setBodyProperty({
        '--menu-item-dark-hover-color': v
      }, v);
    },

    set itemHoverBgc(v) {
      cov_1w0wl6gh7m.f[187]++;
      cov_1w0wl6gh7m.s[231]++;
      setBodyProperty({
        '--menu-item-light-hover-bgc': v
      }, v);
    },

    set itemHoverDarkBgc(v) {
      cov_1w0wl6gh7m.f[188]++;
      cov_1w0wl6gh7m.s[232]++;
      setBodyProperty({
        '--menu-item-dark-hover-bgc': v
      }, v);
    },

    set activeBar(v) {
      cov_1w0wl6gh7m.f[189]++;
      cov_1w0wl6gh7m.s[233]++;
      setBodyProperty({
        '--menu-active-bar': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set activeBarColor(v) {
      cov_1w0wl6gh7m.f[190]++;
      cov_1w0wl6gh7m.s[234]++;
      setBodyProperty({
        '--menu-item-active-indicator': v
      }, v);
    },

    set darkActiveBarColor(v) {
      cov_1w0wl6gh7m.f[191]++;
      cov_1w0wl6gh7m.s[235]++;
      setBodyProperty({
        '--menu-dark-item-active-indicator': v
      }, v);
    }

  },
  alert: {
    info: {
      title: 'Alert 提示框',
      name: 'alert',
      path: 'Alert'
    },
    conf: [{
      name: 'fontSize',
      className: alertClass('_'),
      attr: 'fontSize',
      type: 'number',
      parser: parseInt,
      desc: '文字大小'
    }, {
      name: 'iconMarginTop',
      className: alertClass('icon'),
      attr: 'marginTop',
      type: 'number',
      parser: parseInt,
      desc: 'Icon上外边距'
    }, {
      name: 'paddingX',
      className: alertClass('_'),
      attr: 'paddingLeft',
      type: 'number',
      parser: parseInt,
      desc: '水平方向内边距'
    }, {
      name: 'paddingY',
      className: alertClass('_'),
      attr: 'paddingTop',
      type: 'number',
      parser: parseInt,
      desc: '垂直方向内边距'
    }, {
      name: 'closeIconColor',
      className: exposeClass('alert-close'),
      attr: 'color',
      type: 'color',
      desc: '关闭按钮颜色'
    }, {
      name: 'closeIconHoverColor',
      className: exposeClass('alert-close-hover'),
      attr: 'color',
      type: 'color',
      desc: '关闭按钮鼠标悬浮颜色'
    }, {
      name: 'borderRadius',
      className: alertClass('_'),
      attr: 'borderRadius',
      type: 'number',
      parser: parseInt,
      desc: '圆角'
    }, {
      name: 'successBoxShadow',
      className: alertClass('success'),
      attr: 'boxShadow',
      type: 'string',
      desc: 'success 类型阴影'
    }, {
      name: 'infoBoxShadow',
      className: alertClass('info'),
      attr: 'boxShadow',
      type: 'string',
      desc: 'info 类型阴影'
    }, {
      name: 'warningBoxShadow',
      className: alertClass('warning'),
      attr: 'boxShadow',
      type: 'string',
      desc: 'warning 类型阴影'
    }, {
      name: 'dangerBoxShadow',
      className: alertClass('danger'),
      attr: 'boxShadow',
      type: 'string',
      desc: 'danger 类型阴影'
    }, {
      name: 'borderWidth',
      className: alertClass('_'),
      attr: 'borderWidth',
      type: 'number',
      parser: parseInt,
      desc: '边框宽度'
    }, {
      name: 'successTextColor',
      className: alertClass('success'),
      attr: 'color',
      type: 'color',
      desc: 'success 类型文字颜色'
    }, {
      name: 'successBg',
      className: alertClass('success'),
      attr: 'backgroundColor',
      type: 'color',
      desc: 'success 类型背景色'
    }, {
      name: 'successBorderColor',
      className: alertClass('success'),
      attr: 'borderColor',
      type: 'color',
      desc: 'success 类型边框色'
    }, {
      name: 'infoTextColor',
      className: alertClass('info'),
      attr: 'color',
      type: 'color',
      desc: 'info 类型文字颜色'
    }, {
      name: 'infoBg',
      className: alertClass('info'),
      attr: 'backgroundColor',
      type: 'color',
      desc: 'info 类型背景色'
    }, {
      name: 'infoBorderColor',
      className: alertClass('info'),
      attr: 'borderColor',
      type: 'color',
      desc: 'info 类型边框色'
    }, {
      name: 'warningTextColor',
      className: alertClass('warning'),
      attr: 'color',
      type: 'color',
      desc: 'warning 类型文字颜色'
    }, {
      name: 'warningBg',
      className: alertClass('warning'),
      attr: 'backgroundColor',
      type: 'color',
      desc: 'warning 类型背景色'
    }, {
      name: 'warningBorderColor',
      className: alertClass('warning'),
      attr: 'borderColor',
      type: 'color',
      desc: 'warning 类型边框颜色'
    }, {
      name: 'dangerTextColor',
      className: alertClass('danger'),
      attr: 'color',
      type: 'color',
      desc: 'danger 类型文字颜色'
    }, {
      name: 'dangerBg',
      className: alertClass('danger'),
      attr: 'backgroundColor',
      type: 'color',
      desc: 'success 类型背景色'
    }, {
      name: 'dangerBorderColor',
      className: alertClass('danger'),
      attr: 'borderColor',
      type: 'color',
      desc: 'danger 类型边框色'
    }],

    set fontSize(v) {
      cov_1w0wl6gh7m.f[192]++;
      cov_1w0wl6gh7m.s[236]++;
      setBodyProperty({
        '--alert-font-size': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set paddingX(v) {
      cov_1w0wl6gh7m.f[193]++;
      cov_1w0wl6gh7m.s[237]++;
      setBodyProperty({
        '--alert-padding-x': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set paddingY(v) {
      cov_1w0wl6gh7m.f[194]++;
      cov_1w0wl6gh7m.s[238]++;
      setBodyProperty({
        '--alert-padding-y': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set iconMarginTop(v) {
      cov_1w0wl6gh7m.f[195]++;
      cov_1w0wl6gh7m.s[239]++;
      setBodyProperty({
        '--alert-icon-margin-top': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set closeIconColor(v) {
      cov_1w0wl6gh7m.f[196]++;
      cov_1w0wl6gh7m.s[240]++;
      setBodyProperty({
        '--alert-close-color': v
      }, v);
    },

    set closeIconHoverColor(v) {
      cov_1w0wl6gh7m.f[197]++;
      cov_1w0wl6gh7m.s[241]++;
      setBodyProperty({
        '--alert-close-hover-color': v
      }, v);
    },

    set borderRadius(v) {
      cov_1w0wl6gh7m.f[198]++;
      cov_1w0wl6gh7m.s[242]++;
      setBodyProperty({
        '--alert-border-radius': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set boxShadow(v) {
      cov_1w0wl6gh7m.f[199]++;
      cov_1w0wl6gh7m.s[243]++;
      setBodyProperty({
        '--alert-box-shadow': v
      }, v);
    },

    set successBoxShadow(v) {
      cov_1w0wl6gh7m.f[200]++;
      cov_1w0wl6gh7m.s[244]++;
      setBodyProperty({
        '--alert-success-box-shadow': v
      }, v);
    },

    set infoBoxShadow(v) {
      cov_1w0wl6gh7m.f[201]++;
      cov_1w0wl6gh7m.s[245]++;
      setBodyProperty({
        '--alert-info-box-shadow': v
      }, v);
    },

    set dangerBoxShadow(v) {
      cov_1w0wl6gh7m.f[202]++;
      cov_1w0wl6gh7m.s[246]++;
      setBodyProperty({
        '--alert-danger-box-shadow': v
      }, v);
    },

    set warningBoxShadow(v) {
      cov_1w0wl6gh7m.f[203]++;
      cov_1w0wl6gh7m.s[247]++;
      setBodyProperty({
        '--alert-warning-box-shadow': v
      }, v);
    },

    set borderWidth(v) {
      cov_1w0wl6gh7m.f[204]++;
      cov_1w0wl6gh7m.s[248]++;
      setBodyProperty({
        '--alert-border-width': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set successTextColor(v) {
      cov_1w0wl6gh7m.f[205]++;
      cov_1w0wl6gh7m.s[249]++;
      setBodyProperty({
        '--alert-success-text-color': v,
        '--alert-success-text-darken-10-color': darken(v, 10)
      }, v);
    },

    set successBg(v) {
      cov_1w0wl6gh7m.f[206]++;
      cov_1w0wl6gh7m.s[250]++;
      setBodyProperty({
        '--alert-success-bg': v
      }, v);
    },

    set successBorderColor(v) {
      cov_1w0wl6gh7m.f[207]++;
      cov_1w0wl6gh7m.s[251]++;
      setBodyProperty({
        '--alert-success-border-color': v,
        '--alert-success-border-darken-5-color': darken(v, 5)
      }, v);
    },

    set infoTextColor(v) {
      cov_1w0wl6gh7m.f[208]++;
      cov_1w0wl6gh7m.s[252]++;
      setBodyProperty({
        '--alert-info-text-color': v,
        '--alert-info-text-darken-10-color': darken(v, 10)
      }, v);
    },

    set infoBg(v) {
      cov_1w0wl6gh7m.f[209]++;
      cov_1w0wl6gh7m.s[253]++;
      setBodyProperty({
        '--alert-info-bg': v
      }, v);
    },

    set infoBorderColor(v) {
      cov_1w0wl6gh7m.f[210]++;
      cov_1w0wl6gh7m.s[254]++;
      setBodyProperty({
        '--alert-info-border-color': v,
        '--alert-info-border-darken-5-color': darken(v, 5)
      }, v);
    },

    set warningTextColor(v) {
      cov_1w0wl6gh7m.f[211]++;
      cov_1w0wl6gh7m.s[255]++;
      setBodyProperty({
        '--alert-warning-text-color': v,
        '--alert-warning-text-darken-10-color': darken(v, 10)
      }, v);
    },

    set warningBg(v) {
      cov_1w0wl6gh7m.f[212]++;
      cov_1w0wl6gh7m.s[256]++;
      setBodyProperty({
        '--alert-warning-bg': v
      }, v);
    },

    set warningBorderColor(v) {
      cov_1w0wl6gh7m.f[213]++;
      cov_1w0wl6gh7m.s[257]++;
      setBodyProperty({
        '--alert-warning-border-color': v,
        '--alert-warning-border-darken-5-color': darken(v, 5)
      }, v);
    },

    set dangerTextColor(v) {
      cov_1w0wl6gh7m.f[214]++;
      cov_1w0wl6gh7m.s[258]++;
      setBodyProperty({
        '--alert-danger-text-color': v,
        '--alert-danger-text-darken-10-color': darken(v, 10)
      }, v);
    },

    set dangerBg(v) {
      cov_1w0wl6gh7m.f[215]++;
      cov_1w0wl6gh7m.s[259]++;
      setBodyProperty({
        '--alert-danger-bg': v
      }, v);
    },

    set dangerBorderColor(v) {
      cov_1w0wl6gh7m.f[216]++;
      cov_1w0wl6gh7m.s[260]++;
      setBodyProperty({
        '--alert-danger-border-color': v,
        '--alert-danger-border-darken-5-color': darken(v, 5)
      }, v);
    }

  },
  message: {
    info: {
      title: 'Message 消息提示',
      name: 'message',
      path: 'Message'
    },
    conf: [{
      name: 'boxShadow',
      className: messageClass('msg'),
      attr: 'boxShadow',
      type: 'string',
      desc: '阴影'
    }, {
      name: 'closeColor',
      className: exposeClass('msg-close'),
      attr: 'color',
      type: 'color',
      desc: '关闭图标颜色'
    }, {
      name: 'color',
      className: messageClass('msg'),
      attr: 'color',
      type: 'color',
      desc: '文字颜色'
    }, {
      name: 'fontWeight',
      className: messageClass('msg'),
      attr: 'fontWeight',
      type: 'number',
      parser: parseInt,
      max: 900,
      min: 100,
      desc: '字重'
    }, {
      name: 'borderColor',
      className: messageClass('msg'),
      attr: 'borderColor',
      type: 'color',
      desc: '边框颜色'
    }, {
      name: 'iconMarginTop',
      className: exposeClass('msg-icon'),
      attr: 'marginTop',
      type: 'number',
      parser: parseInt,
      desc: '类型图标距离顶部距离'
    }],

    set boxShadow(v) {
      cov_1w0wl6gh7m.f[217]++;
      cov_1w0wl6gh7m.s[261]++;
      setBodyProperty({
        '--message-box-shadow': v
      }, v);
    },

    set color(v) {
      cov_1w0wl6gh7m.f[218]++;
      cov_1w0wl6gh7m.s[262]++;
      setBodyProperty({
        '--message-text-color': v
      }, v);
    },

    set closeColor(v) {
      cov_1w0wl6gh7m.f[219]++;
      cov_1w0wl6gh7m.s[263]++;
      setBodyProperty({
        '--message-close-color': v
      }, v);
    },

    set fontWeight(v) {
      cov_1w0wl6gh7m.f[220]++;
      cov_1w0wl6gh7m.s[264]++;
      setBodyProperty({
        '--message-font-weight': v
      }, v);
    },

    set borderColor(v) {
      cov_1w0wl6gh7m.f[221]++;
      cov_1w0wl6gh7m.s[265]++;
      setBodyProperty({
        '--message-border-color': v
      }, v);
    },

    set iconMarginTop(v) {
      cov_1w0wl6gh7m.f[222]++;
      cov_1w0wl6gh7m.s[266]++;
      setBodyProperty({
        '--message-icon-margin-top': "".concat(parseInt(v, 10), "px")
      }, v);
    }

  },
  card: {
    info: {
      title: 'Card 卡片',
      name: 'card',
      path: 'Card'
    },
    conf: [{
      name: 'fontSize',
      className: cardClass('_'),
      attr: 'fontSize',
      type: 'number',
      parser: parseInt,
      desc: '文字大小'
    }, {
      name: 'paddingHeaderHorizontal',
      className: cardClass('header'),
      attr: 'paddingLeft',
      type: 'number',
      parser: parseInt,
      desc: '头部水平内边距'
    }, {
      name: 'paddingHeaderVertical',
      className: cardClass('header'),
      attr: 'paddingTop',
      type: 'number',
      parser: parseInt,
      desc: '头部垂直内边距'
    }, {
      name: 'paddingBodyHorizontal',
      className: cardClass('body'),
      attr: 'paddingLeft',
      type: 'number',
      parser: parseInt,
      desc: '内容部分水平内边距'
    }, {
      name: 'paddingBodyVertical',
      className: cardClass('body'),
      attr: 'paddingTop',
      type: 'number',
      parser: parseInt,
      desc: '内容部分垂直内边距'
    }, {
      name: 'paddingFooterHorizontal',
      className: cardClass('footer'),
      attr: 'paddingLeft',
      type: 'number',
      parser: parseInt,
      desc: '底部水平内边距'
    }, {
      name: 'paddingFooterVertical',
      className: cardClass('footer'),
      attr: 'paddingTop',
      type: 'number',
      parser: parseInt,
      desc: '底部垂直内边距'
    }, {
      name: 'borderRadius',
      className: cardClass('_'),
      attr: 'borderRadius',
      type: 'number',
      parser: parseInt,
      desc: '圆角'
    }, {
      name: 'borderWidth',
      className: cardClass('_'),
      attr: 'borderWidth',
      type: 'number',
      parser: parseInt,
      desc: '边框宽度'
    }, {
      name: 'dividerHeight',
      className: exposeClass('card-divider'),
      attr: 'height',
      type: 'number',
      parser: parseInt,
      desc: '分割线高度'
    }, {
      name: 'dividerWidth',
      value: '100%',
      attr: 'width',
      type: 'string',
      desc: '分割线宽度'
    }, {
      name: 'borderColor',
      className: cardClass('_'),
      attr: 'borderColor',
      type: 'color',
      desc: '边框颜色'
    }, {
      name: 'dividerColor',
      className: exposeClass('card-divider'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '分割线颜色'
    }, {
      name: 'color',
      className: cardClass('_'),
      attr: 'color',
      type: 'color',
      desc: '内容部分文字颜色'
    }, {
      name: 'boxShadow',
      className: cardClass('shadow'),
      attr: 'boxShadow',
      type: 'string',
      desc: '阴影'
    }, {
      name: 'headerBg',
      className: cardClass('header'),
      attr: 'background-color',
      type: 'color',
      desc: '头部背景色'
    }, {
      name: 'footerBg',
      className: cardClass('footer'),
      attr: 'background-color',
      type: 'color',
      desc: '底部背景色'
    }, {
      name: 'headerColor',
      className: cardClass('header'),
      attr: 'color',
      type: 'color',
      desc: '头部文字颜色'
    }, {
      name: 'footerColor',
      className: cardClass('footer'),
      attr: 'color',
      type: 'color',
      desc: '底部文字颜色'
    }],

    set fontSize(v) {
      cov_1w0wl6gh7m.f[223]++;
      cov_1w0wl6gh7m.s[267]++;
      setBodyProperty({
        '--card-font-size': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set paddingHeaderHorizontal(v) {
      cov_1w0wl6gh7m.f[224]++;
      cov_1w0wl6gh7m.s[268]++;
      setBodyProperty({
        '--panel-header-padding-horizontal': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set paddingHeaderVertical(v) {
      cov_1w0wl6gh7m.f[225]++;
      cov_1w0wl6gh7m.s[269]++;
      setBodyProperty({
        '--panel-header-padding-vertical': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set paddingBodyHorizontal(v) {
      cov_1w0wl6gh7m.f[226]++;
      cov_1w0wl6gh7m.s[270]++;
      setBodyProperty({
        '--panel-body-padding-horizontal': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set paddingBodyVertical(v) {
      cov_1w0wl6gh7m.f[227]++;
      cov_1w0wl6gh7m.s[271]++;
      setBodyProperty({
        '--panel-body-padding-vertical': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set paddingFooterHorizontal(v) {
      cov_1w0wl6gh7m.f[228]++;
      cov_1w0wl6gh7m.s[272]++;
      setBodyProperty({
        '--panel-footer-padding-horizontal': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set paddingFooterVertical(v) {
      cov_1w0wl6gh7m.f[229]++;
      cov_1w0wl6gh7m.s[273]++;
      setBodyProperty({
        '--panel-footer-padding-vertical': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set borderRadius(v) {
      cov_1w0wl6gh7m.f[230]++;
      cov_1w0wl6gh7m.s[274]++;
      setBodyProperty({
        '--panel-border-radius': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set borderWidth(v) {
      cov_1w0wl6gh7m.f[231]++;
      cov_1w0wl6gh7m.s[275]++;
      setBodyProperty({
        '--card-border-width': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set dividerHeight(v) {
      cov_1w0wl6gh7m.f[232]++;
      cov_1w0wl6gh7m.s[276]++;
      setBodyProperty({
        '--card-divider-height': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set dividerWidth(v) {
      cov_1w0wl6gh7m.f[233]++;
      cov_1w0wl6gh7m.s[277]++;
      setBodyProperty({
        '--card-divider-width': v
      }, v);
    },

    set borderColor(v) {
      cov_1w0wl6gh7m.f[234]++;
      cov_1w0wl6gh7m.s[278]++;
      setBodyProperty({
        '--card-border-color': v
      }, v);
    },

    set dividerColor(v) {
      cov_1w0wl6gh7m.f[235]++;
      cov_1w0wl6gh7m.s[279]++;
      setBodyProperty({
        '--card-divider-color': v
      }, v);
    },

    set color(v) {
      cov_1w0wl6gh7m.f[236]++;
      cov_1w0wl6gh7m.s[280]++;
      setBodyProperty({
        '--card-color': v
      }, v);
    },

    set boxShadow(v) {
      cov_1w0wl6gh7m.f[237]++;
      cov_1w0wl6gh7m.s[281]++;
      setBodyProperty({
        '--card-box-shadow': v
      }, v);
    },

    set headerBg(v) {
      cov_1w0wl6gh7m.f[238]++;
      cov_1w0wl6gh7m.s[282]++;
      setBodyProperty({
        '--card-header-bg': v
      }, v);
    },

    set footerBg(v) {
      cov_1w0wl6gh7m.f[239]++;
      cov_1w0wl6gh7m.s[283]++;
      setBodyProperty({
        '--card-footer-bg': v
      }, v);
    },

    set headerColor(v) {
      cov_1w0wl6gh7m.f[240]++;
      cov_1w0wl6gh7m.s[284]++;
      setBodyProperty({
        '--card-header-color': v
      }, v);
    },

    set footerColor(v) {
      cov_1w0wl6gh7m.f[241]++;
      cov_1w0wl6gh7m.s[285]++;
      setBodyProperty({
        '--card-footer-color': v
      }, v);
    }

  },
  modal: {
    info: {
      title: 'Modal 对话框',
      name: 'modal',
      path: 'Modal'
    },
    conf: [{
      name: 'titleFontFamily',
      className: modalClass('title'),
      attr: 'fontFamily',
      type: 'string',
      desc: '标题字体'
    }, {
      name: 'fontSize',
      className: exposeClass('modal-card'),
      attr: 'fontSize',
      type: 'number',
      parser: parseInt,
      desc: '文字大小'
    }, {
      name: 'iconSize',
      className: exposeClass('modal-icon'),
      attr: 'width',
      type: 'number',
      parser: parseInt,
      desc: '类型图标尺寸'
    }, {
      name: 'iconTop',
      className: exposeClass('modal-icon'),
      attr: 'marginTop',
      type: 'number',
      parser: parseInt,
      desc: '类型图标距离顶部距离'
    }, {
      name: 'iconLeft',
      className: exposeClass('modal-icon'),
      attr: 'marginLeft',
      type: 'number',
      parser: parseInt,
      desc: '类型图标距离左侧距离'
    }, {
      name: 'closeIconColor',
      className: exposeClass('modal-close'),
      attr: 'color',
      type: 'color',
      desc: '关闭按钮颜色'
    }, {
      name: 'closeIconHoverColor',
      className: exposeClass('modal-close-hover'),
      attr: 'color',
      type: 'color',
      desc: '关闭按钮鼠标悬浮颜色'
    }, {
      name: 'closeIconTopMargin',
      className: exposeClass('modal-close'),
      attr: 'marginTop',
      type: 'number',
      parser: parseInt,
      desc: '关闭按钮顶部间距'
    }, {
      name: 'closeIconRightMargin',
      className: exposeClass('modal-close'),
      attr: 'marginRight',
      type: 'number',
      parser: parseInt,
      desc: '关闭按钮右侧间距'
    }, {
      name: 'titleFontSize',
      className: modalClass('title'),
      attr: 'fontSize',
      type: 'number',
      parser: parseInt,
      desc: '标题字体大小'
    }, {
      name: 'padding',
      className: modalClass('panel'),
      attr: 'padding',
      type: 'string',
      desc: '整体内边距'
    }, {
      name: 'headerPaddingTop',
      className: exposeClass('modal-card-header'),
      attr: 'paddingTop',
      type: 'number',
      parser: parseInt,
      desc: '头部内边距-Top'
    }, {
      name: 'headerPaddingRight',
      className: exposeClass('modal-card-header'),
      attr: 'paddingRight',
      type: 'number',
      parser: parseInt,
      desc: '头部内边距-Right'
    }, {
      name: 'headerPaddingBottom',
      className: exposeClass('modal-card-header'),
      attr: 'paddingBottom',
      type: 'number',
      parser: parseInt,
      desc: '头部内边距-Bottom'
    }, {
      name: 'headerPaddingLeft',
      className: exposeClass('modal-card-header'),
      attr: 'paddingLeft',
      type: 'number',
      parser: parseInt,
      desc: '头部内边距-Left'
    }, {
      name: 'bodyPaddingTop',
      className: exposeClass('modal-card-body'),
      attr: 'paddingTop',
      type: 'number',
      parser: parseInt,
      desc: '内容内边距-Top'
    }, {
      name: 'bodyPaddingRight',
      className: exposeClass('modal-card-body'),
      attr: 'paddingRight',
      type: 'number',
      parser: parseInt,
      desc: '内容内边距-Right'
    }, {
      name: 'bodyPaddingBottom',
      className: exposeClass('modal-card-body'),
      attr: 'paddingBottom',
      type: 'number',
      parser: parseInt,
      desc: '内容内边距-Bottom'
    }, {
      name: 'bodyPaddingLeft',
      className: exposeClass('modal-card-body'),
      attr: 'paddingLeft',
      type: 'number',
      parser: parseInt,
      desc: '内容内边距-Left'
    }, {
      name: 'iconHeaderPaddingRight',
      className: modalClass('title', 'method-title'),
      attr: 'paddingRight',
      type: 'number',
      parser: parseInt,
      desc: '带有 Icon 的对话框 头部 Right 内边距'
    }, {
      name: 'iconBodyPaddingTop',
      className: exposeClass('modal-icon-body'),
      attr: 'paddingTop',
      type: 'number',
      parser: parseInt,
      desc: '带有 Icon 的对话框内容 Top 内边距'
    }, {
      name: 'iconBodyPaddingRight',
      className: exposeClass('modal-icon-body'),
      attr: 'paddingRight',
      type: 'number',
      parser: parseInt,
      desc: '带有 Icon 的对话框内容 Right 内边距'
    }, {
      name: 'iconBodyPaddingBottom',
      className: exposeClass('modal-icon-body'),
      attr: 'paddingBottom',
      type: 'number',
      parser: parseInt,
      desc: '带有 Icon 的对话框内容 Bottom 内边距'
    }, {
      name: 'iconBodyPaddingLeft',
      className: exposeClass('modal-icon-body'),
      attr: 'paddingLeft',
      type: 'number',
      parser: parseInt,
      desc: '带有 Icon 的对话框内容 Left 内边距'
    }, {
      name: 'footerPadding',
      className: exposeClass('modal-card-footer'),
      attr: 'padding',
      type: 'string',
      desc: '底部内边距'
    }, {
      name: 'borderRadius',
      className: exposeClass('modal-card'),
      attr: 'borderTopLeftRadius',
      type: 'number',
      parser: parseInt,
      desc: '圆角'
    }, {
      name: 'borderWidth',
      className: exposeClass('modal-card'),
      attr: 'borderWidth',
      type: 'number',
      parser: parseInt,
      desc: '边框宽度'
    }, {
      name: 'dividerHeight',
      className: exposeClass('modal-divider'),
      attr: 'height',
      type: 'number',
      parser: parseInt,
      desc: '分割线高度'
    }, {
      name: 'dividerWidth',
      value: '100%',
      attr: 'width',
      type: 'string',
      desc: '分割线宽度'
    }, {
      name: 'borderColor',
      className: exposeClass('modal-card'),
      attr: 'borderColor',
      type: 'color',
      desc: '边框颜色'
    }, {
      name: 'dividerColor',
      className: exposeClass('modal-divider'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '分割线颜色'
    }, {
      name: 'color',
      className: exposeClass('modal-card'),
      attr: 'color',
      type: 'color',
      desc: '内容部分文字颜色'
    }, {
      name: 'titleColor',
      className: modalClass('title'),
      attr: 'color',
      type: 'color',
      desc: '标题文字颜色'
    }, // {
    //   name: 'footerColor',
    //   className: exposeClass('modal-card-footer'),
    //   attr: 'color',
    //   type: 'color',
    //   desc: '底部文字颜色',
    // },
    {
      name: 'headerBg',
      className: exposeClass('modal-card-header'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '头部背景色'
    }, {
      name: 'footerBg',
      className: exposeClass('modal-card-footer'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '底部背景色'
    }, {
      name: 'boxShadow',
      className: exposeClass('modal-card'),
      attr: 'boxShadow',
      type: 'string',
      desc: '阴影'
    }],

    set titleFontFamily(v) {
      cov_1w0wl6gh7m.f[242]++;
      cov_1w0wl6gh7m.s[286]++;
      setBodyProperty({
        '--modal-title-font': v
      }, v);
    },

    set fontSize(v) {
      cov_1w0wl6gh7m.f[243]++;
      cov_1w0wl6gh7m.s[287]++;
      setBodyProperty({
        '--modal-font-size': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set iconSize(v) {
      cov_1w0wl6gh7m.f[244]++;
      cov_1w0wl6gh7m.s[288]++;
      setBodyProperty({
        '--modal-icon-size': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set iconLeft(v) {
      cov_1w0wl6gh7m.f[245]++;
      cov_1w0wl6gh7m.s[289]++;
      setBodyProperty({
        '--modal-icon-left': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set iconTop(v) {
      cov_1w0wl6gh7m.f[246]++;
      cov_1w0wl6gh7m.s[290]++;
      setBodyProperty({
        '--modal-icon-top': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set closeIconColor(v) {
      cov_1w0wl6gh7m.f[247]++;
      cov_1w0wl6gh7m.s[291]++;
      setBodyProperty({
        '--modal-close-icon-color': v
      }, v);
    },

    set closeIconHoverColor(v) {
      cov_1w0wl6gh7m.f[248]++;
      cov_1w0wl6gh7m.s[292]++;
      setBodyProperty({
        '--modal-close-icon-hover-color': v
      }, v);
    },

    set closeIconTopMargin(v) {
      cov_1w0wl6gh7m.f[249]++;
      cov_1w0wl6gh7m.s[293]++;
      setBodyProperty({
        '--modal-close-top-margin': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set closeIconRightMargin(v) {
      cov_1w0wl6gh7m.f[250]++;
      cov_1w0wl6gh7m.s[294]++;
      setBodyProperty({
        '--modal-close-right-margin': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set titleFontSize(v) {
      cov_1w0wl6gh7m.f[251]++;
      cov_1w0wl6gh7m.s[295]++;
      setBodyProperty({
        '--modal-title-font-size': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set titleColor(v) {
      cov_1w0wl6gh7m.f[252]++;
      cov_1w0wl6gh7m.s[296]++;
      setBodyProperty({
        '--modal-title-color': v
      }, v);
    },

    set padding(v) {
      cov_1w0wl6gh7m.f[253]++;
      cov_1w0wl6gh7m.s[297]++;
      setBodyProperty({
        '--modal-panel-padding': v
      }, v);
    },

    set headerPaddingTop(v) {
      cov_1w0wl6gh7m.f[254]++;
      cov_1w0wl6gh7m.s[298]++;
      setBodyProperty({
        '--modal-header-padding-top': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set headerPaddingRight(v) {
      cov_1w0wl6gh7m.f[255]++;
      cov_1w0wl6gh7m.s[299]++;
      setBodyProperty({
        '--modal-header-padding-right': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set iconHeaderPaddingRight(v) {
      cov_1w0wl6gh7m.f[256]++;
      cov_1w0wl6gh7m.s[300]++;
      setBodyProperty({
        '--modal-method-header-padding-right': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set headerPaddingBottom(v) {
      cov_1w0wl6gh7m.f[257]++;
      cov_1w0wl6gh7m.s[301]++;
      setBodyProperty({
        '--modal-header-padding-bottom': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set headerPaddingLeft(v) {
      cov_1w0wl6gh7m.f[258]++;
      cov_1w0wl6gh7m.s[302]++;
      setBodyProperty({
        '--modal-header-padding-left': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set bodyPaddingTop(v) {
      cov_1w0wl6gh7m.f[259]++;
      cov_1w0wl6gh7m.s[303]++;
      setBodyProperty({
        '--modal-body-padding-top': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set bodyPaddingRight(v) {
      cov_1w0wl6gh7m.f[260]++;
      cov_1w0wl6gh7m.s[304]++;
      setBodyProperty({
        '--modal-body-padding-right': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set bodyPaddingBottom(v) {
      cov_1w0wl6gh7m.f[261]++;
      cov_1w0wl6gh7m.s[305]++;
      setBodyProperty({
        '--modal-body-padding-bottom': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set bodyPaddingLeft(v) {
      cov_1w0wl6gh7m.f[262]++;
      cov_1w0wl6gh7m.s[306]++;
      setBodyProperty({
        '--modal-body-padding-left': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set iconBodyPaddingTop(v) {
      cov_1w0wl6gh7m.f[263]++;
      cov_1w0wl6gh7m.s[307]++;
      setBodyProperty({
        '--modal-icon-body-padding-top': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set iconBodyPaddingRight(v) {
      cov_1w0wl6gh7m.f[264]++;
      cov_1w0wl6gh7m.s[308]++;
      setBodyProperty({
        '--modal-icon-body-padding-right': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set iconBodyPaddingBottom(v) {
      cov_1w0wl6gh7m.f[265]++;
      cov_1w0wl6gh7m.s[309]++;
      setBodyProperty({
        '--modal-icon-body-padding-bottom': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set iconBodyPaddingLeft(v) {
      cov_1w0wl6gh7m.f[266]++;
      cov_1w0wl6gh7m.s[310]++;
      setBodyProperty({
        '--modal-icon-body-padding-left': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set footerPadding(v) {
      cov_1w0wl6gh7m.f[267]++;
      cov_1w0wl6gh7m.s[311]++;
      setBodyProperty({
        '--modal-footer-padding': v
      }, v);
    },

    set borderRadius(v) {
      cov_1w0wl6gh7m.f[268]++;
      cov_1w0wl6gh7m.s[312]++;
      setBodyProperty({
        '--modal-border-radius': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set borderWidth(v) {
      cov_1w0wl6gh7m.f[269]++;
      cov_1w0wl6gh7m.s[313]++;
      setBodyProperty({
        '--modal-border-width': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set dividerHeight(v) {
      cov_1w0wl6gh7m.f[270]++;
      cov_1w0wl6gh7m.s[314]++;
      setBodyProperty({
        '--modal-divider-height': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set dividerWidth(v) {
      cov_1w0wl6gh7m.f[271]++;
      cov_1w0wl6gh7m.s[315]++;
      setBodyProperty({
        '--modal-divider-width': v
      }, v);
    },

    set borderColor(v) {
      cov_1w0wl6gh7m.f[272]++;
      cov_1w0wl6gh7m.s[316]++;
      setBodyProperty({
        '--modal-border-color': v
      }, v);
    },

    set dividerColor(v) {
      cov_1w0wl6gh7m.f[273]++;
      cov_1w0wl6gh7m.s[317]++;
      setBodyProperty({
        '--modal-divider-color': v
      }, v);
    },

    set color(v) {
      cov_1w0wl6gh7m.f[274]++;
      cov_1w0wl6gh7m.s[318]++;
      setBodyProperty({
        '--modal-color': v
      }, v);
    },

    set headerBg(v) {
      cov_1w0wl6gh7m.f[275]++;
      cov_1w0wl6gh7m.s[319]++;
      setBodyProperty({
        '--modal-header-bg': v
      }, v);
    },

    set footerBg(v) {
      cov_1w0wl6gh7m.f[276]++;
      cov_1w0wl6gh7m.s[320]++;
      setBodyProperty({
        '--modal-footer-bg': v
      }, v);
    },

    set boxShadow(v) {
      cov_1w0wl6gh7m.f[277]++;
      cov_1w0wl6gh7m.s[321]++;
      setBodyProperty({
        '--modal-box-shadow': v
      }, v);
    }

  },
  popover: {
    info: {
      title: 'Popover 气泡',
      name: 'popover',
      path: 'Popover'
    },
    conf: [{
      name: 'borderColor',
      className: popoverClass('_'),
      attr: 'borderColor',
      type: 'color',
      desc: '边框颜色'
    }, {
      name: 'borderWidth',
      className: popoverClass('_'),
      attr: 'borderWidth',
      type: 'number',
      parser: parseInt,
      desc: '边框宽度'
    }, {
      name: 'boxShadow',
      className: popoverClass('_'),
      attr: 'boxShadow',
      type: 'string',
      desc: '阴影'
    }, {
      name: 'borderRadius',
      className: popoverClass('_'),
      attr: 'borderRadius',
      type: 'number',
      parser: parseInt,
      desc: '圆角'
    }, {
      name: 'textMaxWidth',
      className: popoverClass('text'),
      attr: 'maxWidth',
      type: 'string',
      desc: '纯文字时的最大宽度'
    }, {
      name: 'fontSize',
      className: popoverClass('_'),
      attr: 'fontSize',
      type: 'number',
      parser: parseInt,
      desc: '字体大小'
    }],

    set borderColor(v) {
      cov_1w0wl6gh7m.f[278]++;
      cov_1w0wl6gh7m.s[322]++;
      setBodyProperty({
        '--popover-border-color': v
      }, v);
    },

    set borderWidth(v) {
      cov_1w0wl6gh7m.f[279]++;
      cov_1w0wl6gh7m.s[323]++;
      setBodyProperty({
        '--popover-border-width': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set boxShadow(v) {
      cov_1w0wl6gh7m.f[280]++;
      cov_1w0wl6gh7m.s[324]++;
      setBodyProperty({
        '--popover-box-shadow': v
      }, v);
    },

    set borderRadius(v) {
      cov_1w0wl6gh7m.f[281]++;
      cov_1w0wl6gh7m.s[325]++;
      setBodyProperty({
        '--popover-border-radius': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set textMaxWidth(v) {
      cov_1w0wl6gh7m.f[282]++;
      cov_1w0wl6gh7m.s[326]++;
      setBodyProperty({
        '--popover-text-max-width': v
      }, v);
    },

    set fontSize(v) {
      cov_1w0wl6gh7m.f[283]++;
      cov_1w0wl6gh7m.s[327]++;
      setBodyProperty({
        '--popover-text-font-size': "".concat(parseInt(v, 10), "px")
      }, v);
    }

  },
  tree: {
    info: {
      title: 'Tree 树型选择',
      name: 'tree',
      path: 'Tree'
    },
    conf: [{
      name: 'treeIndicatorColor',
      className: exposeClass('tree-default-icon'),
      attr: 'borderLeftColor',
      type: 'color',
      desc: '三角/+-颜色'
    }, {
      name: 'levelIndent',
      className: exposeClass('tree-indent'),
      attr: 'width',
      type: 'number',
      parser: parseInt,
      min: -100,
      desc: '项目缩进'
    }, {
      name: 'nodeMarginBottom',
      className: exposeClass('tree-node'),
      attr: 'marginBottom',
      type: 'number',
      parser: parseInt,
      desc: '项目垂直间隔'
    }, {
      name: 'lineColor',
      className: exposeClass('tree-line'),
      attr: 'color',
      type: 'color',
      desc: '连线颜色'
    }],

    set levelIndent(v) {
      cov_1w0wl6gh7m.f[284]++;
      cov_1w0wl6gh7m.s[328]++;
      setBodyProperty({
        '--tree-level-indent': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set nodeMarginBottom(v) {
      cov_1w0wl6gh7m.f[285]++;
      cov_1w0wl6gh7m.s[329]++;
      setBodyProperty({
        '--tree-node-margin-bottom': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set treeIndicatorColor(v) {
      cov_1w0wl6gh7m.f[286]++;
      cov_1w0wl6gh7m.s[330]++;
      setBodyProperty({
        '--tree-indicator-color': v
      }, v);
    },

    set lineColor(v) {
      cov_1w0wl6gh7m.f[287]++;
      cov_1w0wl6gh7m.s[331]++;
      setBodyProperty({
        '--tree-line-color': v
      }, v);
    }

  },
  "switch": {
    info: {
      title: 'Switch 开关选择器',
      name: 'switch',
      path: 'Switch'
    },
    conf: [{
      name: 'uncheckBg',
      className: checkinputClass('switch'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '关闭状态背景色'
    }, {
      name: 'type',
      className: exposeClass('switch-type'),
      attr: 'animationName',
      type: ['outter', 'inner'],
      desc: '类型'
    }],

    set type(v) {
      cov_1w0wl6gh7m.f[288]++;
      var o = (cov_1w0wl6gh7m.s[332]++, {});
      cov_1w0wl6gh7m.s[333]++;

      if (v === 'outter') {
        cov_1w0wl6gh7m.b[19][0]++;
        cov_1w0wl6gh7m.s[334]++;
        o['--switch-indicator-padding-horizontal'] = "0px";
        cov_1w0wl6gh7m.s[335]++;
        o['--switch-indicator-padding-horizontal-negative'] = "0px";
        cov_1w0wl6gh7m.s[336]++;
        o['--switch-indicator-size'] = "24px";
        cov_1w0wl6gh7m.s[337]++;
        o['--switch-bg-height'] = "16px";
        cov_1w0wl6gh7m.s[338]++;
        o['--switch-indicator-top'] = "-4px";
        cov_1w0wl6gh7m.s[339]++;
        o['--switch-small-indicator-size'] = "16px";
        cov_1w0wl6gh7m.s[340]++;
        o['--switch-small-bg-height'] = "10px";
        cov_1w0wl6gh7m.s[341]++;
        o['--switch-large-bg-height'] = "22px";
        cov_1w0wl6gh7m.s[342]++;
        o['--switch-large-indicator-top'] = "-5px";
        cov_1w0wl6gh7m.s[343]++;
        o['--switch-small-indicator-top'] = "-3px";
        cov_1w0wl6gh7m.s[344]++;
        o['--switch-large-indicator-size'] = "32px";
      } else {
        cov_1w0wl6gh7m.b[19][1]++;
        cov_1w0wl6gh7m.s[345]++;

        if (v === 'inner') {
          cov_1w0wl6gh7m.b[20][0]++;
          cov_1w0wl6gh7m.s[346]++;
          o['--switch-indicator-checked-bg'] = "#fff";
          cov_1w0wl6gh7m.s[347]++;
          o['--switch-indicator-padding-horizontal'] = "2px";
          cov_1w0wl6gh7m.s[348]++;
          o['--switch-indicator-padding-horizontal-negative'] = "-2px";
          cov_1w0wl6gh7m.s[349]++;
          o['--switch-indicator-size'] = "18px";
          cov_1w0wl6gh7m.s[350]++;
          o['--switch-bg-height'] = "22px";
          cov_1w0wl6gh7m.s[351]++;
          o['--switch-indicator-top'] = "2px";
          cov_1w0wl6gh7m.s[352]++;
          o['--switch-small-indicator-size'] = "12px";
          cov_1w0wl6gh7m.s[353]++;
          o['--switch-small-bg-height'] = "16px";
          cov_1w0wl6gh7m.s[354]++;
          o['--switch-large-bg-height'] = "28px";
          cov_1w0wl6gh7m.s[355]++;
          o['--switch-large-indicator-top'] = "2px";
          cov_1w0wl6gh7m.s[356]++;
          o['--switch-small-indicator-top'] = "2px";
          cov_1w0wl6gh7m.s[357]++;
          o['--switch-large-indicator-size'] = "24px";
        } else {
          cov_1w0wl6gh7m.b[20][1]++;
        }
      }

      cov_1w0wl6gh7m.s[358]++;
      setBodyProperty(o, v);
    },

    set uncheckBg(v) {
      cov_1w0wl6gh7m.f[289]++;
      cov_1w0wl6gh7m.s[359]++;
      setBodyProperty({
        '--switch-unchecked-bg': v
      }, v);
    }

  },
  tabs: {
    info: {
      title: 'Tabs 标签',
      name: 'tabs',
      path: 'Tabs'
    },
    conf: [{
      name: 'tabSpacing',
      className: exposeClass('tabs'),
      attr: 'marginLeft',
      type: 'number',
      min: -10,
      parser: parseInt,
      desc: 'tab间隔'
    }, {
      name: 'tabPaddingX',
      className: exposeClass('tabs-tab'),
      attr: 'paddingLeft',
      type: 'number',
      min: 0,
      parser: parseInt,
      desc: 'tab水平内边距'
    }, {
      name: 'tabPaddingY',
      className: exposeClass('tabs-tab'),
      attr: 'paddingTop',
      type: 'number',
      min: 0,
      parser: parseInt,
      desc: 'tab垂直内边距'
    }, {
      name: 'tabFontSize',
      className: exposeClass('tabs-tab'),
      attr: 'fontSize',
      type: 'number',
      min: 0,
      parser: parseInt,
      desc: 'tab字体大小'
    }, {
      name: 'tabBackground',
      className: exposeClass('tabs-tab'),
      attr: 'backgroundColor',
      type: 'color',
      desc: 'tab背景色'
    }, {
      name: 'tabActiveBackground',
      className: exposeClass('tabs-tab-active'),
      attr: 'backgroundColor',
      type: 'color',
      desc: 'tab选中背景色'
    }, {
      name: 'tabBorderColor',
      className: exposeClass('tabs-tab'),
      attr: 'borderColor',
      type: 'color',
      desc: 'tab边框颜色'
    }, {
      name: 'tabActiveBorderColor',
      className: exposeClass('tabs-tab-active'),
      attr: 'borderColor',
      type: 'color',
      desc: 'tab选中边框颜色'
    }, {
      name: 'tabColor',
      className: exposeClass('tabs-tab'),
      attr: 'color',
      type: 'color',
      desc: 'tab文字颜色'
    }, {
      name: 'tabActiveColor',
      className: exposeClass('tabs-tab-active'),
      attr: 'color',
      type: 'color',
      desc: 'tab选中文字颜色(不含线条样式)'
    }, {
      name: 'tabLineActiveColor',
      className: exposeClass('tabs-line-active'),
      attr: 'color',
      type: 'color',
      desc: 'tab线条样式选中文字颜色'
    }],

    set tabSpacing(v) {
      cov_1w0wl6gh7m.f[290]++;
      cov_1w0wl6gh7m.s[360]++;
      setBodyProperty({
        '--tabs-tab-spacing': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set tabPaddingX(v) {
      cov_1w0wl6gh7m.f[291]++;
      cov_1w0wl6gh7m.s[361]++;
      setBodyProperty({
        '--tabs-tab-padding-x': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set tabPaddingY(v) {
      cov_1w0wl6gh7m.f[292]++;
      cov_1w0wl6gh7m.s[362]++;
      setBodyProperty({
        '--tabs-tab-padding-y': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set tabFontSize(v) {
      cov_1w0wl6gh7m.f[293]++;
      cov_1w0wl6gh7m.s[363]++;
      setBodyProperty({
        '--tabs-tab-font-size': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set tabBackground(v) {
      cov_1w0wl6gh7m.f[294]++;
      cov_1w0wl6gh7m.s[364]++;
      setBodyProperty({
        '--tabs-tab-background': v
      }, v);
    },

    set tabActiveBackground(v) {
      cov_1w0wl6gh7m.f[295]++;
      cov_1w0wl6gh7m.s[365]++;
      setBodyProperty({
        '--tabs-tab-active-background': v
      }, v);
    },

    set tabBorderColor(v) {
      cov_1w0wl6gh7m.f[296]++;
      cov_1w0wl6gh7m.s[366]++;
      setBodyProperty({
        '--tabs-tab-border-color': v
      }, v);
    },

    set tabActiveBorderColor(v) {
      cov_1w0wl6gh7m.f[297]++;
      cov_1w0wl6gh7m.s[367]++;
      setBodyProperty({
        '--tabs-tab-active-border-color': v
      }, v);
    },

    set tabColor(v) {
      cov_1w0wl6gh7m.f[298]++;
      cov_1w0wl6gh7m.s[368]++;
      setBodyProperty({
        '--tabs-tab-color': v
      }, v);
    },

    set tabActiveColor(v) {
      cov_1w0wl6gh7m.f[299]++;
      cov_1w0wl6gh7m.s[369]++;
      setBodyProperty({
        '--tabs-tab-active-color': v
      }, v);
    },

    set tabLineActiveColor(v) {
      cov_1w0wl6gh7m.f[300]++;
      cov_1w0wl6gh7m.s[370]++;
      setBodyProperty({
        '--tabs-line-active-color': v
      }, v);
    }

  },
  cascader: {
    info: {
      title: 'Cascader 级联选择器',
      name: 'cascader',
      path: 'Cascader'
    },
    conf: [{
      name: 'activeBgc',
      className: exposeClass('cascader-active'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '选中背景颜色'
    }, {
      name: 'activeColor',
      className: exposeClass('cascader-active'),
      attr: 'color',
      type: 'color',
      desc: '选中字体颜色'
    }],

    set activeBgc(v) {
      cov_1w0wl6gh7m.f[301]++;
      cov_1w0wl6gh7m.s[371]++;
      setBodyProperty({
        '--cascader-active-background-color': v
      }, v);
    },

    set activeColor(v) {
      cov_1w0wl6gh7m.f[302]++;
      cov_1w0wl6gh7m.s[372]++;
      setBodyProperty({
        '--cascader-active-color': v
      }, v);
    }

  },
  list: {
    info: {
      title: 'List 列表',
      name: 'list',
      path: 'List'
    },
    conf: [{
      name: 'itemBottomBorderWidth',
      className: exposeClass('list-item'),
      attr: 'width',
      type: 'number',
      parser: parseInt,
      desc: '分割线粗细'
    }, {
      name: 'itemHoverBgc',
      className: exposeClass('list-item'),
      attr: 'backgroundColor',
      type: 'color',
      desc: '行hover时背景颜色'
    }],

    set itemBottomBorderWidth(v) {
      cov_1w0wl6gh7m.f[303]++;
      cov_1w0wl6gh7m.s[373]++;
      setBodyProperty({
        '--list-item-bottom-border-width': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set itemHoverBgc(v) {
      cov_1w0wl6gh7m.f[304]++;
      cov_1w0wl6gh7m.s[374]++;
      setBodyProperty({
        '--list-item-hover-bgc': v
      }, v);
    }

  },
  progress: {
    info: {
      title: 'Progress',
      name: 'progress',
      path: 'Progress'
    },
    conf: [{
      name: 'progressBgc',
      className: exposeClass('progress'),
      attr: 'backgroundColor',
      type: 'color',
      desc: 'Progress默认背景颜色'
    }],

    set progressBgc(v) {
      cov_1w0wl6gh7m.f[305]++;
      cov_1w0wl6gh7m.s[375]++;
      setBodyProperty({
        '--progress-bgc': v
      }, v);
    }

  },
  common: {
    info: {
      title: 'Common 公共',
      name: 'common',
      path: 'Button'
    },
    conf: [{
      name: 'fontSize',
      className: exposeClass('common-base'),
      attr: 'fontSize',
      parser: parseInt,
      type: 'number',
      desc: '字体大小'
    }, {
      name: 'fontFamily',
      className: buttonClass('_'),
      attr: 'fontFamily',
      type: 'string',
      desc: '字体'
    }, {
      name: 'lineHeight',
      value: 1.428571429,
      type: 'string',
      desc: '行高'
    }, {
      name: 'contentBlockPadding',
      className: '',
      attr: 'padding',
      type: 'string',
      desc: '区块内边距'
    }, {
      name: 'contentTextPadding',
      className: popoverClass('text'),
      attr: 'padding',
      type: 'string',
      desc: '文字内边距'
    }, {
      name: 'spinDefaultName',
      className: exposeClass('common-spin-default'),
      parser: function parser(d) {
        cov_1w0wl6gh7m.f[306]++;
        cov_1w0wl6gh7m.s[376]++;
        return d === 'none' ? (cov_1w0wl6gh7m.b[21][0]++, 'default') : (cov_1w0wl6gh7m.b[21][1]++, d);
      },
      attr: 'animationName',
      type: ['default', 'chasing-dots', 'cube-grid', 'double-bounce', 'fading-circle', 'four-dots', 'plane', 'pulse', 'ring', 'scale-circle', 'three-bounce', 'wave'],
      desc: '默认加载中样式'
    }, {
      name: 'caret',
      className: exposeClass('common-caret'),
      attr: 'animationName',
      type: ['line', 'fill'],
      desc: '下拉箭头风格'
    }, {
      name: 'inputDelay',
      className: exposeClass('common-input-delay'),
      attr: 'width',
      type: 'number',
      parser: parseInt,
      min: 0,
      max: 2000,
      desc: '输入延迟，Input, Textarea, EditableArea'
    }, {
      name: 'inputTrim',
      className: exposeClass('common-input-trim'),
      attr: 'opacity',
      type: 'number',
      parser: parseInt,
      min: 0,
      max: 1,
      desc: '输入过滤两侧空格，Input, Textarea, EditableArea work. 0 or 1'
    }],

    set fontSize(v) {
      cov_1w0wl6gh7m.f[307]++;
      var base = (cov_1w0wl6gh7m.s[377]++, parseInt(v, 10));
      cov_1w0wl6gh7m.s[378]++;
      setBodyProperty({
        '--font-size-base': "".concat(base, "px"),
        '--font-size-base-26': "".concat(Math.floor(base * 2.6), "px"),
        '--font-size-base-215': "".concat(Math.floor(base * 2.15), "px"),
        '--font-size-base-17': "".concat(Math.floor(base * 1.7), "px"),
        '--font-size-base-125': "".concat(Math.floor(base * 1.25), "px"),
        '--font-size-base-085': "".concat(Math.floor(base * 0.85), "px"),
        '--font-size-base-15': "".concat(Math.floor(base * 1.5), "px"),
        '--font-size-base-45': "".concat(Math.floor(base * 4.5), "px"),
        '--font-size-large': "".concat(Math.ceil(base * 1.25), "px"),
        '--font-size-small': "".concat(Math.ceil(base * 0.85), "px"),
        '--font-size-large-medium': "".concat(base + 2, "px")
      }, v);
    },

    set fontFamily(v) {
      cov_1w0wl6gh7m.f[308]++;
      cov_1w0wl6gh7m.s[379]++;
      setBodyProperty({
        '--common-body-font-family': v
      }, v);
    },

    set lineHeight(v) {
      cov_1w0wl6gh7m.f[309]++;
      cov_1w0wl6gh7m.s[380]++;
      setBodyProperty({
        '--common-line-height': v
      }, v);
    },

    set contentBlockPadding(v) {
      cov_1w0wl6gh7m.f[310]++;
      cov_1w0wl6gh7m.s[381]++;
      setBodyProperty({
        '--common-content-block-padding': v
      }, v);
    },

    set contentTextPadding(v) {
      cov_1w0wl6gh7m.f[311]++;
      cov_1w0wl6gh7m.s[382]++;
      setBodyProperty({
        '--common-content-text-padding': v
      }, v);
    },

    set caret(v) {
      cov_1w0wl6gh7m.f[312]++;
      cov_1w0wl6gh7m.s[383]++;
      configSet('caret', v);
      cov_1w0wl6gh7m.s[384]++;
      setBodyProperty({
        '--common-caret-style': v
      }, v);
    },

    set inputDelay(v) {
      cov_1w0wl6gh7m.f[313]++;
      cov_1w0wl6gh7m.s[385]++;
      configSet('delay', parseInt(v, 10));
      cov_1w0wl6gh7m.s[386]++;
      setBodyProperty({
        '--common-input-delay': "".concat(parseInt(v, 10), "px")
      }, v);
    },

    set inputTrim(v) {
      cov_1w0wl6gh7m.f[314]++;
      cov_1w0wl6gh7m.s[387]++;
      configSet('trim', !!v);
      cov_1w0wl6gh7m.s[388]++;
      setBodyProperty({
        '--common-input-trim': parseInt(v, 10)
      }, v);
    },

    set spinDefaultName(v) {
      cov_1w0wl6gh7m.f[315]++;
      cov_1w0wl6gh7m.s[389]++;
      configSet('spin', v);
      cov_1w0wl6gh7m.s[390]++;
      setBodyProperty({
        '--common-spin-default-name': v
      }, v);
    }

  }
});
export default injects;